/* Pix on Puzzles - puzzle designer (photo upload, collage layouts, text)
   Works with sections/custom-product-product-hero.liquid: the hero's own
   Upload / Change Photo / Edit Photo buttons open this designer, and the hero
   reads the finished design from the markup in sections/pix-photo-uploader.liquid. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('pixup-config');
  if (!cfgEl || window.__pixup) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var host = document.querySelector('.uploadkit-injected[data-pixup]');
  var form = document.getElementById('pix-pform');
  if (!host || !form || !CFG.endpoint) return;
  window.__pixup = true;

  var ENDPOINT = CFG.endpoint.replace(/\/+$/, '');
  var LINE_COLOR = '#000000', LINE_ALPHA = 0.4;      /* puzzle lines: colour and strength (0 = invisible, 1 = solid black) */
  var MAX_FILE = 40 * 1024 * 1024, MAX_AREA = 16000000, MAX_LONG = 7200, WORK_LONG = 1280, SAT = 1.08, MAX_PHOTOS = 10;
  var OK_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  var FONTS = [
    { name: 'Bold', css: '800 %px "Bricolage Grotesque", "Figtree", sans-serif' },
    { name: 'Clean', css: '700 %px "Figtree", system-ui, sans-serif' },
    { name: 'Classic', css: '700 %px "Playfair Display", Georgia, serif' },
    { name: 'Script', css: '700 %px "Caveat", "Segoe Script", cursive' }
  ];
  var COLORS = ['#FFFFFF', '#22314A', '#000000', '#FFC845', '#D94F3D', '#2D5DA8', '#1F7A4D', '#E86FA2'];
  var T = 1 / 3;
  var LAYOUTS = [
    { id: '1', c: [[0, 0, 1, 1]] },
    { id: '2a', c: [[0, 0, .5, 1], [.5, 0, .5, 1]] },
    { id: '2b', c: [[0, 0, 1, .5], [0, .5, 1, .5]] },
    { id: '2c', c: [[0, 0, .62, 1], [.62, 0, .38, 1]] },
    { id: '3a', c: [[0, 0, .5, 1], [.5, 0, .5, .5], [.5, .5, .5, .5]] },
    { id: '3b', c: [[0, 0, T, 1], [T, 0, T, 1], [2 * T, 0, T, 1]] },
    { id: '3c', c: [[0, 0, 1, .6], [0, .6, .5, .4], [.5, .6, .5, .4]] },
    { id: '4a', c: [[0, 0, .5, .5], [.5, 0, .5, .5], [0, .5, .5, .5], [.5, .5, .5, .5]] },
    { id: '4b', c: [[0, 0, .6, 1], [.6, 0, .4, T], [.6, T, .4, T], [.6, 2 * T, .4, T]] },
    { id: '5a', c: [[0, 0, .5, .5], [.5, 0, .5, .5], [0, .5, T, .5], [T, .5, T, .5], [2 * T, .5, T, .5]] },
    { id: '6a', c: [[0, 0, T, .5], [T, 0, T, .5], [2 * T, 0, T, .5], [0, .5, T, .5], [T, .5, T, .5], [2 * T, .5, T, .5]] }
  ];
  /* 7 to 10 photos: even rows */
  [[3, 4], [4, 4], [3, 3, 3], [5, 5]].forEach(function (rows) {
    var c = [], h = 1 / rows.length;
    rows.forEach(function (n, r) { for (var i = 0; i < n; i++) c.push([i / n, r * h, 1 / n, h]); });
    LAYOUTS.push({ id: String(c.length), c: c });
  });
  /* more collage grids (after the ones above, so a growing collage still picks those first) */
  LAYOUTS.push(
    { id: '3d', c: [[0, 0, .25, 1], [.25, 0, .5, 1], [.75, 0, .25, 1]] },
    { id: '3e', c: [[0, 0, .5, .55], [.5, 0, .5, .55], [0, .55, 1, .45]] },
    { id: '4c', c: [[0, 0, 1, .64], [0, .64, T, .36], [T, .64, T, .36], [2 * T, .64, T, .36]] },
    { id: '4d', c: [[0, 0, .25, 1], [.25, 0, .25, 1], [.5, 0, .25, 1], [.75, 0, .25, 1]] },
    { id: '4e', c: [[0, 0, .6, .5], [.6, 0, .4, .5], [0, .5, .4, .5], [.4, .5, .6, .5]] },
    { id: '5b', c: [[0, 0, .25, .5], [0, .5, .25, .5], [.25, 0, .5, 1], [.75, 0, .25, .5], [.75, .5, .25, .5]] },
    { id: '5c', c: [[0, 0, .5, 1], [.5, 0, .25, .5], [.75, 0, .25, .5], [.5, .5, .25, .5], [.75, .5, .25, .5]] },
    { id: '5d', c: [[0, 0, 1, .62], [0, .62, .25, .38], [.25, .62, .25, .38], [.5, .62, .25, .38], [.75, .62, .25, .38]] },
    { id: '6b', c: [[0, 0, 2 * T, 2 * T], [2 * T, 0, T, T], [2 * T, T, T, T], [0, 2 * T, T, T], [T, 2 * T, T, T], [2 * T, 2 * T, T, T]] },
    { id: '6c', c: [[0, 0, .4, .5], [.4, 0, .3, .5], [.7, 0, .3, .5], [0, .5, .3, .5], [.3, .5, .3, .5], [.6, .5, .4, .5]] },
    { id: '7b', c: [[0, 0, .25, T], [0, T, .25, T], [0, 2 * T, .25, T], [.25, 0, .5, 1], [.75, 0, .25, T], [.75, T, .25, T], [.75, 2 * T, .25, T]] },
    { id: '9b', c: [[0, 0, .5, 2 * T], [.5, 0, .25, T], [.75, 0, .25, T], [.5, T, .25, T], [.75, T, .25, T], [0, 2 * T, .25, T], [.25, 2 * T, .25, T], [.5, 2 * T, .25, T], [.75, 2 * T, .25, T]] }
  );
  function firstLayout(n) { n = clamp(n, 2, MAX_PHOTOS); return LAYOUTS.filter(function (l) { return l.c.length === n; })[0]; }
  function plainFor(n) { return n <= 1 ? LAYOUTS[0] : firstLayout(n); }

  /* ---------- themed designs ----------
     A design has a landscape ("wide") and/or portrait ("tall") version. Each version is drawn in its own
     space (width ar, height 1) that is scaled to cover the puzzle, so artwork, photo windows and text stay
     lined up on every puzzle size. Positions are fractions of that space: x and w of its width, y and h of
     its height. Layers, bottom to top: colour, background art, photo windows, decoration art, text.
     Designs come from the pix_design metaobjects (Content > Metaobjects > Pix puzzle designs). */
  function slug(s) { return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function fontIdx(f) {
    if (typeof f === 'number') return clamp(f, 0, FONTS.length - 1);
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].name.toLowerCase() === String(f || '').toLowerCase()) return i;
    return 0;
  }
  function artList(v) {
    if (!v) return [];
    return (Array.isArray(v) ? v : [v]).map(function (a) { return typeof a === 'string' ? { img: a } : a; }).filter(function (a) { return a && a.img; });
  }
  function normGeo(g, bg, fg) {
    if (!g || !g.slots || !g.slots.length) return null;
    return {
      ar: +g.ar > 0 ? +g.ar : 1.4, color: g.color || '#FFFFFF',
      bg: artList(g.bg).concat(artList(bg)), fg: artList(g.fg).concat(artList(fg)),
      slots: g.slots.slice(0, MAX_PHOTOS).map(function (s) {
        return { x: +s.x || 0, y: +s.y || 0, w: +s.w || 0.3, h: +s.h || 0.3, rot: +s.rot || 0, shape: s.shape || 'rect',
                 rad: s.rad == null ? 0.05 : +s.rad, border: +s.border || 0, fb: +s.fb || 0, bc: s.bc || '#FFFFFF', shadow: !!s.shadow };
      }),
      texts: (g.texts || []).filter(function (t) { return t && t.text; }).map(function (t) {
        return { text: String(t.text), x: t.x == null ? 0.5 : +t.x, y: t.y == null ? 0.85 : +t.y, size: +t.size || 0.08, rot: +t.rot || 0, font: fontIdx(t.font), color: t.color || '#FFFFFF' };
      })
    };
  }
  var DESIGNS = [], THEMES = [];
  function addDesign(d) {
    if (!d || !d.id) return;
    var L = d.layout || d, wide = normGeo(L.wide, d.bg, d.fg), tall = normGeo(L.tall, d.bgTall, d.fgTall);
    if (wide && tall && wide.slots.length !== tall.slots.length) tall = null;
    if (!wide && !tall) { log('design skipped (no photo windows):', d.id); return; }
    var names = (Array.isArray(d.themes) ? d.themes : String(d.themes || '').split(',')).map(function (s) { return String(s).trim(); }).filter(Boolean);
    names.forEach(function (n) { if (!THEMES.some(function (t) { return t.slug === slug(n); })) THEMES.push({ slug: slug(n), name: n }); });
    var id = 'd:' + slug(d.id);
    DESIGNS = DESIGNS.filter(function (x) { return x.id !== id; });
    DESIGNS.push({ tpl: true, id: id, key: slug(d.id), name: String(d.name || d.id), themes: names.map(slug), n: (wide || tall).slots.length,
                   wide: wide, tall: tall, sort: +d.sort || 0,
                   ph: urlList(d.ph), phTall: urlList(d.phTall) });
  }
  function urlList(v) { return (Array.isArray(v) ? v : []).filter(function (u) { return typeof u === 'string' && u; }); }
  function slotCount(l) { return l.tpl ? l.n : l.c.length; }
  function geoFor(l, tall) { return l && l.tpl ? (tall ? l.tall : l.wide) : null; }
  /* a design made in only one orientation (its Layout has just "wide" or just "tall") stays in that orientation */
  function oneOrient(l) { return !!(l && l.tpl && !(l.wide && l.tall)); }
  function onlyName(l) { return l.wide ? 'landscape' : 'portrait'; }
  function geoOf(D) { var l = D.layout; return l.tpl ? (geoFor(l, D.tall) || l.wide || l.tall) : null; }
  function layoutById(id) {
    var all = LAYOUTS.concat(DESIGNS);
    for (var i = 0; i < all.length; i++) if (all[i].id === id) return all[i];
    return null;
  }
  function artMap(geo, W, H) { var s = Math.max(W / geo.ar, H); return { s: s, w: geo.ar * s, x0: (W - geo.ar * s) / 2, y0: (H - s) / 2 }; }

  /* artwork images: a light copy for the screen, the full one for the print file */
  var artImgs = {}, artTimer = 0, szTimer = 0;
  function artImg(u) {
    if (!u) return null;
    var e = artImgs[u];
    if (!e) {
      e = artImgs[u] = { img: new Image(), ok: false };
      e.p = new Promise(function (res) {
        e.img.crossOrigin = 'anonymous';
        e.img.onload = function () { e.ok = true; res(e); artLoaded(); };
        e.img.onerror = function () { log('artwork did not load:', u); res(e); };
        e.img.src = u;
      });
    }
    return e;
  }
  function artLoaded() {
    if (artTimer) return;
    artTimer = setTimeout(function () { artTimer = 0; if (modal && !modal.hidden) { if (step === 2) { tinDirty = true; tinChanged(); return; } draw(); if (pickOn) renderThumbs(); else renderPeek(); if (sizesOn) sizeThumbs(); } }, 40);
  }
  function artReady(D, hi) {
    var geo = geoOf(D), ps = [];
    if (geo) geo.bg.concat(geo.fg).forEach(function (a) { if (a.img) ps.push(artImg(hi ? (a.imgL || a.img) : a.img).p); });
    return Promise.all(ps).then(function (list) { return list.every(function (e) { return e.ok; }); });
  }

  function heartPath(g, w, h) {
    g.moveTo(0, -h * 0.22);
    g.bezierCurveTo(-w * 0.08, -h * 0.47, -w * 0.5, -h * 0.55, -w * 0.5, -h * 0.17);
    g.bezierCurveTo(-w * 0.5, h * 0.12, -w * 0.18, h * 0.3, 0, h * 0.5);
    g.bezierCurveTo(w * 0.18, h * 0.3, w * 0.5, h * 0.12, w * 0.5, -h * 0.17);
    g.bezierCurveTo(w * 0.5, -h * 0.55, w * 0.08, -h * 0.47, 0, -h * 0.22);
    g.closePath();
  }
  (Array.isArray(CFG.designs) ? CFG.designs : []).forEach(function (d) { try { addDesign(d); } catch (e) { log('design skipped:', d && d.id, e.message); } });
  /* a Pix puzzle design with "Collage" (or "Collages") among its themes is listed with the collages
     in "Choose your template", instead of under a theme of its own */
  DESIGNS.forEach(function (l) { if (l.themes.some(function (t) { return t === 'collage' || t === 'collages'; })) l.coll = true; });
  /* plain templates (full photo, collages) get their own sample photos from CFG.layoutPhotos
     (Content > Metaobjects > Pix template photos), separately for the landscape and portrait cards */
  (function () {
    var LP = CFG.layoutPhotos && typeof CFG.layoutPhotos === 'object' ? CFG.layoutPhotos : {};
    LAYOUTS.forEach(function (l) { var e = LP[l.id] || {}; l.ph = urlList(e.ph); l.phTall = urlList(e.phTall); });
  })();
  /* placeholder photos: only ever drawn in the design previews, never on the puzzle.
     A design's own photos (its metaobject entry) fill its windows in order; the theme's general ones fill the rest. */
  var PH = (Array.isArray(CFG.placeholders) ? CFG.placeholders : []).filter(function (u) { return typeof u === 'string' && u; });
  var phCache = {}, phTimer = 0;
  function phEntry(u) {
    var p = phCache[u];
    if (!p) {
      p = phCache[u] = { img: new Image(), ok: false };
      p.img.decoding = 'async';
      p.img.onload = function () { p.ok = true; clearTimeout(phTimer); phTimer = setTimeout(function () { if (pickOn) renderThumbs(); else renderPeek(); if (sizesOn) sizeThumbs(); }, 80); };
      p.img.onerror = function () { p.ok = false; };
      p.img.src = u;
    }
    return p;
  }
  function loadPlaceholders() { PH.forEach(phEntry); }
  function hashStr(t) { var h = 0; t = String(t); for (var i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) >>> 0; return h; }

  function drawArt(g, list, m, ar, hi) {
    list.forEach(function (a) {
      g.save(); g.translate(m.x0, m.y0); g.scale(m.s, m.s);
      var e = artImg(hi ? (a.imgL || a.img) : a.img); if (e && e.ok) g.drawImage(e.img, 0, 0, ar, 1);
      g.restore();
    });
  }
  var vidInput = form.querySelector('[data-vid]') || form.querySelector('[name="id"]');
  var photos = [];                  /* every photo chosen this visit */
  var design = { tall: false, layout: LAYOUTS[0], slots: [{ photo: null, z: 1, ox: 0, oy: 0 }], texts: [], lines: true, snap: true };
  var saved = null;                 /* { vid, print, preview, originals, notes } once the design is on the page */
  var EDIT = null;                  /* { id, key, qty } while a design from the cart is being edited (?pix_edit=) */
  var sel = { type: 'slot', i: 0 }, snap = null, busy = false, lastFocus = null, orientTouched = false, pendingSlot = -1, cropMode = false, cropInfo = null, cropDrag = null, cropSnap = null, lastPhone = null, popOn = false, popSlot = -1, guides = null;

  function log() { try { console.log.apply(console, ['[Pix Upload]'].concat([].slice.call(arguments))); } catch (e) {} }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function isPhone() { return window.matchMedia('(max-width: 820px)').matches; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function activeVid() { return vidInput ? String(vidInput.value) : ''; }
  function variantTall(vid) {
    for (var i = 0; i < CFG.variants.length; i++) if (String(CFG.variants[i].id) === String(vid)) return !!CFG.variants[i].tall;
    return false;
  }
  function variantTitle(vid) {
    for (var i = 0; i < CFG.variants.length; i++) if (String(CFG.variants[i].id) === String(vid)) return String(CFG.variants[i].title || '');
    return '';
  }
  function curOverlay() {      /* a size-specific overlay if one matches the chosen size, else the main one */
    var t = variantTitle(activeVid()).toLowerCase(), list = CFG.overlays || [];
    for (var i = 0; i < list.length; i++) {
      var m = String(list[i].match || '').toLowerCase().trim();
      if (m && list[i].url && t.indexOf(m) > -1) return list[i].url;
    }
    return CFG.overlay || '';
  }
  /* ---------- quick mode: the designer opens right on the homepage or a collection page, for any of several
     puzzle sizes (snippets/pix-quick-designer.liquid); each size's details come from its product ---------- */
  var QUICK = !!(CFG.quick && Array.isArray(CFG.products) && CFG.products.length), PRODUCTS = QUICK ? CFG.products : [], curProd = null;
  function prodBy(h) { for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].handle === h) return PRODUCTS[i]; return null; }
  function useProduct(p) {
    curProd = p;
    CFG.variants = p.variants || []; CFG.overlay = p.overlay || ''; CFG.overlayAspect = +p.overlayAspect || 0; CFG.overlays = [];
    CFG.printLong = +p.long || 0; CFG.printShort = +p.short || 0;
    hasBoth = bothOrients();
  }
  if (QUICK) { CFG.orientMode = 'variants'; useProduct(prodBy(CFG.defaultProduct) || PRODUCTS[0]); }
  var ORIENT = CFG.orientMode || 'variants';      /* variants | both | landscape | portrait */
  function bothOrients() { return ORIENT === 'both' || (ORIENT === 'variants' && CFG.variants.some(function (v) { return v.tall; }) && CFG.variants.some(function (v) { return !v.tall; })); }
  var hasBoth = bothOrients();
  /* quick mode: the hidden form's variant follows the orientation chosen in the designer */
  function syncVariant() {
    if (!QUICK || !vidInput) return;
    var v = null;
    CFG.variants.forEach(function (x) { if (!v && !!x.tall === !!design.tall) v = x; });
    v = v || CFG.variants[0];
    if (v && String(vidInput.value) !== String(v.id)) { vidInput.value = v.id; syncInputs(); }
  }
  var urlQ = new URLSearchParams(location.search), startTall = /^p/i.test(urlQ.get('orient') || '');
  function pageTall() {
    if (ORIENT === 'portrait') return true;
    if (ORIENT === 'landscape') return false;
    if (ORIENT === 'both') return startTall;
    return variantTall(activeVid());
  }
  function ga(name, extra) {
    try {
      if (!window.gtag) return;
      var p = { tool: 'pix_uploader', variant_id: activeVid(), device: window.matchMedia('(max-width: 900px)').matches ? 'mobile' : 'desktop' };
      for (var k in extra || {}) p[k] = extra[k];
      window.gtag('event', name, p);
    } catch (e) {}
  }

  /* ---------- keep the old app's widget out of the way on this page ---------- */
  function purgeForeign() { document.querySelectorAll('.uploadkit-injected:not([data-pixup])').forEach(function (n) { n.remove(); }); }
  purgeForeign();
  var purgeTimer = 0;
  new MutationObserver(function () {
    if (purgeTimer) return;
    purgeTimer = setTimeout(function () { purgeTimer = 0; purgeForeign(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- puzzle size ---------- */
  function dims() {
    if (CFG.printLong > 0 && CFG.printShort > 0) return { long: CFG.printLong, short: CFG.printShort, inches: true };
    var el = document.querySelector('[data-dims] .pix-dims-main') || document.querySelector('[data-dims]');
    var m = el ? el.textContent.match(/\d+(?:\.\d+)?/g) : null;
    if (m && m.length >= 2 && +m[0] > 0 && +m[1] > 0) return { long: Math.max(+m[0], +m[1]), short: Math.min(+m[0], +m[1]), inches: true };
    if (CFG.overlayAspect > 0) return { long: CFG.overlayAspect, short: 1, inches: false };
    return { long: 4, short: 3, inches: false };
  }
  function aspectFor(tall) { var d = dims(); return tall ? d.short / d.long : d.long / d.short; }
  function aspect() { return aspectFor(design.tall); }

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = 0;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'pixup-toast'; toastEl.setAttribute('role', 'alert'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 6000);
  }

  /* ---------- upload ---------- */
  function send(blob, type, kind, group, onProg) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open('POST', ENDPOINT + '/upload?kind=' + kind + (group ? '&group=' + encodeURIComponent(group) : ''));
      x.setRequestHeader('Content-Type', type);
      x.upload.onprogress = function (e) { if (onProg && e.lengthComputable) onProg(e.loaded / e.total); };
      x.onload = function () {
        var d = null; try { d = JSON.parse(x.responseText); } catch (e) {}
        if (x.status === 200 && d && d.ok) res(d); else rej(new Error((d && d.error) || ('HTTP ' + x.status)));
      };
      x.onerror = function () { rej(new Error('network')); };
      x.send(blob);
    });
  }
  function toBlob(canvas, q) {
    return new Promise(function (res, rej) {
      canvas.toBlob(function (b) { if (b) res(b); else rej(new Error('Could not prepare the design')); }, 'image/jpeg', q);
    });
  }
  /* ---------- more photo types ----------
     iPhone/Samsung HEIC (in browsers that can't show it), TIFF scans, GIF, BMP and AVIF all work: anything this browser
     can't open is turned into a JPEG here (the decoders load only when needed), and anything the upload service doesn't
     take goes up as a full-size JPEG instead of the original file. */
  var LIBS = { heic: ['https://cdn.jsdelivr.net/npm/heic-to@1.6.6/dist/iife/heic-to.js', 'HeicTo'],
               pako: ['https://cdn.jsdelivr.net/npm/pako@2.1.0/dist/pako_inflate.min.js', 'pako'],
               utif: ['https://cdn.jsdelivr.net/npm/utif@3.1.0/UTIF.js', 'UTIF'] }, libP = {};
  var EXT_TYPE = { jpg: 'image/jpeg', jpeg: 'image/jpeg', jpe: 'image/jpeg', jfif: 'image/jpeg', png: 'image/png', webp: 'image/webp',
                   heic: 'image/heic', heif: 'image/heif', hif: 'image/heif', tif: 'image/tiff', tiff: 'image/tiff', gif: 'image/gif',
                   bmp: 'image/bmp', avif: 'image/avif' };
  var BIG_TYPES = ['image/tiff', 'image/bmp'], MAX_BIG = 100 * 1024 * 1024;      /* uncompressed scans may be bigger; they go up as JPEGs */
  function lib(k) {
    if (!libP[k]) libP[k] = new Promise(function (res, rej) {
      var L = LIBS[k]; if (window[L[1]]) return res(window[L[1]]);
      var sc = document.createElement('script'); sc.src = L[0]; sc.async = true;
      sc.onload = function () { if (window[L[1]]) res(window[L[1]]); else { libP[k] = null; rej(new Error('decoder')); } };
      sc.onerror = function () { libP[k] = null; rej(new Error('decoder')); };
      document.head.appendChild(sc);
    });
    return libP[k];
  }
  function typeOf(file) {
    var t = (file.type || '').toLowerCase(), m = /\.([a-z0-9]+)$/i.exec(file.name || ''), e = m ? EXT_TYPE[m[1].toLowerCase()] || '' : '';
    if (t === 'image/jpg' || t === 'image/pjpeg') t = 'image/jpeg';
    if (t === 'image/heic-sequence') t = 'image/heic'; if (t === 'image/heif-sequence') t = 'image/heif';
    return t && t !== 'application/octet-stream' ? t : e || t;
  }
  function bytes(blob) { return blob.arrayBuffer ? blob.arrayBuffer() : new Response(blob).arrayBuffer(); }
  function kindOf(file) {      /* 'heic', 'tiff' or '' from the file's first bytes, so a missing or wrong name doesn't matter */
    return bytes(file.slice(0, 32)).then(function (ab) {
      var b = new Uint8Array(ab);
      if ((b[0] === 73 && b[1] === 73 && b[2] === 42 && b[3] === 0) || (b[0] === 77 && b[1] === 77 && b[2] === 0 && b[3] === 42)) return 'tiff';
      var h = String.fromCharCode.apply(null, b.subarray(4, 12));
      if (h.slice(0, 4) === 'ftyp' && /^(heic|heix|hevc|hevx|heim|heis|hevm|hevs|mif1|msf1)/.test(h.slice(4))) return 'heic';
      var t = typeOf(file); return /hei[cf]/.test(t) ? 'heic' : t === 'image/tiff' ? 'tiff' : '';
    }, function () { return ''; });
  }
  function jpegOf(src, w, h) {      /* a full-size JPEG, white behind any see-through parts, no bigger than a print needs */
    var f = Math.min(1, MAX_LONG / Math.max(w, h), Math.sqrt(MAX_AREA / (w * h))), c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * f)); c.height = Math.max(1, Math.round(h * f));
    var g = c.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(src, 0, 0, c.width, c.height);
    return toBlob(c, 0.92).then(function (b) { c.width = c.height = 1; return b; });
  }
  function tiffToJpeg(file) {
    return lib('pako').catch(function () {}).then(function () { return lib('utif'); }).then(function (U) {
      return bytes(file).then(function (buf) {
        var ifds = U.decode(buf), best = null;
        ifds.forEach(function (d) { var w = d.t256 && d.t256[0], h = d.t257 && d.t257[0]; if (w && h && (!best || w * h > best.t256[0] * best.t257[0])) best = d; });
        if (!best) throw new Error('decode');
        /* a JPEG-compressed TIFF stored as RGB (not YCbCr) must not be colour-converted again */
        var JD = U.JpegDecoder; if (JD && !JD.pix) { U.JpegDecoder = function () { var j = new JD(); if (U.pixRgb) j.B = 0; return j; }; U.JpegDecoder.pix = 1; }
        U.pixRgb = best.t259 && best.t259[0] === 7 && best.t262 && best.t262[0] === 2;
        U.decodeImage(buf, best, ifds);
        var px = U.toRGBA8(best), w = best.width, h = best.height, c = document.createElement('canvas');
        c.width = w; c.height = h;
        c.getContext('2d').putImageData(new ImageData(new Uint8ClampedArray(px.buffer, px.byteOffset, w * h * 4), w, h), 0, 0);
        return jpegOf(c, w, h).then(function (b) { c.width = c.height = 1; return b; });
      });
    });
  }
  function toJpeg(file) {      /* a photo this browser can't open, as a JPEG; null when it isn't one we know */
    return kindOf(file).then(function (k) {
      if (!k) return null;
      toast('Opening your photo…');
      var p = k === 'heic' ? lib('heic').then(function (H) { return H({ blob: file, type: 'image/jpeg', quality: 0.92 }); }) : tiffToJpeg(file);
      return p.then(function (b) { if (toastEl) toastEl.classList.remove('is-on'); return b; });
    });
  }
  function jpgName(n) { return (String(n || 'photo').replace(/\.[a-z0-9]+$/i, '') || 'photo') + '.jpg'; }

  var group = '';                   /* one storage folder per design */
  var upQ = Promise.resolve();      /* originals upload one at a time */

  /* ---------- auto-enhance: levels + gentle brightness + a touch of colour ---------- */
  function makeLut(work) {
    var w = Math.min(320, work.width), h = Math.max(1, Math.round(work.height * w / work.width));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d'); g.drawImage(work, 0, 0, w, h);
    var p = g.getImageData(0, 0, w, h).data, hist = new Array(256).fill(0), n = w * h, i;
    for (i = 0; i < p.length; i += 4) hist[Math.round(0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2])]++;
    var lo = 0, hi = 255, acc = 0;
    for (i = 0; i < 256; i++) { acc += hist[i]; if (acc >= n * 0.005) { lo = i; break; } }
    acc = 0;
    for (i = 255; i >= 0; i--) { acc += hist[i]; if (acc >= n * 0.005) { hi = i; break; } }
    lo = Math.min(lo, 48); hi = Math.max(hi, 208);
    var mean = 0;
    for (i = 0; i < 256; i++) mean += hist[i] * clamp((i - lo) / (hi - lo), 0, 1);
    mean = clamp(mean / n, 0.05, 0.95);
    var gamma = clamp(Math.log(0.5) / Math.log(mean), 0.75, 1.3);
    gamma = 1 + (gamma - 1) * 0.6;
    var lut = new Uint8ClampedArray(256);
    for (i = 0; i < 256; i++) lut[i] = Math.pow(clamp((i - lo) / (hi - lo), 0, 1), gamma) * 255;
    return lut;
  }
  function applyLut(g, x, y, w, h, lut) {
    for (var yy = y; yy < y + h; yy += 256) {
      var hh = Math.min(256, y + h - yy), d = g.getImageData(x, yy, w, hh), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var r = lut[p[i]], gr = lut[p[i + 1]], b = lut[p[i + 2]], l = 0.299 * r + 0.587 * gr + 0.114 * b;
        p[i] = l + (r - l) * SAT; p[i + 1] = l + (gr - l) * SAT; p[i + 2] = l + (b - l) * SAT;
      }
      g.putImageData(d, x, yy);
    }
  }

  /* ---------- photos ---------- */
  function photoOf(img) {      /* a loaded photo: a working copy (long side WORK_LONG) for the screen, and a small thumbnail */
    var sw = img.naturalWidth, sh = img.naturalHeight;
    if (!sw || !sh) return null;
    var f = Math.min(1, WORK_LONG / Math.max(sw, sh));
    var work = document.createElement('canvas');
    work.width = Math.max(1, Math.round(sw * f)); work.height = Math.max(1, Math.round(sh * f));
    var g = work.getContext('2d');
    g.fillStyle = '#fff'; g.fillRect(0, 0, work.width, work.height);
    g.drawImage(img, 0, 0, work.width, work.height);
    var tf = Math.min(1, 132 / Math.max(work.width, work.height)), tc = document.createElement('canvas');
    tc.width = Math.round(work.width * tf); tc.height = Math.round(work.height * tf);
    tc.getContext('2d').drawImage(work, 0, 0, tc.width, tc.height);
    return { file: null, name: '', img: img, sw: sw, sh: sh, work: work, enh: null, lut: null, rot: 0, enhance: false,
             thumb: tc.toDataURL('image/jpeg', 0.8), originalP: null };
  }
  function loadImg(blob) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(blob), img = new Image();
      img.onload = function () { res(img); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('decode')); };
      img.src = url;
    });
  }
  function addPhoto(file) {
    var conv = null;
    return loadImg(file).catch(function () {      /* this browser can't show it: convert it here */
      return toJpeg(file).then(function (b) { if (!b) throw new Error('decode'); conv = b; return loadImg(b); });
    }).then(function (img) {
      var P = photoOf(img);
      if (!P) throw new Error('empty');
      P.file = file; P.name = file.name || '';
      /* start sending the original now, while the customer designs: as it is when the upload service takes it, otherwise as a full-size JPEG */
      var type = typeOf(file), asIs = OK_TYPES.indexOf(type) > -1;
      if (!asIs) P.upName = jpgName(P.name);
      P.originalP = upQ = upQ.then(function () {
        return (asIs ? Promise.resolve(file) : conv ? Promise.resolve(conv) : jpegOf(img, img.naturalWidth, img.naturalHeight))
          .then(function (b) { return send(b, asIs ? type : 'image/jpeg', 'original', group); })
          .then(function (d) { if (!group) group = d.group; return d.url; })
          .catch(function (e) { log('original not saved:', e.message); return ''; });
      });
      photos.push(P); return P;
    });
  }
  function ensureEnhanced(P) {
    if (P.enh) return;
    P.lut = makeLut(P.work);
    P.enh = document.createElement('canvas'); P.enh.width = P.work.width; P.enh.height = P.work.height;
    var g = P.enh.getContext('2d'); g.drawImage(P.work, 0, 0); applyLut(g, 0, 0, P.enh.width, P.enh.height, P.lut);
  }
  function used(P) { return design.slots.some(function (s) { return s.photo === P; }); }
  /* a photo the customer removed or replaced is forgotten, so it can't creep back into another layout */
  function dropUnused(P) { if (P && !used(P)) { var i = photos.indexOf(P); if (i > -1) photos.splice(i, 1); } }

  /* ---------- layout geometry ---------- */
  function cells(layout, tall) { return tall ? layout.c.map(function (c) { return [c[1], c[0], c[3], c[2]]; }) : layout.c; }
  /* every photo window in canvas pixels: x, y, w, h of the unturned window, plus its turn, shape and frame */
  function rects(W, H, D) {
    D = D || design;
    var geo = geoOf(D);
    if (geo) {
      var m = artMap(geo, W, H);
      return geo.slots.map(function (s) {
        return { x: m.x0 + s.x * m.w, y: m.y0 + s.y * m.s, w: s.w * m.w, h: s.h * m.s, rot: s.rot, shape: s.shape, rad: s.rad,
                 border: s.border * m.s, fb: s.fb * m.s, bc: s.bc, shadow: s.shadow };
      });
    }
    /* the white line between photos: at least 2px so it survives in the small previews; edges are rounded first so every line is the same width */
    var cs = cells(D.layout, D.tall), gap = cs.length > 1 ? Math.max(2, Math.round(Math.max(W, H) * 0.005)) : 0, e = 0.001, g0 = Math.floor(gap / 2), g1 = gap - g0;
    return cs.map(function (c) {
      var x0 = Math.round(c[0] * W), y0 = Math.round(c[1] * H), x1 = Math.round((c[0] + c[2]) * W), y1 = Math.round((c[1] + c[3]) * H);
      if (c[0] > e) x0 += g1; if (c[0] + c[2] < 1 - e) x1 -= g0;
      if (c[1] > e) y0 += g1; if (c[1] + c[3] < 1 - e) y1 -= g0;
      return { x: x0, y: y0, w: x1 - x0, h: y1 - y0, rot: 0, shape: 'rect', rad: 0, border: 0, fb: 0, shadow: false };
    });
  }
  /* is a canvas point inside a (possibly turned) window? */
  function inRect(p, r) {
    var a = -r.rot * Math.PI / 180, dx = p.x - (r.x + r.w / 2), dy = p.y - (r.y + r.h / 2);
    var lx = dx * Math.cos(a) - dy * Math.sin(a), ly = dx * Math.sin(a) + dy * Math.cos(a);
    if (r.shape === 'circle' || r.shape === 'heart') return (lx * lx) / (r.w * r.w / 4) + (ly * ly) / (r.h * r.h / 4) <= 1.05;
    return Math.abs(lx) <= r.w / 2 && Math.abs(ly) <= r.h / 2;
  }
  /* preset text of a design, placed for a puzzle of aspect A */
  function presetTexts(l, tall, A) {
    var geo = geoFor(l, tall); if (!geo) return [];
    var m = artMap(geo, A, 1);
    return geo.texts.map(function (t) {
      return { text: t.text, x: (m.x0 + t.x * m.w) / A, y: m.y0 + t.y * m.s, size: t.size * m.s, rot: t.rot, font: t.font, color: t.color, preset: l.id };
    });
  }
  /* how a photo sits in its window. z = 1 fills the window (the photo's extra width or height is trimmed);
     zooming out below 1, down to fitZ, shows more of the photo, and fitZ shows all of it, with the window's
     uncovered edges filled by the slot's background (slot.bg: "blur" = a soft blurred copy of the photo, or a colour) */
  function photoWH(P) { var q = P.rot % 180 !== 0; return { iw: q ? P.work.height : P.work.width, ih: q ? P.work.width : P.work.height }; }
  function fitZ(slot, r) { var d = photoWH(slot.photo), A = r.w / r.h; return Math.min(d.iw, d.ih * A) / Math.max(d.iw, d.ih * A); }
  /* zooming out past "fill" ("Show whole photo") is switched off: a photo always fills its space, and
     whatever doesn't fit is trimmed. Set ZOOM_OUT to true to bring it back. */
  var ZOOM_OUT = false;
  function minZ(slot, r) { return ZOOM_OUT ? fitZ(slot, r) : 1; }
  function slotGeom(slot, r) {
    var d = photoWH(slot.photo), iw = d.iw, ih = d.ih;
    slot.z = clamp(slot.z, minZ(slot, r), 5);
    var A = r.w / r.h, vw = Math.min(iw, ih * A) / slot.z, vh = vw / A, mx = Math.abs(iw - vw) / 2, my = Math.abs(ih - vh) / 2;
    slot.ox = clamp(slot.ox, -mx, mx);      /* zoomed out, the photo can slide around inside the window instead */
    slot.oy = clamp(slot.oy, -my, my);
    return { vw: vw, vh: vh, sc: r.w / vw, iw: iw, ih: ih, open: vw > iw + 0.5 || vh > ih + 0.5 };
  }
  /* is part of the photo trimmed at "fill", and is the slot showing more than "fill" now? */
  function fitState(slot, r) {
    var zf = fitZ(slot, r);
    return { zf: zf, trimmed: zf < 0.94, whole: slot.z < 0.999 };
  }
  var BG_CHOICES = [['blur', 'Blurred photo'], ['#FFFFFF', 'White'], ['#000000', 'Black']];
  /* the slot the "Show whole photo" button works on: the selected one, or the only one */
  function fitSlot() {
    if (sel.type === 'slot' && design.slots[sel.i] && design.slots[sel.i].photo) return sel.i;
    return design.slots.length === 1 && design.slots[0].photo ? 0 : -1;
  }
  /* right after an upload: say so when the window trims a good part of the new photo (a wide phone photo on a
     500 piece puzzle loses about a quarter of its width) */
  function trimNote() {
    var i = sel.type === 'slot' ? sel.i : -1, s = design.slots[i]; if (!s || !s.photo || !canvas) return;
    var r = rects(canvas.width, canvas.height)[i], d = photoWH(s.photo), zf = fitZ(s, r);
    if (!ZOOM_OUT || zf >= 0.85 || s.z < 0.999) return;
    var wide = d.iw / d.ih > r.w / r.h;
    toast('Your photo is ' + (wide ? 'wider' : 'taller') + ' than this space, so its ' + (wide ? 'sides are' : 'top and bottom are') + ' trimmed. Tap \u201cShow whole photo\u201d to keep all of it.');
    ga('photo_trimmed_notice', { kept: Math.round(zf * 100) });
  }
  /* background choices, shown once a photo is zoomed out far enough to leave edges uncovered */
  function bgRowHtml(i) {
    var s = design.slots[i]; if (!s || !s.photo || !canvas) return '';
    if (!slotGeom(s, rects(canvas.width, canvas.height)[i]).open) return '';
    var cur = s.bg || 'blur';
    return '<div class="pixup-bgrow"><span>Edges</span><div class="pixup-btns">' + BG_CHOICES.map(function (b) {
      return '<button type="button" data-bg="' + b[0] + '" aria-pressed="' + (cur === b[0]) + '">' + b[1] + '</button>';
    }).join('') + '</div></div>';
  }
  var canFilter = (function () { try { return typeof document.createElement('canvas').getContext('2d').filter === 'string'; } catch (e) { return false; } })();
  function blurOf(P) {      /* a soft copy of the photo for the uncovered edges; it is blurry anyway, so a small one is enough */
    if (P.blur) return P.blur;
    var W = P.work.width, H = P.work.height, k = 360 / Math.max(W, H), c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(W * k)); c.height = Math.max(1, Math.round(H * k));
    var g = c.getContext('2d');
    if (canFilter) {      /* drawn a little larger so the blur's soft rim falls outside */
      g.filter = 'blur(' + Math.round(c.width / 28) + 'px)';
      g.drawImage(P.work, -c.width * 0.08, -c.height * 0.08, c.width * 1.16, c.height * 1.16);
      g.filter = 'none';
    } else {      /* no canvas blur here: shrink to a few pixels and stretch back up */
      var t = document.createElement('canvas'); t.width = Math.max(1, Math.round(c.width / 18)); t.height = Math.max(1, Math.round(c.height / 18));
      var tg = t.getContext('2d'); tg.imageSmoothingQuality = 'high'; tg.drawImage(P.work, 0, 0, t.width, t.height);
      g.imageSmoothingQuality = 'high'; g.drawImage(t, 0, 0, c.width, c.height);
    }
    P.blur = c; return c;
  }
  /* the background behind a zoomed-out photo, drawn with the origin at the window's centre */
  function paintBg(g, slot, w, h) {
    var P = slot.photo, bg = slot.bg || 'blur';
    if (bg !== 'blur') { g.fillStyle = bg; g.fillRect(-w / 2, -h / 2, w, h); return; }
    var d = photoWH(P), s = Math.max(w / d.iw, h / d.ih);
    g.save(); g.rotate(P.rot * Math.PI / 180); g.imageSmoothingQuality = 'high';
    g.drawImage(blurOf(P), -P.work.width * s / 2, -P.work.height * s / 2, P.work.width * s, P.work.height * s);
    g.restore();
    g.fillStyle = 'rgba(255,255,255,.16)'; g.fillRect(-w / 2, -h / 2, w, h);      /* a touch lighter, so the photo itself stands out */
  }
  function setLayout(layout, extra) {
    var old = design.slots.map(function (s) { return s.photo; }).filter(Boolean).concat(extra || []);
    photos.forEach(function (P) { if (old.indexOf(P) < 0) old.push(P); });
    design.layout = layout;
    design.slots = [];
    for (var i = 0; i < slotCount(layout); i++) design.slots.push({ photo: old[i] || null, z: 1, ox: 0, oy: 0 });
    /* a design's own text comes with it; text the customer changed stays */
    design.texts = design.texts.filter(function (t) { return !t.preset || t.edited; });
    if (layout.tpl) design.texts = design.texts.concat(presetTexts(layout, design.tall, aspect()));
    sel = { type: 'slot', i: 0 }; cropMode = false; popOn = false;
  }
  /* after the orientation changes: keep the design if it has that version, else the plain layout with as many photos */
  function fitOrient() {
    var l = design.layout;
    if (l.tpl) setLayout(geoFor(l, design.tall) ? l : plainFor(l.n));
  }
  function resetSlots() { design.slots.forEach(function (s) { s.z = 1; s.ox = 0; s.oy = 0; }); }
  function slotDpi(slot, r, W) {
    var d = dims(); if (!d.inches || !slot.photo) return 0;
    var G = slotGeom(slot, r), frameIn = design.tall ? d.short : d.long;
    return G.vw * (slot.photo.sw / slot.photo.work.width) / (r.w / W * frameIn);
  }

  /* ---------- drawing (same code paints the preview and the print file) ---------- */
  function textBox(g, t, H) {
    var size = t.size * H; g.font = FONTS[t.font].css.replace('%', size);
    var lines = (t.text || ' ').split('\n'), w = 0;
    lines.forEach(function (l) { w = Math.max(w, g.measureText(l).width); });
    return { size: size, lines: lines, w: w, h: lines.length * size * 1.2 };
  }
  function roundRectPath(g, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath();
  }
  /* window outline around the centre; grow widens it (for frames), extra adds to the bottom (instant-photo frames) */
  function shapePath(g, r, grow, extra) {
    var w = r.w + grow * 2, h = r.h + grow * 2 + (extra || 0), y = -r.h / 2 - grow;
    g.beginPath();
    if (r.shape === 'circle') g.ellipse(0, 0, w / 2, h / 2, 0, 0, Math.PI * 2);
    else if (r.shape === 'heart') { g.save(); g.translate(0, (extra || 0) / 2); heartPath(g, w, h); g.restore(); }
    else if (r.shape === 'round') roundRectPath(g, -w / 2, y, w, h, Math.min(r.w, r.h) * r.rad + grow);
    else g.rect(-w / 2, y, w, h);
  }
  function paintSlot(g, slot, r, W, hi, thumb, picked) {
    var P = slot.photo, framed = r.border > 0 || r.fb > 0;
    g.save(); g.translate(r.x + r.w / 2, r.y + r.h / 2); g.rotate(r.rot * Math.PI / 180);
    if (framed || r.shadow) {       /* frame and drop shadow sit under the photo */
      g.save();
      if (r.shadow) { var sz = Math.max(r.w, r.h); g.shadowColor = 'rgba(20,24,32,.38)'; g.shadowBlur = sz * 0.045; g.shadowOffsetY = sz * 0.014; }
      g.fillStyle = framed ? r.bc : '#FFFFFF'; shapePath(g, r, r.border, r.fb); g.fill();
      g.restore();
    }
    g.save(); shapePath(g, r, 0, 0); g.clip();
    if (P) {
      var G = slotGeom(slot, r);
      if (G.open) paintBg(g, slot, r.w, r.h);
      g.imageSmoothingQuality = 'high';
      if (hi && P.enhance) {          /* enhance only this photo's pixels, then place them */
        var tc = document.createElement('canvas'); tc.width = Math.max(1, Math.round(r.w)); tc.height = Math.max(1, Math.round(r.h));
        var tg = tc.getContext('2d'); tg.imageSmoothingQuality = 'high';
        tg.translate(tc.width / 2 + slot.ox * G.sc, tc.height / 2 + slot.oy * G.sc); tg.rotate(P.rot * Math.PI / 180); tg.scale(G.sc, G.sc);
        tg.drawImage(P.img, -P.work.width / 2, -P.work.height / 2, P.work.width, P.work.height);
        if (!P.lut) P.lut = makeLut(P.work);
        applyLut(tg, 0, 0, tc.width, tc.height, P.lut);
        g.drawImage(tc, -r.w / 2, -r.h / 2, r.w, r.h);
      } else {
        g.translate(slot.ox * G.sc, slot.oy * G.sc); g.rotate(P.rot * Math.PI / 180); g.scale(G.sc, G.sc);
        g.drawImage(hi ? P.img : (P.enhance && P.enh ? P.enh : P.work), -P.work.width / 2, -P.work.height / 2, P.work.width, P.work.height);
      }
    } else if (thumb && slot.ph) {     /* a placeholder photo, cover-fit, kept a little high so faces stay in */
      var im = slot.ph, iw = im.naturalWidth, ih = im.naturalHeight, A = r.w / r.h, sw = Math.min(iw, ih * A), sh = sw / A;
      g.imageSmoothingQuality = 'high';
      g.drawImage(im, (iw - sw) / 2, (ih - sh) * 0.4, sw, sh, -r.w / 2, -r.h / 2, r.w, r.h);
    } else if (thumb) {
      /* no sample photo: a picture icon with "Your Photo Here" under it (just the icon when the space is tiny) */
      var lab = phLabel(g, r, W, Math.min(2, window.devicePixelRatio || 1)), q = lab ? lab.q : Math.min(r.w, r.h) * 0.32;
      var top = lab ? -lab.h / 2 : 0, oy = lab ? top + q * 0.78 : 0;      /* the icon reaches 0.78q above its middle and 0.55q below */
      g.fillStyle = '#D3DCE8'; g.fillRect(-r.w / 2, -r.h / 2, r.w, r.h);
      g.save(); g.translate(0, oy); if (lab && !lab.icon) g.globalAlpha = 0;
      g.fillStyle = '#A9B8CD'; g.beginPath(); g.moveTo(-q, q * 0.55); g.lineTo(-q * 0.3, -q * 0.35); g.lineTo(q * 0.15, q * 0.15);
      g.lineTo(q * 0.45, -q * 0.12); g.lineTo(q, q * 0.55); g.closePath(); g.fill();
      g.beginPath(); g.arc(q * 0.45, -q * 0.6, q * 0.18, 0, Math.PI * 2); g.fill();
      g.restore();
      if (lab) {
        g.fillStyle = '#52607A'; g.font = lab.font; g.textAlign = 'center'; g.textBaseline = 'middle';
        var ty = lab.icon ? oy + q * 0.55 + lab.gap : top;
        lab.lines.forEach(function (t, i) { g.fillText(t, 0, ty + lab.lh * (i + 0.5)); });
      }
    } else if (!hi) {
      g.fillStyle = '#E3EAF4'; g.fillRect(-r.w / 2, -r.h / 2, r.w, r.h);
      var px = W / (frame.clientWidth || W), k = clamp(Math.min(r.w, r.h) / px / 200, 0.55, 1.5) * px;
      g.fillStyle = '#2D5DA8'; g.beginPath(); g.arc(0, -12 * k, 20 * k, 0, 7); g.fill();
      g.strokeStyle = '#fff'; g.lineWidth = 3.5 * k; g.lineCap = 'round'; g.beginPath();
      g.moveTo(-9 * k, -12 * k); g.lineTo(9 * k, -12 * k); g.moveTo(0, -21 * k); g.lineTo(0, -3 * k); g.stroke();
      g.fillStyle = '#52607A'; g.font = '700 ' + (13 * k) + 'px "Figtree", sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle';
      g.fillText('Add photo', 0, 24 * k);
    }
    g.restore();
    if (picked) {
      var lw = Math.max(3, W / 200);
      g.strokeStyle = '#FFC845'; g.lineWidth = lw; shapePath(g, r, -lw / 2, 0); g.stroke();
    }
    g.restore();
  }
  /* "Your Photo Here" for an empty window in a preview. One text size for the whole preview (from its width),
     on one line or two; under the picture icon when there is room, on its own when the window is short,
     and just the icon when even the words won't fit. */
  function phLabel(g, r, W, dpr) {
    var fs = clamp(W * 0.047, 7.5 * dpr, 13 * dpr), fam = 'px "Figtree", system-ui, sans-serif';
    g.save(); g.font = '700 ' + fs + fam;
    var one = g.measureText('Your Photo Here').width, two = g.measureText('Your Photo').width; g.restore();
    var wm = r.w * (r.shape === 'heart' ? 0.5 : r.shape === 'circle' ? 0.68 : 0.88);      /* round shapes are narrower away from the middle */
    var lines = one <= wm ? ['Your Photo Here'] : ['Your Photo', 'Here'];
    if (lines.length > 1 && two > wm) {      /* a small window: smaller words, down to a size that can still be read */
      fs = fs * wm / two;
      if (fs < 7.5 * dpr) return null;
    }
    var lh = fs * 1.15, th = lh * lines.length, q = Math.min(Math.min(r.w, r.h) * 0.24, fs * 2.2), gap = fs * 0.5;
    var iconH = q * 1.35, room = r.h * 0.84;
    if (th > room) return null;
    var icon = iconH + gap + th <= room;
    return { font: '700 ' + fs + fam, lines: lines, lh: lh, gap: gap, q: q, icon: icon, h: (icon ? iconH + gap : 0) + th };
  }
  function paint(g, W, H, hi, D, thumb) {
    D = D || design;
    var geo = geoOf(D), m = geo ? artMap(geo, W, H) : null, live = D === design && !hi && !thumb;
    g.fillStyle = geo ? geo.color : '#fff'; g.fillRect(0, 0, W, H);
    if (geo) drawArt(g, geo.bg, m, geo.ar, hi);
    var rs = rects(W, H, D);
    D.slots.forEach(function (slot, i) { paintSlot(g, slot, rs[i], W, hi, thumb, live && rs.length > 1 && sel.type === 'slot' && sel.i === i); });
    if (geo) drawArt(g, geo.fg, m, geo.ar, hi);
    D.texts.forEach(function (t, i) {
      var b = textBox(g, t, H), light = ['#FFFFFF', '#FFC845'].indexOf(t.color) > -1;
      g.save(); g.translate(t.x * W, t.y * H); g.rotate(t.rot * Math.PI / 180);
      g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillStyle = t.color;
      if (light) { g.shadowColor = 'rgba(0,0,0,.45)'; g.shadowBlur = b.size * 0.12; g.shadowOffsetY = b.size * 0.03; }
      b.lines.forEach(function (l, n) { g.fillText(l, 0, (n - (b.lines.length - 1) / 2) * b.size * 1.2); });
      if (live && sel.type === 'text' && sel.i === i) {
        var pad = b.size * 0.25; g.shadowColor = 'transparent';
        g.setLineDash([6 * W / 600, 5 * W / 600]); g.lineWidth = Math.max(1.5, W / 400);
        g.strokeStyle = '#fff'; g.strokeRect(-b.w / 2 - pad, -b.h / 2 - pad, b.w + pad * 2, b.h + pad * 2);
        g.lineDashOffset = 5.5 * W / 600; g.strokeStyle = '#2D5DA8'; g.strokeRect(-b.w / 2 - pad, -b.h / 2 - pad, b.w + pad * 2, b.h + pad * 2);
      }
      g.restore();
    });
    if (live && guides) {
      var gw = Math.max(1, W / 600);
      g.save(); g.setLineDash([6 * gw, 4 * gw]);
      [['rgba(255,255,255,.9)', 3 * gw], ['#E0287D', 1.5 * gw]].forEach(function (st) {
        g.strokeStyle = st[0]; g.lineWidth = st[1]; g.beginPath();
        guides.x.forEach(function (x) { g.moveTo(x * W, 0); g.lineTo(x * W, H); });
        guides.y.forEach(function (y) { g.moveTo(0, y * H); g.lineTo(W, y * H); });
        g.stroke();
      });
      g.restore();
    }
  }
  /* text snapping: centre lines, thirds, and a safe margin at the edges */
  var SNAP_LINES = [0.5, 1 / 3, 2 / 3], SNAP_MARGIN = 0.04;
  function snapText(t, x, y) {
    var W = canvas.width, H = canvas.height, b = textBox(ctx, t, H), a = t.rot * Math.PI / 180;
    var hw = (Math.abs(b.w * Math.cos(a)) + Math.abs(b.h * Math.sin(a))) / 2 / W;
    var hh = (Math.abs(b.w * Math.sin(a)) + Math.abs(b.h * Math.cos(a))) / 2 / H;
    var px = W / (canvas.getBoundingClientRect().width || W);      /* canvas pixels per screen pixel */
    function pick(v, half, tol) {
      var opts = SNAP_LINES.map(function (c) { return { d: c - v, line: c }; });
      opts.push({ d: SNAP_MARGIN - (v - half), line: SNAP_MARGIN }, { d: 1 - SNAP_MARGIN - (v + half), line: 1 - SNAP_MARGIN });
      var best = null;
      opts.forEach(function (o) { if (Math.abs(o.d) <= tol && (!best || Math.abs(o.d) < Math.abs(best.d))) best = o; });
      return best;
    }
    var sx = pick(x, hw, 8 * px / W), sy = pick(y, hh, 8 * px / H), gl = { x: [], y: [] };
    if (sx) { x += sx.d; gl.x.push(sx.line); }
    if (sy) { y += sy.d; gl.y.push(sy.line); }
    return { x: x, y: y, g: gl.x.length || gl.y.length ? gl : null };
  }
  function exportDesign() {
    var d = dims(), A = aspect(), best = 0, pxLong = 0;
    var rs = rects(1000 * (A >= 1 ? 1 : A), 1000 * (A >= 1 ? 1 / A : 1)), Wn = 1000 * (A >= 1 ? 1 : A);
    design.slots.forEach(function (s, i) {
      if (!s.photo) return;
      best = Math.max(best, slotDpi(s, rs[i], Wn));
      var G = slotGeom(s, rs[i]); pxLong = Math.max(pxLong, G.vw * (s.photo.sw / s.photo.work.width) / (rs[i].w / Wn) * (A >= 1 ? 1 : 1 / A));
    });
    var long = d.inches ? d.long * clamp(best, 100, 300) : clamp(pxLong, 1800, 6000);
    long = Math.min(long, MAX_LONG);
    var W = A >= 1 ? long : long * A, H = A >= 1 ? long / A : long, m = Math.min(1, Math.sqrt(MAX_AREA / (W * H)));
    W = Math.round(W * m); H = Math.round(H * m);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    paint(c.getContext('2d'), W, H, true);
    return c;
  }
  function shrink(canvas, long) {
    var f = Math.min(1, long / Math.max(canvas.width, canvas.height));
    var c = document.createElement('canvas'); c.width = Math.round(canvas.width * f); c.height = Math.round(canvas.height * f);
    var g = c.getContext('2d'); g.imageSmoothingQuality = 'high'; g.drawImage(canvas, 0, 0, c.width, c.height);
    return c;
  }

  /* the preview shown on the product page and in the cart carries the puzzle lines;
     the print file never does */
  var overlayCache = {};
  function overlayForPreview() {
    var u = curOverlay();
    if (!u) return Promise.resolve(null);
    if (!overlayCache[u]) overlayCache[u] = new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = function () { res(null); };
      im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'pixup=1';
    });
    return overlayCache[u];
  }
  function previewCanvas(out) {      /* resolves to { c: the picture with its lines (or without), plain: true when no lines } */
    return overlayForPreview().then(function (im) {
      if (!im) return { c: shrink(out, 1400), plain: true };
      var c = shrink(out, 1400), g = c.getContext('2d');
      var lines = document.createElement('canvas'); lines.width = im.naturalWidth; lines.height = im.naturalHeight;
      var lg = lines.getContext('2d'); lg.drawImage(im, 0, 0);
      lg.globalCompositeOperation = 'source-in'; lg.fillStyle = LINE_COLOR; lg.fillRect(0, 0, lines.width, lines.height);
      im = lines;
      g.save(); g.translate(c.width / 2, c.height / 2); g.globalAlpha = LINE_ALPHA;
      if (design.tall) { g.rotate(Math.PI / 2); g.drawImage(im, -c.height / 2, -c.width / 2, c.height, c.width); }
      else g.drawImage(im, -c.width / 2, -c.height / 2, c.width, c.height);
      g.restore();
      return { c: c, plain: false };
    });
  }

  /* ---------- designer window ---------- */
  var fitChip = null;
  var modal, stage, frame, canvas, ctx, overlayEl, starsEl, sideEl, busyEl, barEl, msgEl, popEl, sheetEl, dragging = false, fontsLoaded = false;
  var ICON_UP = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>';
  var ICON_T = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 6V4h14v2M12 4v16M9 20h6"/></svg>';
  var pickOn = false, pickTab = 'multi', pickTheme = [], pickEl = null, thumbTok = 0;
  var sizesOn = false, sizesMust = false, sizesEl = null;
  /* quick mode's first run: "Choose your size", then "Choose a design" (askDesign), then the designer.
     pickStart: the design window is that second step, so it gets a way back to the sizes. */
  var askDesign = false, pickStart = false;
  /* askSize: the homepage's "Start your puzzle" asks for the template first, then the size (tplFirst while that size window shows) */
  var askSize = false, tplFirst = false, thumbIO = null;
  /* phones: tool buttons under the preview; a tool's panel takes their place ("photo" or "text"),
     the layout chooser and the tin's 3D preview open as popups, so nothing on the screen scrolls */
  var tool = null, tinTool = null, layEl = null, layOn = false;

  /* ---------- "Choose your template" window ---------- */
  var FILTER = (String(CFG.themeFilter || '') + ',' + (urlQ.get('themes') || urlQ.get('theme') || '')).split(',').map(slug).filter(Boolean);
  pickTheme = FILTER.filter(function (s) { return DESIGNS.some(function (d) { return d.themes.indexOf(s) > -1; }); });
  var autoPick = pickTheme.length > 0 && !!(urlQ.get('themes') || urlQ.get('theme')) && !/[a-z]/i.test(urlQ.get('design') || '');      /* theme links open the design window first */
  function themeName(s) { for (var i = 0; i < THEMES.length; i++) if (THEMES[i].slug === s) return THEMES[i].name; return s; }
  function pickList(tab) {
    var one = tab === 'one';
    var list = LAYOUTS.concat(DESIGNS).filter(function (l) {
      var n = slotCount(l);
      if (one ? n !== 1 : n < 2) return false;
      if (l.tpl && !geoFor(l, design.tall) && !hasBoth) return false;      /* only made in an orientation this puzzle does not offer */
      return true;
    });
    if (pickTheme.length) list = list.filter(function (l) {
      return (l.tpl && l.themes.some(function (t) { return pickTheme.indexOf(t) > -1; })) || (one && l === LAYOUTS[0]);
    });
    var pos = {}; list.forEach(function (l, i) { pos[l.id] = i; });
    return list.sort(function (a, b) {
      return (slotCount(a) - slotCount(b)) || ((a.tpl ? 1 : 0) - (b.tpl ? 1 : 0)) || ((a.sort || 0) - (b.sort || 0)) || (pos[a.id] - pos[b.id]);
    });
  }
  function openPicker(tab, src) {
    pickTab = 'all'; closeLay();
    pickOn = true; popOn = false; cropMode = false; draw(); loadPlaceholders();
    pickEl.hidden = false; renderPicker();
    var L = design.layout, key = pickTheme.length ? 't-' + pickTheme[0] : !pickStart ? (L.tpl ? (L.themes[0] ? 't-' + L.themes[0] : 't-more') : slotCount(L) > 1 ? 'multi' : '') : '';
    if (key) requestAnimationFrame(function () { var g = pickEl.querySelector('.pixup-grid'), sc = pickEl.querySelector('#pixup-sec-' + key); if (g && sc) g.scrollTop = sc.offsetTop - g.offsetTop - 6; });
    var b = pickEl.querySelector('[data-act="pickclose"]'); if (b) b.focus({ preventScroll: true });
    ga('design_window_opened', { tab: 'all', source: src || 'change_template' });
  }
  function closePicker() { if (!pickOn) return; pickOn = false; pickStart = false; thumbTok++; if (thumbIO) { thumbIO.disconnect(); thumbIO = null; } pickEl.hidden = true; renderSide(); }
  function pickBack() { closePicker(); askDesign = true; openSizes(true); }      /* the start flow's design window: back to "Choose your size" */
  /* every template on one screen: the full photo, then the collages, then the themed designs grouped by theme.
     Each comes as a landscape and a portrait card when the puzzle is offered both ways. */
  function tplOrients(l) {
    var o = hasBoth ? [false, true] : [design.tall];
    return o.filter(function (t) { return !l.tpl || !!geoFor(l, t); });
  }
  function tplSections() {
    /* collages: by number of photos, the plain grids first and then the styled ones */
    var colls = LAYOUTS.slice(1).concat(DESIGNS.filter(function (l) { return l.coll && tplOrients(l).length; })), cpos = {};
    colls.forEach(function (l, i) { cpos[l.id] = i; });
    colls.sort(function (a, b) { return (slotCount(a) - slotCount(b)) || ((a.tpl ? 1 : 0) - (b.tpl ? 1 : 0)) || ((a.sort || 0) - (b.sort || 0)) || (cpos[a.id] - cpos[b.id]); });
    var secs = [{ key: 'one', name: 'Single photo', list: [LAYOUTS[0]] }, { key: 'multi', name: 'Collages', list: colls }];
    var pos = {}; DESIGNS.forEach(function (l, i) { pos[l.id] = i; });
    var byTheme = {}, order = [], other = [];
    DESIGNS.slice().sort(function (a, b) { return ((a.sort || 0) - (b.sort || 0)) || (pos[a.id] - pos[b.id]); }).forEach(function (l) {
      if (!tplOrients(l).length || l.coll) return;
      var t = l.themes[0];
      if (!t) { other.push(l); return; }
      if (!byTheme[t]) { byTheme[t] = []; order.push(t); }
      byTheme[t].push(l);
    });
    order.sort(function (a, b) { return THEMES.map(function (x) { return x.slug; }).indexOf(a) - THEMES.map(function (x) { return x.slug; }).indexOf(b); });
    order.forEach(function (t) { secs.push({ key: 't-' + t, name: themeName(t), list: byTheme[t], theme: t }); });
    if (other.length) secs.push({ key: 't-more', name: 'More designs', list: other });
    return secs;
  }
  function renderPicker() {
    var secs = tplSections();
    var h = '<div class="pixup-pickbox pixup-tplbox"><div class="pixup-pickhead">' +
      '<b>Choose your template</b><button type="button" class="pixup-x" data-act="pickclose" aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<p class="pixup-tpllead">Start with one photo, a collage or a themed design. You can change it later.</p>' +
      '<div class="pixup-chips" role="navigation" aria-label="Jump to">' + secs.map(function (sc) {
        return '<button type="button" data-jump="' + esc(sc.key) + '">' + esc(sc.name) + '</button>';
      }).join('') + '</div><div class="pixup-grid pixup-tplgrid">';
    secs.forEach(function (sc) {
      h += '<h3 class="pixup-gsec" id="pixup-sec-' + esc(sc.key) + '">' + esc(sc.name) + '</h3>';
      sc.list.forEach(function (l) {
        tplOrients(l).forEach(function (t) {
          var n = slotCount(l), on = l === design.layout && t === design.tall;
          var title = l.tpl ? esc(l.name) : n === 1 ? 'Full photo' : 'Collage';
          h += '<button type="button" class="pixup-dcard pixup-tcard" data-design="' + esc(l.id) + '" data-t="' + (t ? 1 : 0) + '" aria-pressed="' + on + '"' +
            ' aria-label="' + title + ', ' + n + (n > 1 ? ' photos' : ' photo') + ', ' + (t ? 'portrait' : 'landscape') + '">' +
            '<span class="pixup-thumb"><canvas width="1" height="1" data-l="' + esc(l.id) + '" data-t="' + (t ? 1 : 0) + '"></canvas><em class="pixup-npill">' + n + (n > 1 ? ' photos' : ' photo') + '</em></span>' +
            '<b>' + title + '</b><small>' + n + (n > 1 ? ' photos' : ' photo') + ' \u00b7 ' + (t ? 'Portrait' : 'Landscape') + '</small>' +
            '<span class="pixup-tsel">' + (on ? 'Selected' : 'Select') + '</span></button>';
        });
      });
    });
    h += '</div></div>';
    pickEl.innerHTML = h;
    watchThumbs();
  }
  /* only the cards on screen (and just below) are drawn, so the long list opens quickly on phones */
  function watchThumbs() {
    if (thumbIO) { thumbIO.disconnect(); thumbIO = null; }
    var cvs = [].slice.call(pickEl.querySelectorAll('canvas[data-l]'));
    if (!('IntersectionObserver' in window)) { cvs.forEach(function (c) { c.setAttribute('data-vis', '1'); }); renderThumbs(); return; }
    thumbIO = new IntersectionObserver(function (es) {
      var any = false;
      es.forEach(function (e) { if (e.isIntersecting) { e.target.setAttribute('data-vis', '1'); thumbIO.unobserve(e.target); any = true; } });
      if (any) renderThumbs();
    }, { root: pickEl.querySelector('.pixup-grid'), rootMargin: '400px 0px' });
    cvs.forEach(function (c) { thumbIO.observe(c); });
  }
  function jumpTo(key) {
    var grid = pickEl.querySelector('.pixup-grid'), sec = pickEl.querySelector('#pixup-sec-' + key);
    if (!grid || !sec) return;
    grid.scrollTo({ top: sec.offsetTop - grid.offsetTop - 6, behavior: 'smooth' });
    [].forEach.call(pickEl.querySelectorAll('[data-jump]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-jump') === key)); });
  }
  function openStartPicker(src) { pickStart = true; openPicker(null, src || 'start_flow'); }
  function renderThumbs() {
    var cvs = [].slice.call(pickEl.querySelectorAll('canvas[data-l][data-vis]')), i = 0, tok = ++thumbTok;
    (function step() {
      if (tok !== thumbTok || !pickOn) return;
      var t0 = Date.now();
      while (i < cvs.length && Date.now() - t0 < 14) thumb(cvs[i++]);
      if (i < cvs.length) requestAnimationFrame(step);
    })();
  }
  function thumb(cv) {
    var l = layoutById(cv.getAttribute('data-l')); if (!l) return;
    var tall = cv.getAttribute('data-t') === '1';
    thumbPaint(cv, l, tall, aspectFor(tall), 150, 112, 1);
  }
  /* a design preview in a canvas: l = the design, A = puzzle width / height, fill = how much of the box it may use,
     keep = show the customer's own crops and text (the size window shows their puzzle as it is) */
  function thumbPaint(cv, l, tall, A, dw, dh, fill, keep) {
    var box = cv.parentNode;
    var bw = (box.clientWidth || dw) * fill, bh = (box.clientHeight || dh) * fill, w = Math.min(bw, bh * A), h = w / A, dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); cv.style.width = Math.round(w) + 'px'; cv.style.height = Math.round(h) + 'px';
    /* shown with the customer's own photos when there are some */
    var mine = design.slots.map(function (s) { return s.photo; }).filter(Boolean);
    photos.forEach(function (P) { if (mine.indexOf(P) < 0) mine.push(P); });
    var D = { layout: l, tall: tall, slots: [], texts: keep ? design.texts : l.tpl ? presetTexts(l, tall, A) : [] };
    /* windows the customer's photos don't fill show placeholder photos: the design's own in order,
       or the general ones starting at a different photo per design */
    var lph = l.ph || [], lpt = l.phTall || [];
    var ownList = tall ? (lpt.length ? lpt : lph) : (lph.length ? lph : lpt);      /* each orientation borrows the other's if it has none */
    var own = ownList.length ? ownList.map(phEntry) : null;
    var gen = own ? null : PH.map(phEntry).filter(function (p) { return p.ok; }), off = gen && gen.length ? hashStr(l.id) % gen.length : 0;
    for (var k = 0; k < slotCount(l); k++) {
      var pe = mine[k] ? null : own ? own[k % own.length] : gen.length ? gen[(off + k) % gen.length] : null;
      var ds = keep ? design.slots[k] : null;      /* the size window: each photo stays in its own window, cropped as the customer left it */
      if (ds) {
        var pk = ds.photo ? null : own ? own[k % own.length] : gen.length ? gen[(off + k) % gen.length] : null;
        D.slots.push({ photo: ds.photo || null, ph: pk && pk.ok ? pk.img : null, z: ds.z, ox: ds.ox, oy: ds.oy, bg: ds.bg }); continue;
      }
      D.slots.push({ photo: mine[k] || null, ph: pe && pe.ok ? pe.img : null, z: 1, ox: 0, oy: 0 });
    }
    paint(cv.getContext('2d'), cv.width, cv.height, false, D, true);
  }

  /* phones (the modal gets .pixup-c): the preview fills the screen above a row of tool buttons, a tool's panel
     replaces the buttons while it is open, and the layout chooser and the tin's 3D preview are popups.
     Nothing scrolls; the preview takes whatever room is left. */
  var PHONE_CSS = '@media (max-width:820px){' +
    '.pixup-c .pixup-left{flex:1 1 auto;height:auto;min-height:0}' +
    '.pixup-c .pixup-side{flex:none;overflow:visible;padding:10px 12px 12px;gap:10px}' +
    '.pixup-c .pixup-under{min-height:28px;padding:0 12px 4px}' +
    '.pixup-tools{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(0,1fr);gap:8px}' +
    '.pixup-tools button{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;min-width:0;min-height:70px;padding:8px 4px;border:1.5px solid #E4DCCB;border-radius:12px;background:#fff;color:#22314A;font:inherit;font-weight:700;font-size:.92rem;line-height:1.2;cursor:pointer}' +
    '.pixup-tools button:active{background:#E9F0FA;border-color:#2D5DA8}' +
    '.pixup-tools svg{flex:none;width:26px;height:26px;color:#2D5DA8}' +
    '.pixup-tools small{display:block;max-width:100%;font-size:.72rem;font-weight:600;color:#52607A;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.pixup-pline{margin:0;text-align:center;font-size:.9rem;color:#52607A}.pixup-pline s{margin:0 5px}.pixup-pline strong{color:#C2412F;font-weight:800}' +
    '.pixup-tpanel{display:flex;flex-direction:column;gap:9px}' +
    '.pixup-thead{display:flex;align-items:center;justify-content:space-between;gap:8px;min-height:40px}' +
    '.pixup-thead b{font-family:"Bricolage Grotesque","Figtree",sans-serif;font-size:1.08rem;font-weight:800}' +
    '.pixup-thead span{display:flex;align-items:center;gap:6px}' +
    '.pixup-done{min-height:40px;padding:0 18px;border:0;border-radius:20px;background:#2D5DA8;color:#fff;font:inherit;font-weight:800;font-size:.92rem;cursor:pointer}' +
    '.pixup-tlink{display:flex;align-items:center;justify-content:center;gap:4px;min-width:40px;min-height:40px;padding:0 12px;border:1.5px solid #C9D6EA;border-radius:20px;background:#fff;color:#2D5DA8;font:inherit;font-weight:800;font-size:.86rem;cursor:pointer}' +
    '.pixup-tlink.is-icon{padding:0;color:#9B2C1A}' +
    '.pixup-tpanel .pixup-btns{flex-wrap:nowrap;gap:6px}.pixup-tpanel .pixup-btns button{flex:1 1 0;min-width:0;min-height:46px;padding:0 3px;font-size:.84rem;white-space:nowrap}' +
    '.pixup-modal .pixup-tpanel textarea{display:block;width:100%;padding:8px 10px;border:1.5px solid #C9D6EA;border-radius:10px;background:#fff !important;color:#22314A !important;-webkit-text-fill-color:#22314A;font:inherit;font-size:16px;resize:none}' +
    '.pixup-tpanel .pixup-fonts,.pixup-tpanel .pixup-colors,.pixup-tpanel .pixup-row{margin:0}' +
    '.pixup-tpanel .pixup-colors{flex-wrap:nowrap;justify-content:space-between}.pixup-tpanel .pixup-colors button{width:30px;height:30px}' +
    '.pixup-tpanel .pixup-tip{margin:0;text-align:center}' +
    /* "Change layout" */
    '.pixup-lay{position:absolute;inset:0;z-index:4;display:flex;align-items:flex-start;justify-content:center;padding:calc(10px + var(--pixup-top)) 10px 10px;background:rgba(18,26,40,.45)}' +
    '.pixup-laybox{width:100%;max-width:520px;padding:4px 16px 18px;border-radius:16px;background:#fff;box-shadow:0 10px 36px rgba(18,26,40,.4)}' +
    '.pixup-laybox .pixup-pickhead{padding:6px 0 10px;margin-bottom:16px;border-bottom:1.5px solid #E4DCCB}' +
    '.pixup-laytiles{display:grid;grid-template-columns:1fr 1fr;gap:12px}' +
    '.pixup-laytiles button{display:flex;flex-direction:column;align-items:center;gap:10px;padding:16px 8px 14px;border:1.5px solid #E4DCCB;border-radius:14px;background:#fff;color:#2D5DA8;font:inherit;font-weight:800;font-size:1rem;cursor:pointer}' +
    '.pixup-laytiles button[aria-pressed="true"]{border-color:#2D5DA8;background:#F4F8FE}' +
    '.pixup-laytiles svg{width:96px;height:69px}.pixup-laytiles rect{fill:#fff;stroke:#8C97A8;stroke-width:1.5}.pixup-laytiles rect.f{fill:#C9D1DC;stroke:none}' +
    '.pixup-laynote{margin:12px 0 0;text-align:center;font-size:.84rem;color:#52607A}' +
    '.pixup-layo{margin-top:16px}.pixup-layo h3{margin:0 0 8px;font:inherit;font-size:.82rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#52607A}' +
    /* the tin step: the lid fills the screen, its 3D preview is a popup */
    '.pixup-c .pixup-tin{position:relative}.pixup-c .pixup-tinstage{flex:1 1 auto;height:auto;min-height:0}' +
    '.pixup-c .pixup-tinside{flex:none;overflow:visible;padding:10px 12px 12px;gap:10px}' +
    '.pixup-c .pixup-sec3d{display:none}' +
    '.pixup-c .pixup-tin.is-3d::before{content:"";position:absolute;inset:0;z-index:5;background:rgba(18,26,40,.45)}' +
    '.pixup-c .pixup-tin.is-3d .pixup-sec3d{position:absolute;inset:10px;z-index:6;display:flex;flex-direction:column;gap:8px;padding:4px 16px 16px;border-radius:16px;background:#fff;box-shadow:0 10px 36px rgba(18,26,40,.4)}' +
    '.pixup-c .pixup-tin.is-3d .pixup-3dhead{display:flex;padding:6px 0 8px}.pixup-c .pixup-sec3d>h3{display:none}' +
    '.pixup-c .pixup-sec3d .pixup-tin3d{flex:1 1 auto;height:auto;min-height:0}.pixup-c .pixup-sec3d .pixup-tip{margin:0;text-align:center}' +
    '.pixup-lidpanel .pixup-sec h3{margin-bottom:5px}.pixup-lidpanel .pixup-tiles{gap:8px}' +
    '.pixup-lidpanel .pixup-tiles button{flex-direction:row;justify-content:center;gap:9px;min-height:46px;padding:4px 8px;font-size:.92rem}.pixup-lidpanel .pixup-tiles svg{width:34px;height:28px}' +
    '.pixup-lidpanel .pixup-tintitle{min-height:44px;font-size:16px}.pixup-lidpanel .pixup-tip{margin-top:5px;font-size:.76rem}' +
    /* "Choose your size": all four sizes on one screen */
    '.pixup-q .pixup-sizelead{font-size:.84rem;padding:0 16px 4px}.pixup-q .pixup-grid.pixup-sizegrid{gap:10px;padding:8px 12px calc(12px + env(safe-area-inset-bottom))}' +
    '.pixup-q .pixup-scard{padding:8px 8px 10px;gap:1px}.pixup-q .pixup-simg{height:74px;margin-bottom:6px}.pixup-q .pixup-scard b{font-size:.88rem;line-height:1.2}' +
    '.pixup-q .pixup-scard small{font-size:.76rem}.pixup-q .pixup-sprice{margin-top:2px;font-size:.88rem}.pixup-q .pixup-scta{margin-top:6px;padding:7px 0;font-size:.88rem}' +
    '.pixup-q .pixup-sbadge{top:6px;left:6px;font-size:.64rem;padding:2px 7px}' +
    /* ...and the cards grow to fill the whole screen: the pictures take the extra height */
    '.pixup-sizes .pixup-grid.pixup-sizegrid{flex:1 1 auto;grid-auto-rows:minmax(min-content,1fr);align-content:stretch}' +
    '.pixup-sizes .pixup-scard{align-self:stretch;height:auto}' +
    '.pixup-sizes .pixup-scard .pixup-simg{position:relative;flex:1 1 0;height:auto;min-height:50px}' +
    '.pixup-sizes .pixup-simg>canvas,.pixup-sizes .pixup-simg>img{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}' +
    '}';
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'pixup-modal' + (QUICK ? ' pixup-q' : ''); modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Design your puzzle');
    modal.innerHTML =
      '<div class="pixup-panel">' +
        '<div class="pixup-head"><div class="pixup-ttl"><b>Design your puzzle</b>' + (TIN ? '<span class="pixup-stepnum">Step 1 of 2</span>' : '') + '</div><button type="button" class="pixup-x" data-act="cancel" aria-label="Close">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<div class="pixup-body">' +
          '<div class="pixup-left"><div class="pixup-stage"><div class="pixup-frame"><canvas class="pixup-canvas"></canvas><img class="pixup-overlay" alt="" draggable="false" hidden>' +
            '<div class="pixup-pop" hidden><button type="button" data-act="crop" aria-label="Crop and zoom this photo"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2v14a2 2 0 0 0 2 2h14M2 6h14a2 2 0 0 1 2 2v14"/></svg></button>' +
            '<button type="button" data-act="remove" aria-label="Remove this photo"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div></div></div>' +
            '<div class="pixup-under"><span class="pixup-stars" hidden></span><button type="button" class="pixup-chip pixup-fitchip" hidden></button></div></div>' +
          '<div class="pixup-side"></div>' +
        '</div>' +
        (TIN ? tinMarkup() : '') +
        '<p class="pixup-warn" hidden></p>' +
        (BACK ? backMarkup() : '') +
        '<div class="pixup-foot"><button type="button" class="pixup-ghost" data-act="cancel">Cancel</button>' +
          '<button type="button" class="pixup-add" data-act="' + (TIN ? 'next' : 'add') + '">' + (TIN ? NEXT_HTML : addHtml()) + '</button></div>' +
        '<div class="pixup-sheet" hidden></div>' +
        '<div class="pixup-lay" hidden role="dialog" aria-label="Change layout"></div>' +
        '<div class="pixup-pick" hidden role="dialog" aria-label="Choose your template"></div>' +
        (QUICK ? '<div class="pixup-pick pixup-sizes" hidden role="dialog" aria-label="Choose your size"></div>' : '') +
        '<div class="pixup-leave" hidden role="alertdialog" aria-modal="true" aria-labelledby="pixup-leave-t"></div>' +
        '<div class="pixup-busy" hidden><div class="pixup-bar"><i></i></div><span>Adding to cart…</span></div>' +
      '</div>';
    document.body.appendChild(modal);
    var st = document.createElement('style');
    st.textContent = '.pixup-frame .pixup-overlay{filter:brightness(0);opacity:' + LINE_ALPHA + '}' +
      '.pixup-modal{--pixup-top:0px}@media (display-mode:standalone){.pixup-modal{--pixup-top:env(safe-area-inset-top,0px)}}' +
      '@media (max-width:820px){.pixup-modal .pixup-head{padding-top:calc(8px + var(--pixup-top))}}' +
      '.pixup-pop{position:absolute;z-index:3;display:flex;gap:6px;padding:5px;border-radius:13px;background:rgba(255,255,255,.94);box-shadow:0 2px 10px rgba(18,26,40,.4);transform:translate(-50%,-100%)}' +
      '.pixup-pop button{width:40px;height:40px;padding:0;border:0;border-radius:9px;background:#2D5DA8;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
      '.pixup-pop button[data-act="remove"]{background:#D94F3D}.pixup-pop button:hover{filter:brightness(1.1)}' +
      '.pixup-switch{display:flex;align-items:flex-start;gap:10px;margin:4px 0 10px;font-size:.9rem;font-weight:700;color:#22314A;cursor:pointer}' +
      '.pixup-switch small{display:block;margin-top:1px;font-size:.78rem;font-weight:600;color:#52607A}' +
      '.pixup-switch input{-webkit-appearance:none;appearance:none;flex:none;position:relative;width:42px;height:24px;margin:0;border-radius:12px;background:#C9D6EA;cursor:pointer;transition:background .15s}' +
      '.pixup-switch input::after{content:"";position:absolute;top:3px;left:3px;width:18px;height:18px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.25);transition:transform .15s}' +
      '.pixup-switch input:checked{background:#2D5DA8}.pixup-switch input:checked::after{transform:translateX(18px)}' +
      '.pixup-bgrow{display:flex;align-items:center;gap:10px;margin-top:9px}.pixup-bgrow>span{flex:none;font-size:.82rem;font-weight:800;color:#52607A}' +
      '.pixup-bgrow .pixup-btns{flex:1;flex-wrap:nowrap;gap:6px}.pixup-bgrow .pixup-btns button{flex:1 1 0;min-width:0;min-height:36px;padding:0 4px;font-size:.8rem;white-space:nowrap}' +
      '.pixup-tpanel .pixup-bgrow{margin:0}.pixup-tpanel .pixup-bgrow .pixup-btns button{min-height:40px}' +
      '.pixup-fitchip{flex:none}.pixup-toast{width:max-content}' +
      /* a soft pulsing ring on the photo button until the first photo is in */
      '@keyframes pixup-pulse{0%{box-shadow:0 0 0 0 rgba(45,93,168,.55)}70%{box-shadow:0 0 0 9px rgba(45,93,168,0)}100%{box-shadow:0 0 0 0 rgba(45,93,168,0)}}' +
      '.pixup-modal .pixup-hint{border-color:#2D5DA8 !important;animation:pixup-pulse 1.6s ease-out infinite}' +
      '@media (prefers-reduced-motion:reduce){.pixup-modal .pixup-hint{animation:none;box-shadow:0 0 0 3px rgba(45,93,168,.35)}}' +
      /* "Leave without saving?" */
      '.pixup-leave{position:absolute;inset:0;z-index:7;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(18,26,40,.55)}' +
      '.pixup-leavebox{width:100%;max-width:400px;padding:22px 22px 18px;border-radius:18px;background:#fff;box-shadow:0 16px 50px rgba(18,26,40,.4);text-align:center}' +
      '.pixup-leavebox b{display:block;font-family:"Bricolage Grotesque","Figtree",sans-serif;font-size:1.25rem;font-weight:800;line-height:1.2}' +
      '.pixup-leavebox p{margin:8px 0 18px;font-size:.95rem;color:#52607A}' +
      '.pixup-helplink{display:block;width:100%;margin:10px 0 0;padding:8px 4px;border:0;background:none;color:#52607A;font:600 .92rem/1.35 Figtree,system-ui,sans-serif;text-align:center;cursor:pointer}' +
      '.pixup-helplink u{color:#2D5DA8;text-underline-offset:3px}' +
      '.pixup-helpmail{display:flex;align-items:center;justify-content:center;gap:10px;text-decoration:none !important}.pixup-helpaddr{color:#22314A;overflow-wrap:anywhere}' +
      '.pixup-leavebtns .pixup-emailalt{display:flex;align-items:center;justify-content:center;gap:10px;min-height:50px;padding:0 16px;border:2px solid #2D5DA8;border-radius:14px;background:#fff;color:#2D5DA8;font:800 1rem/1.2 Figtree,system-ui,sans-serif;cursor:pointer}' +
      '.pixup-leavebtns .pixup-emailalt:hover{background:#F4F7FC}.pixup-leavebtns [disabled]{opacity:.7;cursor:wait}' +
      '.pixup-leavebtns{display:flex;flex-direction:column;gap:6px}.pixup-leavebtns .pixup-add{width:100%;padding:0 16px}.pixup-leavebtns .pixup-ghost{min-height:44px}' +
      '.pixup-cropcv{display:block;margin:0 auto 10px;border-radius:6px;touch-action:none;cursor:move;max-width:none}' +
      '.pixup-zoomrow{display:flex;align-items:center;gap:8px;font-size:.86rem;font-weight:700;color:#52607A;margin-bottom:6px}' +
      '.pixup-zoomrow input{flex:1;min-width:0;accent-color:#2D5DA8;height:28px}' +
      '.pixup-zoomrow button{flex:none;width:34px;height:34px;padding:0;border-radius:50%;border:1.5px solid #C9D6EA;background:#fff;color:#22314A;font:inherit;font-weight:800;font-size:1.15rem;line-height:1;cursor:pointer}' +
      '.pixup-crop .pixup-stars{display:block;text-align:center;margin-bottom:10px}' +
      '.pixup-crophead{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}.pixup-crophead h3{margin:0}' +
      '.pixup-crophead button{flex:none;width:36px;height:36px;padding:0;border:0;border-radius:50%;background:#F3EDE0;color:#22314A;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
      '.pixup-cropbtns{display:flex;gap:10px;margin-top:14px}.pixup-cropbtns button{flex:1;min-height:48px}' +
      '.pixup-cropbtns .pixup-ghost{border:1.5px solid #C9D6EA;border-radius:12px;background:#fff;color:#22314A}' +
      '.pixup-crop .pixup-big{background:#2D5DA8;color:#fff}.pixup-crop .pixup-big:hover{background:#234A87}' +
      '.pixup-sheet{position:absolute;inset:0;z-index:4;display:flex;align-items:flex-start;justify-content:center;overflow-y:auto;' +
        'padding:calc(10px + var(--pixup-top)) 10px calc(10px + env(safe-area-inset-bottom));background:rgba(18,26,40,.55)}' +
      '.pixup-sheet[hidden],.pixup-pop[hidden]{display:none}' +
      '.pixup-sheet .pixup-crop{width:100%;max-width:520px;padding:16px;border:0;border-radius:16px;background:#fff;box-shadow:0 10px 36px rgba(18,26,40,.45)}' +
      /* side panel: layout tiles */
      '.pixup-side>*{flex-shrink:0}' +
      '.pixup-tiles{display:grid;grid-template-columns:1fr 1fr;gap:10px}' +
      '.pixup-tiles button{display:flex;flex-direction:column;align-items:center;gap:8px;padding:14px 8px 11px;border:1.5px solid #E4DCCB;border-radius:12px;background:#fff;color:#22314A;font:inherit;font-weight:700;font-size:.95rem;cursor:pointer}' +
      '.pixup-tiles svg{width:64px;height:46px}.pixup-tiles rect{fill:#fff;stroke:#8C97A8;stroke-width:1.5}.pixup-tiles rect.f{fill:#C9D1DC;stroke:none}' +
      '.pixup-tiles button:hover{border-color:#2D5DA8}' +
      '.pixup-tiles button[aria-pressed="true"]{background:#E9F0FA;border-color:#2D5DA8;color:#2D5DA8}.pixup-tiles button[aria-pressed="true"] rect.f{fill:#9DB3D6}' +
      '.pixup-cur{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:11px 0 0;font-size:.86rem;color:#52607A}' +
      '.pixup-cur b{color:#22314A}.pixup-cur button{flex:none;border:0;background:none;padding:4px 0;color:#2D5DA8;font:inherit;font-weight:800;cursor:pointer;text-decoration:underline;text-underline-offset:2px}' +
      /* "See all designs" card */
      '.pixup-browse{display:flex;align-items:center;gap:12px;width:100%;padding:10px 12px 10px 10px;border:1.5px solid #F0D58A;border-radius:14px;background:#FFF8E4;color:#22314A;font:inherit;text-align:left;cursor:pointer;transition:border-color .15s,box-shadow .15s}' +
      '.pixup-browse:hover{border-color:#2D5DA8;box-shadow:0 2px 10px rgba(45,93,168,.15)}.pixup-browse:focus-visible{outline:2px solid #2D5DA8;outline-offset:2px}' +
      '.pixup-browse>svg{flex:none;color:#2D5DA8;transition:transform .15s}.pixup-browse:hover>svg{transform:translateX(2px)}' +
      '.pixup-peek{position:relative;flex:none;width:96px;height:58px}' +
      '.pixup-peek span{position:absolute;top:6px;width:46px;height:46px;display:flex;align-items:center;justify-content:center}' +
      '.pixup-peek span:nth-child(1){left:0;transform:rotate(-9deg)}.pixup-peek span:nth-child(2){left:25px;top:2px;z-index:2}.pixup-peek span:nth-child(3){left:50px;transform:rotate(9deg)}' +
      '.pixup-peek canvas{display:block;border:2px solid #fff;border-radius:3px;box-shadow:0 2px 6px rgba(34,49,74,.3);background:#fff}' +
      '.pixup-browsetxt{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.pixup-browsetxt b{font-size:.98rem;font-weight:800;color:#2D5DA8}' +
      '.pixup-browsetxt small{font-size:.8rem;color:#52607A;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      /* quick mode: size row and "Choose your size" window */
      '.pixup-sizebtn{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;padding:10px 12px;border:1.5px solid #E4DCCB;border-radius:12px;background:#fff;color:#22314A;font:inherit;text-align:left;cursor:pointer}' +
      '.pixup-sizebtn:hover{border-color:#2D5DA8}.pixup-sizebtn b{display:block;font-size:.95rem;font-weight:800}.pixup-sizebtn small{display:block;font-size:.8rem;color:#52607A}' +
      '.pixup-sizebtn em{flex:none;font-style:normal;font-weight:800;font-size:.86rem;color:#2D5DA8;text-decoration:underline;text-underline-offset:2px}' +
      '.pixup-pick.pixup-sizes{align-items:center}.pixup-sizes .pixup-pickbox{max-height:100%;max-width:940px}.pixup-sizes .pixup-grid{flex:0 1 auto}' +
      '.pixup-sizelead{flex:none;margin:0;padding:0 22px 4px;font-size:.9rem;color:#52607A}' +
      '.pixup-grid.pixup-sizegrid{grid-template-columns:repeat(auto-fit,minmax(190px,1fr))}' +
      '.pixup-scard{position:relative;padding:12px 12px 14px;gap:3px}' +
      '.pixup-simg{display:flex;align-items:center;justify-content:center;width:100%;height:132px;margin-bottom:8px;border-radius:10px;background:#F6F3EC;overflow:hidden}' +
      '.pixup-simg img{max-width:88%;max-height:88%;object-fit:contain}.pixup-simg canvas{display:block;box-shadow:0 1px 3px rgba(34,49,74,.22),0 6px 14px rgba(34,49,74,.12)}' +
      '.pixup-scard b{font-size:.98rem;font-weight:800}.pixup-scard .pixup-snote{color:#22314A}' +
      '.pixup-sprice{margin-top:4px;font-size:.95rem}.pixup-sprice strong{color:#C2412F;font-weight:800}.pixup-sprice s{color:#52607A;font-size:.85rem}' +
      '.pixup-scta{display:block;width:100%;margin-top:8px;padding:9px 0;border-radius:10px;background:#2D5DA8;color:#fff;font-weight:800;font-size:.92rem}' +
      '.pixup-scard[aria-pressed="true"] .pixup-scta{background:#E9F0FA;color:#2D5DA8}' +
      '.pixup-sbadge{position:absolute;top:10px;left:10px;z-index:1;padding:3px 9px;border-radius:999px;background:#FFC845;color:#22314A;font-size:.72rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase}' +
      '@media (max-width:820px){.pixup-pick.pixup-sizes{align-items:stretch}.pixup-sizelead{padding:0 16px 2px}.pixup-grid.pixup-sizegrid{grid-template-columns:1fr 1fr}.pixup-simg{height:96px}.pixup-scard{padding:10px 8px 12px}}' +
      /* the design window */
      '.pixup-pick{position:absolute;inset:0;z-index:4;display:flex;align-items:stretch;justify-content:center;padding:18px;background:rgba(18,26,40,.55)}' +
      '.pixup-pick[hidden]{display:none}' +
      '.pixup-pickbox{display:flex;flex-direction:column;width:100%;max-width:1000px;min-height:0;border-radius:16px;background:#fff;box-shadow:0 10px 36px rgba(18,26,40,.45);overflow:hidden}' +
      '.pixup-pickhead,.pixup-picktabs,.pixup-chips{flex:none}.pixup-pickhead{display:flex;align-items:center;justify-content:space-between;padding:12px 14px 10px 22px}' +
      '.pixup-pickhead b{font-family:"Bricolage Grotesque","Figtree",sans-serif;font-size:1.2rem;font-weight:800}' +
      '.pixup-picktabs{display:flex;margin:0 22px;border-bottom:1.5px solid #E4DCCB}' +
      '.pixup-picktabs button{flex:1;min-height:46px;border:0;background:none;color:#52607A;font:inherit;font-weight:700;font-size:.98rem;cursor:pointer;border-bottom:3px solid transparent;margin-bottom:-1.5px}' +
      '.pixup-picktabs button[aria-selected="true"]{color:#2D5DA8;border-bottom-color:#2D5DA8}' +
      '.pixup-chips{display:flex;gap:8px;padding:12px 22px 4px;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch}.pixup-chips::-webkit-scrollbar{display:none}' +
      '.pixup-chips button{flex:none;min-height:36px;padding:0 14px;border-radius:18px;border:1.5px solid #E4DCCB;background:#fff;color:#22314A;font:inherit;font-weight:700;font-size:.86rem;cursor:pointer;white-space:nowrap}' +
      '.pixup-chips button[aria-pressed="true"]{background:#2D5DA8;border-color:#2D5DA8;color:#fff}' +
      '.pixup-grid{flex:1 1 auto;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;display:grid;grid-template-columns:repeat(auto-fill,minmax(168px,1fr));align-content:start;gap:14px;padding:14px 22px 22px}' +
      '.pixup-dcard{display:flex;flex-direction:column;align-items:center;gap:2px;padding:12px 10px 11px;border:1.5px solid transparent;border-radius:12px;background:#fff;box-shadow:0 1px 3px rgba(34,49,74,.16),0 2px 10px rgba(34,49,74,.08);color:#22314A;font:inherit;cursor:pointer;text-align:center}' +
      '.pixup-dcard:hover{border-color:#9DB3D6}.pixup-dcard[aria-pressed="true"]{border-color:#2D5DA8;background:#F4F8FE}' +
      '.pixup-thumb{display:flex;align-items:center;justify-content:center;width:100%;height:118px;margin-bottom:8px}' +
      '.pixup-thumb canvas{display:block;box-shadow:0 1px 3px rgba(34,49,74,.25)}' +
      '.pixup-dcard b{font-size:.9rem;font-weight:700;line-height:1.25}.pixup-dcard small{font-size:.8rem;color:#52607A}' +
      '.pixup-none{grid-column:1/-1;margin:20px 0;text-align:center;color:#52607A}.pixup-none button{border:0;background:none;color:#2D5DA8;font:inherit;font-weight:800;text-decoration:underline;cursor:pointer}' +
      '@media (max-width:820px){.pixup-wide{display:none}.pixup-pick{padding:0}.pixup-pickbox{max-width:none;border-radius:0;padding-top:var(--pixup-top)}' +
        '.pixup-pickhead{padding:10px 10px 6px 16px}.pixup-picktabs{margin:0 16px}.pixup-chips{padding:10px 16px 2px}' +
        '.pixup-grid{grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:10px;padding:12px 16px calc(16px + env(safe-area-inset-bottom))}' +
        '.pixup-thumb{height:100px}.pixup-tiles button{padding:10px 6px 8px}.pixup-tiles svg{width:52px;height:38px}}' +
      /* "Choose your template": big cards, a photo-count pill, section headings and jump chips */
      '.pixup-tpllead{flex:none;margin:0;padding:0 22px 2px;font-size:.92rem;color:#52607A}' +
      '.pixup-chips button[data-jump]{min-height:38px}' +
      '.pixup-tplgrid{grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:16px;padding-top:6px}.pixup-tcard{min-width:0}.pixup-tcard canvas{max-width:100%}' +
      '.pixup-gsec{grid-column:1/-1;margin:14px 0 -2px;font-family:"Bricolage Grotesque","Figtree",sans-serif;font-size:1.12rem;font-weight:800;color:#22314A}' +
      '.pixup-gsec:first-child{margin-top:4px}' +
      '.pixup-tcard{padding:14px 12px 14px;background:#F7F9FB;box-shadow:none;border:1.5px solid #E6ECF2;gap:3px}' +
      '.pixup-tcard:hover{border-color:#9DB3D6;background:#fff}' +
      '.pixup-tcard .pixup-thumb{position:relative;height:170px;margin-bottom:10px}' +
      '.pixup-tcard .pixup-npill{display:none}.pixup-npill{position:absolute;left:50%;bottom:6px;transform:translateX(-50%);padding:2px 9px;border-radius:999px;background:rgba(255,255,255,.95);color:#22314A;font-style:normal;font-size:.76rem;font-weight:700;white-space:nowrap;box-shadow:0 1px 4px rgba(34,49,74,.25)}' +
      '.pixup-tsel{margin-top:8px;padding:7px 20px;border-radius:999px;background:#E9EEF4;color:#22314A;font-weight:800;font-size:.86rem}' +
      '.pixup-tcard:hover .pixup-tsel,.pixup-tcard[aria-pressed="true"] .pixup-tsel{background:#2D5DA8;color:#fff}' +
      '.pixup-tplcur{gap:12px}.pixup-peek1{flex:none;display:flex;align-items:center;justify-content:center;width:84px;height:62px}' +
      '.pixup-peek1 canvas{display:block;border-radius:3px;box-shadow:0 1px 4px rgba(34,49,74,.3);background:#fff}' +
      '.pixup-tplchg{margin-left:auto;padding:6px 14px;border-radius:999px;background:#2D5DA8;color:#fff;font-style:normal;font-weight:800;font-size:.85rem}' +
      '@media (max-width:820px){.pixup-tpllead{padding:0 16px 2px;font-size:.86rem}.pixup-tplgrid{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}' +
        '.pixup-tcard{padding:10px 8px 12px}.pixup-tcard .pixup-thumb{height:126px;margin-bottom:6px}.pixup-tcard b{font-size:.84rem}.pixup-tsel{margin-top:6px;padding:6px 16px}}' +
      /* the start flow's design window: back to the sizes */
      '.pixup-pickhead b{flex:1}.pixup-pickback{flex:none;display:flex;align-items:center;gap:2px;margin:0 10px 0 -8px;min-height:40px;padding:0 10px 0 4px;border:0;border-radius:20px;background:none;color:#2D5DA8;font:inherit;font-weight:800;font-size:.92rem;cursor:pointer}.pixup-pickback:hover{background:#E9F0FA}' +
      PHONE_CSS + (TIN ? TIN_CSS : '') + (BACK ? BACK_CSS : '');
    document.head.appendChild(st);
    popEl = modal.querySelector('.pixup-pop'); sheetEl = modal.querySelector('.pixup-sheet'); pickEl = modal.querySelector('.pixup-pick:not(.pixup-sizes)'); sizesEl = modal.querySelector('.pixup-sizes'); layEl = modal.querySelector('.pixup-lay'); overlayForPreview();
    stage = modal.querySelector('.pixup-stage'); frame = modal.querySelector('.pixup-frame');
    canvas = modal.querySelector('.pixup-canvas'); ctx = canvas.getContext('2d');
    overlayEl = modal.querySelector('.pixup-overlay'); starsEl = modal.querySelector('.pixup-stars'); fitChip = modal.querySelector('.pixup-fitchip');
    overlayEl.onerror = function () { overlayEl.hidden = true; };
    sideEl = modal.querySelector('.pixup-side'); busyEl = modal.querySelector('.pixup-busy');
    barEl = modal.querySelector('.pixup-bar i'); msgEl = modal.querySelector('.pixup-warn');
    if (TIN) initTinDom();
    if (BACK) initBack();

    modal.addEventListener('click', function (e) { if (popOn && e.target !== canvas) { popOn = false; draw(); } }, true);
    modal.addEventListener('click', onClick);
    modal.addEventListener('input', onInput);
    modal.addEventListener('change', function (e) { if (e.target.getAttribute('data-f') === 'snap') onInput(e); });
    /* the new text's "Your text here" is selected as soon as the box is tapped, so typing replaces it */
    modal.addEventListener('focusin', function (e) {
      var ta = e.target;
      if (ta.matches && ta.matches('textarea[data-f="text"]') && ta.value === 'Your text here') setTimeout(function () { try { ta.select(); } catch (err) {} }, 0);
    });
    layEl.addEventListener('click', function (e) { if (e.target === layEl) closeLay(); });      /* a tap outside the box closes it */
    if (tinPanel) tinPanel.addEventListener('click', function (e) { if (e.target === tinPanel && tinPanel.classList.contains('is-3d')) close3D(); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden || busy || e.key !== 'Escape') return;
      if (step === 2) { if (is3D()) close3D(); else goStep(1); }
      else if (leaveOn) closeLeave(); else if (sizesOn) sizesBack(); else if (pickOn) closePicker(); else if (layOn) closeLay(); else if (cropMode) cancelCrop(); else askClose();
    });
    window.addEventListener('resize', function () {
      if (modal.hidden) return;
      if (sizesOn) { clearTimeout(szTimer); szTimer = setTimeout(sizeThumbs, 150); }      /* the size pictures follow the screen */
      var ph = isPhone(), flip = ph !== lastPhone;      /* turning a tablet, or a desktop window made narrow */
      if (step === 2) {
        if (flip) {
          lastPhone = ph; modal.classList.toggle('pixup-c', ph); tinTool = null;
          if (ph) close3D(); else { tinPanel.classList.remove('is-3d'); start3D(); }
          renderTinSide();
        }
        drawTinFlat(); if (T3 && T3.ready) T3.sized = false; return;
      }
      if (flip) { if (!ph) { tool = null; closeLay(); } refresh(); } else draw();      /* crop moves between popup and side panel */
      if (pickOn) renderThumbs();
    });
    bindPointer(); bindCrop();
  }
  function loadFonts() {
    if (fontsLoaded) return; fontsLoaded = true;
    var l = document.createElement('link'); l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@700&family=Playfair+Display:wght@700&display=swap';
    l.onload = function () { waitFonts().then(function () { if (modal && !modal.hidden) { draw(); } }); };
    document.head.appendChild(l);
  }
  function waitFonts() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all(FONTS.map(function (f) { return document.fonts.load(f.css.replace('%', 40)).catch(function () {}); }));
  }

  /* side panel: rebuilt whenever the selection, photos or layout change */
  function miniSvg(layout) {
    var w = design.tall ? 30 : 42, h = design.tall ? 42 : 30, g = 1;
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '" aria-hidden="true">' + cells(layout, design.tall).map(function (c) {
      return '<rect x="' + (c[0] * w + g / 2) + '" y="' + (c[1] * h + g / 2) + '" width="' + (c[2] * w - g) + '" height="' + (c[3] * h - g) + '" rx="1"/>';
    }).join('') + '</svg>';
  }
  /* pixels per inch needed for 5, 4, 3 and 2 stars (section settings) */
  var STARS = (CFG.stars && CFG.stars.length === 4 ? CFG.stars : [150, 115, 85, 60]).map(Number).sort(function (a, b) { return b - a; });
  function starsHtml(dpi) {
    var n = dpi >= STARS[0] ? 5 : dpi >= STARS[1] ? 4 : dpi >= STARS[2] ? 3 : dpi >= STARS[3] ? 2 : 1, st = '';
    for (var i = 1; i <= 5; i++) st += '<i class="' + (i <= n ? 'on' : '') + '">★</i>';
    return st + (CFG.minDpi > 0 && dpi < CFG.minDpi ? ' <em>may print blurry: make the crop box bigger or use a larger photo</em>' : '');
  }
  /* "See all designs": a card with three small previews (with the customer's own photo once there is one) */
  function peekList() {
    var n = design.slots.filter(function (s) { return s.photo; }).length || 1, pos = {};
    DESIGNS.forEach(function (l, i) { pos[l.id] = i; });
    return DESIGNS.filter(function (l) { return l !== design.layout && (geoFor(l, design.tall) || hasBoth); }).sort(function (a, b) {
      return ((geoFor(a, design.tall) ? 0 : 1) - (geoFor(b, design.tall) ? 0 : 1)) || ((a.n === n ? 0 : 1) - (b.n === n ? 0 : 1)) ||
        ((a.sort || 0) - (b.sort || 0)) || (pos[a.id] - pos[b.id]);
    }).slice(0, 3);
  }
  function browseHtml() {
    var list = peekList(); if (!list.length) return '';
    var first = pickTheme.concat(THEMES.map(function (t) { return t.slug; }).filter(function (t) { return pickTheme.indexOf(t) < 0; }));
    var names = first.slice(0, 3).map(themeName), sub = names.length ? names.join(', ') + (first.length > 3 ? ' & more' : '') : DESIGNS.length + ' designs to choose from';
    return '<div class="pixup-sec"><button type="button" class="pixup-browse" data-act="designs">' +
      '<span class="pixup-peek" aria-hidden="true">' + list.map(function (l) {
        return '<span><canvas data-l="' + esc(l.id) + '" data-t="' + ((geoFor(l, design.tall) ? design.tall : !design.tall) ? 1 : 0) + '"></canvas></span>';
      }).join('') + '</span>' +
      '<span class="pixup-browsetxt"><b>See all designs</b><small>' + esc(sub) + '</small></span>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button></div>';
  }
  function renderPeek() {
    if (!sideEl || !modal || modal.hidden) return;
    [].forEach.call(sideEl.querySelectorAll('.pixup-peek canvas[data-l], .pixup-peek1 canvas[data-l]'), thumb);
  }
  function renderSide() {
    var multi = slotCount(design.layout) > 1, h = '', cs = sel.type === 'slot' ? design.slots[sel.i] : null;
    if (cropMode && !(cs && cs.photo)) cropMode = false;
    lastPhone = isPhone(); modal.classList.toggle('pixup-c', lastPhone);
    sheetEl.hidden = true; sheetEl.textContent = '';
    if (cropMode) {
      var cropHtml = '<div class="pixup-sec pixup-ctx pixup-crop" role="group" aria-label="Crop photo"><div class="pixup-crophead"><h3>Crop photo</h3>' +
        '<button type="button" data-act="cropcancel" aria-label="Close crop"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<canvas class="pixup-cropcv"></canvas>' +
        '<div class="pixup-zoomrow"><span>Zoom</span><button type="button" data-act="zout" aria-label="Zoom out">&minus;</button>' +
        '<input type="range" data-f="z" min="' + (Math.floor(minZ(cs, rects(canvas.width, canvas.height)[sel.i]) * 100) / 100) + '" max="5" step="0.01" value="' + cs.z + '" aria-label="Zoom"><button type="button" data-act="zin" aria-label="Zoom in">+</button></div>' +
        '<span class="pixup-stars pixup-cropstars"></span>' +
        '<div class="pixup-btns"><button type="button" data-act="rotate">Rotate</button>' +
        '<button type="button" data-act="enhance" aria-pressed="' + !!cs.photo.enhance + '">Auto-enhance</button></div>' +
        '<p class="pixup-tip">The bright box is the part that prints. Drag it to move, or drag a corner to resize. Pull a corner out past the photo to show all of it.</p>' +
        '<div class="pixup-cropbtns"><button type="button" class="pixup-ghost" data-act="cropcancel">Cancel</button>' +
        '<button type="button" class="pixup-big" data-act="cropdone">Apply</button></div></div>';
      if (!lastPhone) { sideEl.innerHTML = cropHtml; return; }
      sheetEl.innerHTML = cropHtml; sheetEl.hidden = false;      /* phones: the crop opens in its own popup */
    }
    if (lastPhone) { sideEl.innerHTML = phoneSideHtml(); return; }
    h += '<div class="pixup-acts"><button type="button" class="pixup-big' + (noPhotoYet() ? ' pixup-hint' : '') + '" data-act="upload">' + ICON_UP + 'Upload photo</button>' +
         '<button type="button" class="pixup-big" data-act="addtext">' + ICON_T + '<span>Add text<span class="pixup-wide"> to the puzzle</span></span></button></div>' + helpLinkHtml();
    if (QUICK && curProd) h += '<div class="pixup-sec"><h3>Puzzle size</h3><button type="button" class="pixup-sizebtn" data-act="sizes">' +
      '<span><b>' + esc(curProd.title) + '</b>' + (curProd.sizeText ? '<small>Finished size ' + esc(curProd.sizeText) + '</small>' : '') + '</span><em>Change size</em></button></div>';
    if (hasBoth) {
      var lockO = oneOrient(design.layout), offO = ' disabled style="opacity:.45;cursor:not-allowed"';
      h += '<div class="pixup-sec"><h3>Orientation</h3><div class="pixup-seg"><button type="button" data-o="wide" aria-pressed="' + !design.tall + '"' + (lockO && design.tall ? offO : '') + '>Landscape</button><button type="button" data-o="tall" aria-pressed="' + design.tall + '"' + (lockO && !design.tall ? offO : '') + '>Portrait</button></div>' +
        (lockO ? '<p class="pixup-tip">' + esc(design.layout.name) + ' comes in ' + onlyName(design.layout) + ' only. Pick another design to switch.</p>' : '') + '</div>';
    }
    /* Template: what is on the puzzle now, and the way into "Choose your template" */
    var L = design.layout, ln = slotCount(L), curName = L.tpl ? esc(L.name) : multi ? 'Collage' : 'Full photo';
    h += '<div class="pixup-sec"><h3>Template</h3><button type="button" class="pixup-browse pixup-tplcur" data-act="designs">' +
      '<span class="pixup-peek1" aria-hidden="true"><canvas data-l="' + esc(L.id) + '" data-t="' + (design.tall ? 1 : 0) + '"></canvas></span>' +
      '<span class="pixup-browsetxt"><b>' + curName + '</b><small>' + ln + (ln > 1 ? ' photos' : ' photo') + ' · ' + (design.tall ? 'Portrait' : 'Landscape') + '</small></span>' +
      '<em class="pixup-tplchg">Change</em></button></div>';
    var t = sel.type === 'text' ? design.texts[sel.i] : null, s = sel.type === 'slot' ? design.slots[sel.i] : null;
    if (t) {
      h += '<div class="pixup-sec pixup-ctx"><h3>Edit text</h3><textarea data-f="text" rows="2" aria-label="Your text">' + esc(t.text) + '</textarea>' +
        '<div class="pixup-fonts">' + FONTS.map(function (f, i) { return '<button type="button" data-font="' + i + '" aria-pressed="' + (t.font === i) + '" style="font:' + f.css.replace('%', 15).replace(/"/g, '&quot;') + '">' + f.name + '</button>'; }).join('') + '</div>' +
        '<div class="pixup-colors">' + COLORS.map(function (c) { return '<button type="button" data-color="' + c + '" aria-pressed="' + (t.color === c) + '" aria-label="Colour ' + c + '" style="background:' + c + '"></button>'; }).join('') + '</div>' +
        '<label class="pixup-row"><span>Size</span><input type="range" data-f="size" min="0.03" max="0.3" step="0.005" value="' + t.size + '"></label>' +
        '<label class="pixup-row"><span>Angle</span><input type="range" data-f="rot" min="-45" max="45" step="1" value="' + t.rot + '"></label>' +
        '<label class="pixup-switch"><input type="checkbox" data-f="snap"' + (design.snap ? ' checked' : '') + '><span>Snap to guides<small>Lines text up with the center, thirds and edges, and keeps it level</small></span></label>' +
        '<div class="pixup-btns"><button type="button" data-act="deltext">Delete text</button></div>' +
        '<p class="pixup-tip">Drag the text in the preview to move it.</p></div>';
    } else if (s && s.photo) {
      h += '<div class="pixup-sec pixup-ctx pixup-ephoto"><h3>Edit photo</h3>' +
        '<div class="pixup-btns"><button type="button" data-act="crop">Crop</button><button type="button" data-act="rotate">Rotate</button>' +
        '<button type="button" data-act="enhance" aria-pressed="' + !!s.photo.enhance + '">Auto-enhance</button>' +
        '<button type="button" data-act="remove">Remove</button></div>' + bgRowHtml(sel.i) +
        '<p class="pixup-tip">Drag the photo in the preview to reposition it, or tap it for quick crop and remove buttons.</p></div>';
    }
    sideEl.innerHTML = h;
    renderPeek();
  }

  /* ---------- phones: tool buttons, a tool's panel, and the "Change layout" popup ---------- */
  var ICON_PHOTOS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6" width="15" height="13" rx="2"/><path d="M7 3h12a2 2 0 0 1 2 2v10"/><circle cx="8.5" cy="10.5" r="1.5"/><path d="M18 16l-4.5-4.5L5 19"/></svg>';
  var ICON_LAYOUT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M12 4v16M12 12h9"/></svg>';
  var ICON_TEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M8 8h8M12 8v9M10 17h4"/></svg>';
  var ICON_SIZE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="8" width="20" height="8" rx="1.5"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/></svg>';
  var ICON_LID = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="3"/><path d="M7 9h4M7 12h10M7 15h10"/></svg>';
  var ICON_3D = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/></svg>';
  var ICON_TRASH = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>';
  function toolHead(title, extra) {
    return '<div class="pixup-thead"><b>' + title + '</b><span>' + (extra || '') + '<button type="button" class="pixup-done" data-act="tdone">Done</button></span></div>';
  }
  function layoutName() { var L = design.layout; return L.tpl ? L.name : slotCount(L) > 1 ? 'Collage, ' + slotCount(L) + ' photos' : 'Full photo'; }
  function phoneSideHtml() {
    if (tool === 'text' && sel.type !== 'text') tool = null;
    if (tool === 'photo' && sel.type !== 'slot') tool = null;
    var t = tool === 'text' ? design.texts[sel.i] : null, s = tool === 'photo' ? design.slots[sel.i] : null;
    if (t) {
      return '<div class="pixup-tpanel" role="group" aria-label="Edit text">' +
        toolHead('Text', '<button type="button" class="pixup-tlink is-icon" data-act="deltext" aria-label="Delete this text">' + ICON_TRASH + '</button><button type="button" class="pixup-tlink" data-act="addtext">+ Add</button>') +
        '<textarea data-f="text" rows="2" aria-label="Your text">' + esc(t.text) + '</textarea>' +
        '<div class="pixup-fonts">' + FONTS.map(function (f, i) { return '<button type="button" data-font="' + i + '" aria-pressed="' + (t.font === i) + '" style="font:' + f.css.replace('%', 15).replace(/"/g, '&quot;') + '">' + f.name + '</button>'; }).join('') + '</div>' +
        '<div class="pixup-colors">' + COLORS.map(function (c) { return '<button type="button" data-color="' + c + '" aria-pressed="' + (t.color === c) + '" aria-label="Colour ' + c + '" style="background:' + c + '"></button>'; }).join('') + '</div>' +
        '<label class="pixup-row"><span>Size</span><input type="range" data-f="size" min="0.03" max="0.3" step="0.005" value="' + t.size + '"></label>' +
        '<label class="pixup-row"><span>Angle</span><input type="range" data-f="rot" min="-45" max="45" step="1" value="' + t.rot + '"></label></div>';
    }
    if (s) {
      var many = design.slots.length > 1;
      return '<div class="pixup-tpanel" role="group" aria-label="Edit photo">' + toolHead(many ? 'Photo ' + (sel.i + 1) + ' of ' + design.slots.length : 'Photo') +
        (s.photo
          ? '<div class="pixup-btns"><button type="button" data-act="replace">Replace</button><button type="button" data-act="crop">Crop</button><button type="button" data-act="rotate">Rotate</button>' +
            '<button type="button" data-act="enhance" aria-pressed="' + !!s.photo.enhance + '">Enhance</button><button type="button" data-act="remove">Remove</button></div>'
          : '<button type="button" class="pixup-big" data-act="replace" style="background:#2D5DA8;color:#fff">' + ICON_UP + 'Add a photo here</button>') +
        (s.photo ? bgRowHtml(sel.i) : '') +
        '<p class="pixup-tip">' + (many ? 'Tap a space on the puzzle to switch photos. Drag a photo to move it.' : 'Drag the photo on the puzzle to move it.') + '</p>' + helpLinkHtml() + '</div>';
    }
    var h = '<div class="pixup-tools">' +
      '<button type="button" data-act="tphoto"' + (noPhotoYet() ? ' class="pixup-hint"' : '') + '>' + ICON_PHOTOS + '<span>Photos</span></button>' +
      '<button type="button" data-act="tlayout">' + ICON_LAYOUT + '<span>Template</span><small>' + esc(design.layout.tpl ? design.layout.name : layoutName()) + '</small></button>' +
      '<button type="button" data-act="ttext">' + ICON_TEXT + '<span>Text</span></button>' +
      (QUICK && curProd ? '<button type="button" data-act="sizes">' + ICON_SIZE + '<span>Size</span><small>' + esc(curProd.title.replace(/\s*custom.*$/i, '')) + '</small></button>' : '') +
      '</div>' + helpLinkHtml();
    if (QUICK && curProd && curProd.price) h += '<p class="pixup-pline">' + esc(curProd.title) + ':' + (curProd.compare ? '<s>' + esc(curProd.compare) + '</s>' : ' ') + '<strong>' + esc(curProd.price) + '</strong></p>';
    return h;
  }
  function openLay() {
    var multi = slotCount(design.layout) > 1, lockO = oneOrient(design.layout), offO = ' disabled style="opacity:.45;cursor:not-allowed"';
    var names = THEMES.filter(function (t) { return DESIGNS.some(function (d) { return d.themes.indexOf(t.slug) > -1; }); }).map(function (t) { return t.name; });
    var h = '<div class="pixup-laybox"><div class="pixup-pickhead"><b>Change layout</b><button type="button" class="pixup-x" data-act="layclose" aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="pixup-laytiles">' +
      '<button type="button" data-pick="one" aria-pressed="' + !multi + '"><svg viewBox="0 0 64 46" aria-hidden="true"><rect x="1" y="1" width="62" height="44" rx="2"/><rect class="f" x="6" y="6" width="52" height="34" rx="1"/></svg>1 Photo</button>' +
      '<button type="button" data-pick="multi" aria-pressed="' + multi + '"><svg viewBox="0 0 64 46" aria-hidden="true"><rect x="1" y="1" width="62" height="44" rx="2"/><rect class="f" x="6" y="6" width="28" height="34" rx="1"/><rect class="f" x="37" y="6" width="21" height="15.5" rx="1"/><rect class="f" x="37" y="24.5" width="21" height="15.5" rx="1"/></svg>2+ Photos</button></div>' +
      (names.length ? '<p class="pixup-laynote">Both include our ' + esc(names.slice(0, 3).join(', ') + (names.length > 3 ? ' & more' : '')) + ' designs.</p>' : '');
    if (hasBoth) h += '<div class="pixup-layo"><h3>Orientation</h3><div class="pixup-seg"><button type="button" data-o="wide" aria-pressed="' + !design.tall + '"' + (lockO && design.tall ? offO : '') + '>Landscape</button><button type="button" data-o="tall" aria-pressed="' + design.tall + '"' + (lockO && !design.tall ? offO : '') + '>Portrait</button></div>' +
      (lockO ? '<p class="pixup-tip">' + esc(design.layout.name) + ' comes in ' + onlyName(design.layout) + ' only. Pick another design to switch.</p>' : '') + '</div>';
    layEl.innerHTML = h + '</div>'; layEl.hidden = false; layOn = true; popOn = false; draw();
    var b = layEl.querySelector('[data-act="layclose"]'); if (b) b.focus({ preventScroll: true });
  }
  function closeLay() { if (!layEl) return; layEl.hidden = true; layOn = false; }
  /* puzzle lines over the design, always on: the cut for the size chosen on the page */
  function syncOverlay() {
    var u = curOverlay();
    if ((overlayEl.getAttribute('data-src') || '') === u) return;
    overlayEl.setAttribute('data-src', u);
    if (u) { overlayEl.hidden = false; overlayEl.src = u; } else { overlayEl.hidden = true; overlayEl.removeAttribute('src'); }
  }
  function draw() {
    syncOverlay();
    var left = stage.parentNode;
    if (left.style.height) left.style.height = '';      /* phones: the preview takes the room the tools leave (PHONE_CSS) */
    var A = aspect(), r = stage.getBoundingClientRect(), pad = 12;
    var Wm = Math.max(60, r.width - pad * 2), Hm = Math.max(60, r.height - pad * 2);
    var Fw = Math.floor(Math.min(Wm, Hm * A)), Fh = Math.floor(Fw / A), dpr = Math.min(2, window.devicePixelRatio || 1);
    frame.style.width = Fw + 'px'; frame.style.height = Fh + 'px';
    var cw = Math.round(Fw * dpr), ch = Math.round(Fh * dpr);
    if (canvas.width !== cw || canvas.height !== ch) { canvas.width = cw; canvas.height = ch; }
    paint(ctx, cw, ch, false);
    /* crop / remove buttons sit at the bottom of the selected photo */
    var ps = sel.type === 'slot' ? design.slots[sel.i] : null;
    if (ps && ps.photo && !dragging && !cropMode && popOn && popSlot === sel.i) {
      var pr = rects(cw, ch)[sel.i], pa = pr.rot * Math.PI / 180, bh = Math.abs(pr.w * Math.sin(pa)) + Math.abs(pr.h * Math.cos(pa));
      popEl.style.left = clamp(pr.x + pr.w / 2, 0, cw) / dpr + 'px';
      popEl.style.top = Math.min((pr.y + pr.h / 2 + bh / 2) / dpr - 10, Fh - 6) + 'px'; popEl.hidden = false;
    } else popEl.hidden = true;
    if (design.tall) { overlayEl.style.width = Fh + 'px'; overlayEl.style.height = Fw + 'px'; overlayEl.style.transform = 'translate(-50%,-50%) rotate(90deg)'; }
    else { overlayEl.style.width = Fw + 'px'; overlayEl.style.height = Fh + 'px'; overlayEl.style.transform = 'translate(-50%,-50%)'; }
    /* resolution stars: the weakest photo sets the score */
    var rs = rects(cw, ch), low = Infinity;
    design.slots.forEach(function (s, i) { if (s.photo) low = Math.min(low, slotDpi(s, rs[i], cw)); });
    if (low === Infinity || !dims().inches) { starsEl.hidden = true; }
    else {
      starsEl.innerHTML = 'Photo quality ' + starsHtml(low);
      starsEl.hidden = false;
    }
    /* "Show whole photo" when the window trims a good part of the photo, "Fill the space" once it is zoomed out */
    var fi = fitSlot(), fs = fi > -1 ? fitState(design.slots[fi], rs[fi]) : null;
    if (!ZOOM_OUT || !fs || (!fs.trimmed && !fs.whole)) fitChip.hidden = true;
    else {
      fitChip.hidden = false; fitChip.setAttribute('data-act', fs.whole ? 'fill' : 'whole'); fitChip.setAttribute('aria-pressed', fs.whole);
      fitChip.textContent = fs.whole ? (design.slots.length > 1 ? 'Fill the space' : 'Fill the puzzle') : 'Show whole photo';
    }
    if (cropMode) drawCrop();
    mirrorSoon(canvas, 'main');
  }
  /* ---------- session replays (Propel Replays and the like) ----------
     Replay apps copy the page's code and replay it later; they never see what a <canvas> has painted, so the
     preview (and the customer's photo in it) comes back empty. So each preview canvas also carries a small
     copy of itself as its CSS background, refreshed a moment after the customer stops changing things. The
     live page never shows it (the canvas paints over it); a replay, where the canvas is empty, does. */
  var mirrorT = {};
  function mirrorSoon(cv, key) {
    if (!cv) return;
    clearTimeout(mirrorT[key]);
    mirrorT[key] = setTimeout(function () {
      if (!cv.width || !cv.height || !modal || modal.hidden || !cv.isConnected) return;
      try {
        var k = Math.min(1, 560 / Math.max(cv.width, cv.height)), c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(cv.width * k)); c.height = Math.max(1, Math.round(cv.height * k));
        var g = c.getContext('2d'); g.fillStyle = '#FFFFFF'; g.fillRect(0, 0, c.width, c.height);
        g.drawImage(cv, 0, 0, c.width, c.height);
        var u = c.toDataURL('image/jpeg', 0.66);
        if (cv.__pixMirror === u) return;
        cv.__pixMirror = u;
        cv.style.backgroundImage = 'url("' + u + '")'; cv.style.backgroundSize = '100% 100%'; cv.style.backgroundRepeat = 'no-repeat';
      } catch (e) {}      /* a canvas that can't be read back: no replay picture, nothing else changes */
    }, 1200);
  }
  function drawCrop() {
    var cv = modal.querySelector('.pixup-cropcv'), s = sel.type === 'slot' ? design.slots[sel.i] : null;
    if (!cv || !s || !s.photo) { cropInfo = null; return; }
    var maxH = cv.closest('.pixup-sheet') ? Math.min(window.innerHeight * 0.42, 440) : 250;
    var P = s.photo, r = rects(canvas.width, canvas.height)[sel.i], G = slotGeom(s, r), iw = G.iw, ih = G.ih, A = r.w / r.h;
    /* the view covers the largest the box can get (the whole photo with its edges), so it never jumps while dragging */
    var VW = ZOOM_OUT ? Math.max(iw, ih * A) : iw, VH = ZOOM_OUT ? VW / A : ih, x0 = (VW - iw) / 2, y0 = (VH - ih) / 2;
    var f = Math.min((cv.parentNode.clientWidth - 32) / VW, maxH / VH), dpr = Math.min(2, window.devicePixelRatio || 1), F = f * dpr;
    var w = Math.round(VW * F), h = Math.round(VH * F);
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; cv.style.width = VW * f + 'px'; cv.style.height = VH * f + 'px'; }
    var g = cv.getContext('2d');
    g.save(); g.translate(w / 2, h / 2); g.scale(F, F); paintBg(g, s, VW, VH); g.restore();      /* what the uncovered edges would show */
    g.save(); g.translate(w / 2, h / 2); g.rotate(P.rot * Math.PI / 180); g.scale(F, F);
    g.drawImage(P.enhance && P.enh ? P.enh : P.work, -P.work.width / 2, -P.work.height / 2); g.restore();
    var cx = iw / 2 - s.ox, cy = ih / 2 - s.oy, bx = (x0 + cx - G.vw / 2) * F, by = (y0 + cy - G.vh / 2) * F, bw = G.vw * F, bh = G.vh * F, L = 13 * dpr;
    g.fillStyle = 'rgba(18,26,40,.6)'; g.beginPath(); g.rect(0, 0, w, h); g.rect(bx, by, bw, bh); g.fill('evenodd');
    g.strokeStyle = '#fff'; g.lineWidth = 1.5 * dpr; g.setLineDash([5 * dpr, 4 * dpr]); g.strokeRect(bx, by, bw, bh); g.setLineDash([]);
    g.lineWidth = 4 * dpr; g.lineCap = 'round'; g.beginPath();
    [[bx, by, 1, 1], [bx + bw, by, -1, 1], [bx, by + bh, 1, -1], [bx + bw, by + bh, -1, -1]].forEach(function (c) {
      g.moveTo(c[0] + c[2] * L, c[1]); g.lineTo(c[0], c[1]); g.lineTo(c[0], c[1] + c[3] * L);
    });
    g.stroke();
    cropInfo = { f: f, iw: iw, ih: ih, A: A, cx: cx, cy: cy, w: G.vw, h: G.vh, x0: x0, y0: y0 };
    mirrorSoon(cv, 'crop');
    var se = modal.querySelector('.pixup-cropstars'), d = slotDpi(s, r, canvas.width);
    if (se) se.innerHTML = d ? 'Photo quality ' + starsHtml(d) : '';
  }
  function bindCrop() {
    function at(e, cv) { var b = cv.getBoundingClientRect(); return { x: (e.clientX - b.left) / cropInfo.f - cropInfo.x0, y: (e.clientY - b.top) / cropInfo.f - cropInfo.y0 }; }      /* in photo pixels */
    modal.addEventListener('pointerdown', function (e) {
      var cv = e.target.closest && e.target.closest('.pixup-cropcv'), s = sel.type === 'slot' ? design.slots[sel.i] : null;
      if (!cv || busy || !cropInfo || !s || !s.photo) return;
      e.preventDefault(); try { cv.setPointerCapture(e.pointerId); } catch (err) {}
      var I = cropInfo, p = at(e, cv), x0 = I.cx - I.w / 2, x1 = I.cx + I.w / 2, y0 = I.cy - I.h / 2, y1 = I.cy + I.h / 2, tol = 24 / I.f;
      var nx = Math.abs(p.x - x0) < tol ? -1 : Math.abs(p.x - x1) < tol ? 1 : 0, ny = Math.abs(p.y - y0) < tol ? -1 : Math.abs(p.y - y1) < tol ? 1 : 0;
      if (nx && ny) cropDrag = { kind: 'size', ax: nx < 0 ? x1 : x0, ay: ny < 0 ? y1 : y0, dx: nx, dy: ny };
      else if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1) cropDrag = { kind: 'move', x: p.x, y: p.y, ox: s.ox, oy: s.oy };
      else cropDrag = null;
    });
    modal.addEventListener('pointermove', function (e) {
      var cv = modal.querySelector('.pixup-cropcv');
      if (!cropDrag || !cropInfo || !cv) return;
      var I = cropInfo, D = cropDrag, s = design.slots[sel.i], p = at(e, cv);
      if (D.kind === 'move') { s.ox = D.ox - (p.x - D.x); s.oy = D.oy - (p.y - D.y); }
      else {
        /* the box can grow past the photo's edges, up to showing the whole photo */
        var full = Math.min(I.iw, I.ih * I.A), most = ZOOM_OUT ? Math.max(I.iw, I.ih * I.A) : full;
        var lim = Math.min(D.dx > 0 ? I.iw + I.x0 - D.ax : D.ax + I.x0, (D.dy > 0 ? I.ih + I.y0 - D.ay : D.ay + I.y0) * I.A);
        var w = clamp(Math.max((p.x - D.ax) * D.dx, (p.y - D.ay) * D.dy * I.A), full / 5, Math.max(full / 5, Math.min(most, lim)));
        s.z = full / w; s.ox = I.iw / 2 - (D.ax + D.dx * w / 2); s.oy = I.ih / 2 - (D.ay + D.dy * w / I.A / 2);
      }
      draw(); syncSliders();
    });
    function end() { cropDrag = null; }
    modal.addEventListener('pointerup', end); modal.addEventListener('pointercancel', end);
  }
  function startCrop(s) {
    cropSnap = { P: s.photo, rot: s.photo.rot, enhance: s.photo.enhance, slots: design.slots.map(function (x) { return { z: x.z, ox: x.ox, oy: x.oy, bg: x.bg }; }) };
    cropMode = true; refresh(); sideEl.scrollTop = 0;
  }
  function cancelCrop() {
    var c = cropSnap;
    if (c && c.slots.length === design.slots.length) {
      c.P.rot = c.rot; c.P.enhance = c.enhance; if (c.enhance) ensureEnhanced(c.P);
      design.slots.forEach(function (x, i) { x.z = c.slots[i].z; x.ox = c.slots[i].ox; x.oy = c.slots[i].oy; x.bg = c.slots[i].bg; });
    }
    cropSnap = null; cropMode = false; refresh();
  }
  function refresh() { renderSide(); draw(); backShow(); }

  /* ---------- pointer: drag photos and text, pinch or scroll to zoom ---------- */
  function pos(e) { var b = canvas.getBoundingClientRect(); return { x: (e.clientX - b.left) * canvas.width / b.width, y: (e.clientY - b.top) * canvas.height / b.height }; }
  function hitText(p) {
    for (var i = design.texts.length - 1; i >= 0; i--) {
      var t = design.texts[i], b = textBox(ctx, t, canvas.height), a = -t.rot * Math.PI / 180;
      var dx = p.x - t.x * canvas.width, dy = p.y - t.y * canvas.height;
      var lx = dx * Math.cos(a) - dy * Math.sin(a), ly = dx * Math.sin(a) + dy * Math.cos(a), pad = b.size * 0.3;
      if (Math.abs(lx) <= b.w / 2 + pad && Math.abs(ly) <= b.h / 2 + pad) return i;
    }
    return -1;
  }
  function hitSlot(p) {
    var rs = rects(canvas.width, canvas.height);
    for (var i = rs.length - 1; i >= 0; i--) if (inRect(p, rs[i])) return i;      /* top-most window first */
    return -1;
  }
  function bindPointer() {
    var ptrs = {}, pinch = null, drag = null, moved = false, wasPop = false;
    canvas.addEventListener('pointerdown', function (e) {
      if (busy) return;
      if (!Object.keys(ptrs).length) { wasPop = popOn; popOn = false; }      /* hidden while pressing or dragging */
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(ptrs), p = pos(e);
      if (ids.length === 2) {
        var a = ptrs[ids[0]], b = ptrs[ids[1]];
        if (sel.type === 'slot' && design.slots[sel.i] && design.slots[sel.i].photo) pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, z: design.slots[sel.i].z };
        else if (sel.type === 'text') pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, size: design.texts[sel.i].size };
        drag = null; return;
      }
      moved = false;
      var ti = hitText(p), before = sel.type + sel.i;
      if (ti > -1 || hitSlot(p) !== popSlot) wasPop = false;
      if (ti > -1) { sel = { type: 'text', i: ti }; drag = { kind: 'text', p: p, x: design.texts[ti].x, y: design.texts[ti].y }; }
      else {
        var si = hitSlot(p); if (si < 0) return;
        sel = { type: 'slot', i: si };
        var s = design.slots[si];
        var sr = rects(canvas.width, canvas.height)[si];
        drag = s.photo ? { kind: 'pan', p: p, ox: s.ox, oy: s.oy, sc: slotGeom(s, sr).sc, rot: sr.rot * Math.PI / 180 } : { kind: 'empty' };
      }
      if (before !== sel.type + sel.i) { cropMode = false; refresh(); var cx = sideEl.querySelector('.pixup-ctx'); if (cx) cx.scrollIntoView({ block: 'nearest' }); } else draw();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(ptrs);
      if (pinch && ids.length >= 2) {
        var a = ptrs[ids[0]], b = ptrs[ids[1]], f = Math.hypot(a.x - b.x, a.y - b.y) / pinch.d;
        if (pinch.z) design.slots[sel.i].z = clamp(pinch.z * f, 0.01, 5); else design.texts[sel.i].size = clamp(pinch.size * f, 0.03, 0.3);
        moved = true; dragging = true; draw(); syncSliders(); return;
      }
      if (!drag || drag.kind === 'empty') return;
      var p = pos(e), dx = p.x - drag.p.x, dy = p.y - drag.p.y;
      if (Math.abs(dx) + Math.abs(dy) > 5) { moved = true; dragging = true; }
      if (drag.kind === 'text') {
        var t = design.texts[sel.i], nx = clamp(drag.x + dx / canvas.width, 0.02, 0.98), ny = clamp(drag.y + dy / canvas.height, 0.02, 0.98);
        guides = null;
        if (design.snap && moved) { var sn = snapText(t, nx, ny); nx = sn.x; ny = sn.y; guides = sn.g; }
        t.x = nx; t.y = ny; if (moved) t.edited = true;
      }
      else {      /* pan in the window's own (possibly turned) direction */
        var s = design.slots[sel.i], ca = Math.cos(-drag.rot), sa = Math.sin(-drag.rot);
        s.ox = drag.ox + (dx * ca - dy * sa) / drag.sc; s.oy = drag.oy + (dx * sa + dy * ca) / drag.sc;
      }
      draw();
    });
    function up(e) {
      delete ptrs[e.pointerId];
      if (Object.keys(ptrs).length < 2) pinch = null;
      if (!Object.keys(ptrs).length) drag = drag && drag.kind === 'empty' ? drag : null;
      if (dragging || guides) { dragging = false; guides = null; draw(); }
    }
    canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up);
    canvas.addEventListener('click', function () {
      if (busy || moved) { drag = null; return; }
      if (drag && drag.kind === 'empty') { drag = null; pendingSlot = sel.i; pickFile(); return; }      /* tap an empty space to fill it */
      drag = null;
      if (isPhone() && sel.type === 'text') { if (tool !== 'text') { tool = 'text'; refresh(); } return; }      /* phones: tap text to edit it */
      var s = sel.type === 'slot' ? design.slots[sel.i] : null;
      if (s && s.photo) { popOn = !wasPop; popSlot = sel.i; draw(); }      /* tap a photo: show (or hide) crop and remove */
    });
    canvas.addEventListener('wheel', function (e) {
      if (busy) return;
      var si = hitSlot(pos(e)), s = design.slots[si];
      if (!s || !s.photo) return;
      e.preventDefault(); s.z = clamp(s.z * (e.deltaY < 0 ? 1.08 : 1 / 1.08), 0.01, 5);
      if (sel.type !== 'slot' || sel.i !== si) { sel = { type: 'slot', i: si }; cropMode = false; refresh(); } else { draw(); syncSliders(); }
    }, { passive: false });
  }
  function syncSliders() {
    var z = modal.querySelector('[data-f="z"]'), sz = modal.querySelector('[data-f="size"]');
    if (z && sel.type === 'slot') z.value = design.slots[sel.i].z;
    if (sz && sel.type === 'text') sz.value = design.texts[sel.i].size;
  }

  /* ---------- side panel actions ---------- */
  function onInput(e) {
    var f = e.target.getAttribute('data-f'); if (!f || busy) return;
    if (f === 'snap') { design.snap = !!e.target.checked; return; }
    if (f === 'tintitle') { typeTitle(e.target); tinChanged(); return; }
    if (sel.type === 'text') {
      var t = design.texts[sel.i]; t.edited = true;
      if (f === 'text') t.text = e.target.value;
      else if (f === 'size' || f === 'rot') t[f] = +e.target.value;
      if (f === 'rot' && design.snap && Math.abs(t.rot) <= 3) t.rot = 0;      /* snap to level */
    }
    else if (f === 'z') design.slots[sel.i].z = +e.target.value;
    draw();
  }
  function onClick(e) {
    if (busy) return;
    var el = e.target.closest('button'); if (!el || !modal.contains(el)) return;
    var d = el.dataset, s = sel.type === 'slot' ? design.slots[sel.i] : null;
    if (d.o) { var nt = d.o === 'tall'; if (nt !== design.tall && !oneOrient(design.layout)) { design.tall = nt; orientTouched = true; resetSlots(); fitOrient(); } refresh(); if (layOn) openLay(); }
    else if (d.pick) {
      closeLay();
      /* 1 Photo with no single-photo designs on offer: switch straight to the full photo */
      if (d.pick === 'one' && !pickList('one').some(function (l) { return l.tpl; })) { if (slotCount(design.layout) !== 1 || design.layout.tpl) setLayout(LAYOUTS[0]); refresh(); }
      else openPicker(d.pick);
    }
    else if (d.ptab) { pickTab = d.ptab; renderPicker(); }
    else if (d.theme != null) { pickTheme = d.theme ? [d.theme] : []; renderPicker(); }
    else if (d.design) {
      var nl = layoutById(d.design); if (!nl) return;
      var wt = d.t === '1';
      if (hasBoth && d.t != null && wt !== design.tall && (!nl.tpl || geoFor(nl, wt))) { design.tall = wt; orientTouched = true; }      /* the card's orientation */
      else if (nl.tpl && !geoFor(nl, design.tall)) { design.tall = !design.tall; orientTouched = true; }      /* a design made only in the other orientation */
      setLayout(nl);
      if (QUICK) syncVariant();
      var fromStart = pickStart;
      closePicker();
      ga('design_chosen', { design: nl.tpl ? nl.key : 'layout-' + nl.id, orientation: design.tall ? 'portrait' : 'landscape', source: fromStart ? 'start' : 'change' });
      if (fromStart && askSize) { askSize = false; tplFirst = true; openSizes(true); return; }      /* homepage: the template first, then the size */
      refresh();
    }
    else if (d.jump) jumpTo(d.jump);
    else if (d.act === 'sizeback') { closeSizes(); askSize = true; tplFirst = false; openStartPicker('back_from_size'); }
    else if (d.act === 'pickclose') { if (pickStart && noPhotoYet()) { closePicker(); askClose(); } else closePicker(); }      /* the first window: closing it leaves the designer */
    else if (d.act === 'pickback') pickBack();
    else if (d.size) chooseSize(d.size);
    else if (d.act === 'sizes') openSizes(false);
    else if (d.act === 'sizeclose') sizesBack();
    else if (d.act === 'designs') openPicker(null, 'see_all_button');
    else if (d.font) { design.texts[sel.i].font = +d.font; refresh(); }
    else if (d.color) { design.texts[sel.i].color = d.color; refresh(); }
    else if (d.act === 'cancel') askClose();
    else if (d.act === 'leavestay') closeLeave();
    else if (d.act === 'help') goEmail('link', null);
    else if (d.act === 'emailus') goEmail(leaveOn ? (noPhotoYet() ? 'close' : 'leave') : 'link', el);
    else if (d.act === 'leavego') { closeLeave(); closeDesigner(false); }
    else if (d.act === 'upload') { pendingSlot = -1; pickFile(); }
    else if (d.act === 'addtext') addText();
    /* phones: the tool buttons */
    else if (d.act === 'tphoto') {
      if (!design.slots.some(function (x) { return x.photo; }) && !photos.length) { pendingSlot = -1; pickFile(); return; }      /* nothing yet: straight to the photo picker */
      if (sel.type !== 'slot') { var fi = -1; design.slots.forEach(function (x, i) { if (fi < 0 && !x.photo) fi = i; }); sel = { type: 'slot', i: Math.max(0, fi) }; }
      tool = 'photo'; popOn = false; refresh();
    }
    else if (d.act === 'ttext') {
      if (sel.type !== 'text' && design.texts.length) sel = { type: 'text', i: design.texts.length - 1 };
      if (sel.type === 'text') { tool = 'text'; refresh(); } else addText();
    }
    else if (d.act === 'whole' || d.act === 'fill') {      /* "Show whole photo" / "Fill the puzzle" */
      var fi = fitSlot(); if (fi < 0) return;
      var fsl = design.slots[fi], fr = rects(canvas.width, canvas.height)[fi];
      fsl.z = d.act === 'whole' ? minZ(fsl, fr) : 1; fsl.ox = 0; fsl.oy = 0;
      if (toastEl) toastEl.classList.remove('is-on');      /* the "trimmed" note has done its job */
      if (sel.type !== 'slot' || sel.i !== fi) sel = { type: 'slot', i: fi };
      refresh(); ga('photo_fit_changed', { mode: d.act });
    }
    else if (d.bg) { var bsl = sel.type === 'slot' ? design.slots[sel.i] : null; if (bsl && bsl.photo) { bsl.bg = d.bg; refresh(); } }
    else if (d.act === 'tlayout') openPicker(null, 'phone_tool');
    else if (d.act === 'layclose') closeLay();
    else if (d.act === 'tdone') { tool = null; refresh(); }
    else if (d.act === 'replace') { pendingSlot = sel.type === 'slot' ? sel.i : -1; pickFile(); }
    else if (d.act === 'tlid') { tinTool = 'lid'; renderTinSide(); drawTinFlat(); }
    else if (d.act === 'tliddone') { tinTool = null; renderTinSide(); drawTinFlat(); }
    else if (d.act === 'tin3d') open3D();
    else if (d.act === 'tin3dclose') close3D();
    else if (d.act === 'deltext') { design.texts.splice(sel.i, 1); sel = { type: 'slot', i: 0 }; refresh(); }
    else if (d.act === 'rotate' && s && s.photo) { s.photo.rot = (s.photo.rot + 90) % 360; design.slots.forEach(function (x) { if (x.photo === s.photo) { x.z = 1; x.ox = 0; x.oy = 0; } }); refresh(); }
    else if (d.act === 'enhance' && s && s.photo) { s.photo.enhance = !s.photo.enhance; if (s.photo.enhance) ensureEnhanced(s.photo); refresh(); }
    else if (d.act === 'remove' && s) { var gone = s.photo; s.photo = null; dropUnused(gone); refresh(); }
    else if (d.act === 'crop' && s && s.photo) startCrop(s);
    else if (d.act === 'cropdone') { cropSnap = null; cropMode = false; refresh(); }
    else if (d.act === 'cropcancel') cancelCrop();
    else if ((d.act === 'zin' || d.act === 'zout') && s && s.photo) { s.z = clamp(s.z * (d.act === 'zin' ? 1.15 : 1 / 1.15), 0.01, 5); draw(); syncSliders(); }
    else if (d.act === 'next') nextStep();
    else if (d.act === 'back') goStep(1);
    else if (d.tinlay) { tin.layout = d.tinlay; renderTinSide(); tinChanged(); ga('tin_design_changed', { layout: tin.layout, color: tin.color }); }
    else if (d.tinpos) { tin.badge = { x: d.tinpos.charAt(1) === 'r' ? 1 : 0, y: d.tinpos.charAt(0) === 'b' ? 1 : 0 }; tinChanged(); ga('tin_piece_count_moved', { corner: d.tinpos }); }
    else if (d.tincolor) { tin.color = d.tincolor; renderTinSide(); tinChanged(); ga('tin_design_changed', { layout: tin.layout, color: tin.color }); }
    else if (d.act === 'add') commit();
  }

  function addText() {
    cropMode = false;
    design.texts.push({ text: 'Your text here', x: 0.5, y: 0.82, size: 0.08, rot: 0, font: 0, color: '#FFFFFF' });
    sel = { type: 'text', i: design.texts.length - 1 };
    if (isPhone()) { tool = 'text'; refresh(); return; }      /* phones: no keyboard until the text box is tapped */
    refresh();
    var ta = sideEl.querySelector('textarea'); if (ta) { ta.focus(); ta.select(); }
  }

  /* ---------- open / close ---------- */
  function takeSnap() {
    return { tall: design.tall, layout: design.layout, lines: design.lines,
      slots: design.slots.map(function (s) { return { photo: s.photo, z: s.z, ox: s.ox, oy: s.oy, bg: s.bg }; }),
      texts: design.texts.map(function (t) { var o = {}; for (var k in t) o[k] = t[k]; return o; }),
      photos: photos.map(function (P) { return { P: P, rot: P.rot, enhance: P.enhance }; }),
      tin: { layout: tin.layout, color: tin.color, title: tin.title, badge: { x: tin.badge.x, y: tin.badge.y } } };
  }
  function openDesigner() {
    if (!modal) buildModal();
    loadFonts(); loadPlaceholders(); addLabel();
    var fresh = modal.hidden;
    if (modal.hidden) {
      syncVariant();
      if (toastEl) toastEl.classList.remove('is-on');      /* only clear old messages when the designer first opens */
      snap = saved ? takeSnap() : null; cropMode = false; popOn = false;
      var pt = pageTall(), wasTall = design.tall;
      if (!hasBoth) design.tall = pt;
      else if (oneOrient(design.layout)) { if (pt !== design.tall) toast(design.layout.name + ' comes in ' + onlyName(design.layout) + ' only, so your puzzle stays ' + onlyName(design.layout) + '.'); }
      else if (ORIENT === 'variants') { if (design.tall !== pt && (saved || !photos.length)) { design.tall = pt; resetSlots(); } }
      else if (!saved && !photos.length && !orientTouched) design.tall = pt;
      if (design.tall !== wasTall) fitOrient();
      lastFocus = document.activeElement; modal.hidden = false; document.documentElement.classList.add('pixup-open'); histOpen();
      msgEl.hidden = true; tool = null; closeLay();
    }
    refresh(); requestAnimationFrame(draw);
    if (fresh) openSig = designSig();      /* what "unsaved changes" are measured against */
    if (autoPick) { autoPick = false; if (noPhotoYet() && !saved) pickStart = true; openPicker(null, 'theme_link'); }
  }
  /* ---------- "Leave without saving?" ----------
     Closing the designer (X, Cancel, Escape or the phone's back button) with a photo on the puzzle that is not in
     the cart yet, or with changes to a design that is, asks first. The design stays on the page either way;
     what is lost is a design that never reached the cart (or the unsaved changes to one that did). */
  var leaveEl = null, leaveOn = false, openSig = '';
  function noPhotoYet() { return !design.slots.some(function (x) { return x.photo; }); }
  function designSig() {
    return JSON.stringify([design.layout.id, design.tall,
      design.slots.map(function (x) { return [photos.indexOf(x.photo), +(+x.z).toFixed(3), Math.round(x.ox), Math.round(x.oy), x.bg || '', x.photo ? x.photo.rot + '' + !!x.photo.enhance : '']; }),
      design.texts.map(function (t) { return [t.text, +t.x.toFixed(3), +t.y.toFixed(3), +t.size.toFixed(3), t.rot, t.font, t.color]; }),
      TIN ? [tin.layout, tin.color, tin.title, tin.badge.x, tin.badge.y] : 0]);
  }
  function needsLeaveCheck() {
    if (busy || noPhotoYet()) return false;
    return (saved || EDIT) ? designSig() !== openSig : true;      /* a design already in the cart: only when it changed */
  }
  function askClose() { if (needsLeaveCheck()) openLeave(); else if (wantHelp(true)) openHelp(true); else closeDesigner(false); }
  /* ---------- "Email us your photo instead", for anyone who would rather not upload (window.PixHelp comes from
     snippets/pix-email-help.liquid). Offered as one quiet line until a photo is added, and once when the
     designer is closed without a photo. ---------- */
  function helpEmail() { var h = window.PixHelp; return (h && h.email) || 'info@pixonpuzzles.com'; }
  /* the "Email us your photo" page: a form for the size, how many and the photos (sections/pix-email-photo.liquid) */
  function helpPage() { var h = window.PixHelp; return (h && h.page) || '/pages/email-your-photo'; }
  /* every close without a photo offers it (always: true); the browser's back button only once a visit */
  function wantHelp(always) {
    if (busy || !noPhotoYet() || saved || EDIT) return false;
    if (always) return true;
    try { return sessionStorage.getItem('pixup_help') !== '1'; } catch (e) { return false; }
  }
  /* to the email page, taking the size and any photos already added here (their uploads finish first) */
  function goEmail(from, btn) {
    var list = design.slots.map(function (x) { return x.photo; }).filter(Boolean);
    photos.forEach(function (P) { if (list.indexOf(P) < 0) list.push(P); });
    list = list.slice(0, MAX_PHOTOS);
    var pm = /\/products\/([^\/?#]+)/.exec(location.pathname), went = false;
    var url = helpPage(), size = curProd && curProd.handle ? curProd.handle : pm ? decodeURIComponent(pm[1]) : '';
    ga('designer_email_click', { from: from, photos: list.length });
    function go(urls) {
      if (went) return; went = true;
      try {
        sessionStorage.setItem('pixup_help', '1');
        sessionStorage.setItem('pixup_email', JSON.stringify({ at: Date.now(), from: 'designer', size: size,
          photos: list.map(function (P, i) { return { url: urls[i] || '', name: P.upName || P.name || '' }; }).filter(function (p) { return p.url; }) }));
      } catch (e) {}
      window.location.href = url + (size ? (url.indexOf('?') > -1 ? '&' : '?') + 'size=' + encodeURIComponent(size) : '');
    }
    if (!list.length) return go([]);
    if (btn) { btn.disabled = true; btn.textContent = 'Attaching your photos\u2026'; }
    Promise.all(list.map(function (P) { return P.originalP || Promise.resolve(''); })).then(go, function () { go([]); });
    setTimeout(function () { go([]); }, 25000);      /* a very slow upload: go anyway, they can add the photos there */
  }
  function helpMailto() {
    var h1 = document.querySelector('h1'), size = (curProd && curProd.title) || (h1 ? h1.textContent.trim() : '');
    var body = 'Hi Pix on Puzzles,\n\nI would like help ordering a custom puzzle.\n\nPuzzle size: ' + size + '\nHow many: \nMy phone number (optional): \n\nMy photo is attached.\n\nThank you!';
    return 'mailto:' + helpEmail() + '?subject=' + encodeURIComponent('Help with my puzzle order') + '&body=' + encodeURIComponent(body);
  }
  function helpLinkHtml() {
    return noPhotoYet() ? '<button type="button" class="pixup-helplink" data-act="help">Trouble uploading? <u>Email Us Your Photo instead</u></button>' : '';
  }
  var MAIL_SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/></svg>';
  function openHelp(closing) {
    if (!leaveEl) leaveEl = modal.querySelector('.pixup-leave');
    try { sessionStorage.setItem('pixup_help', '1'); } catch (e) {}
    leaveEl.innerHTML = '<div class="pixup-leavebox"><b id="pixup-leave-t">' + (closing ? 'Would you rather email us your photo?' : 'Email Us Your Photo') + '</b>' +
      '<p>Choose your size and how many, add your photo and send it to us. We\u2019ll set up your puzzle and email you to finish your order.</p>' +
      '<div class="pixup-leavebtns"><button type="button" class="pixup-add pixup-helpmail" data-act="emailus">' + MAIL_SVG + 'Email Us Your Photo</button>' +
      '<button type="button" class="pixup-ghost" data-act="leavestay">' + (closing ? 'Keep designing' : 'Back to my puzzle') + '</button>' +
      (closing ? '<button type="button" class="pixup-ghost" data-act="leavego">No thanks, close</button>' : '') + '</div></div>';
    leaveEl.hidden = false; leaveOn = true;
    var b = leaveEl.querySelector('.pixup-helpmail'); if (b) b.focus({ preventScroll: true });
    ga('designer_email_help', { from: closing ? 'close' : 'link' });
  }
  function openLeave() {
    if (!leaveEl) leaveEl = modal.querySelector('.pixup-leave');
    var edit = !!(saved || EDIT);
    leaveEl.innerHTML = '<div class="pixup-leavebox"><b id="pixup-leave-t">' + (edit ? 'Leave without saving your changes?' : 'Leave without saving?') + '</b>' +
      '<p>' + (edit ? 'Your changes aren\u2019t saved yet. If you close now, your puzzle goes back to how it was.'
                    : 'Your puzzle isn\u2019t in your cart yet. Add it to your cart to keep it, or email your photos to us and we\u2019ll set it up for you.') + '</p>' +
      '<div class="pixup-leavebtns"><button type="button" class="pixup-add" data-act="leavestay">Keep designing</button>' +
      (edit ? '' : '<button type="button" class="pixup-emailalt" data-act="emailus">' + MAIL_SVG + 'Email Us Your Photo' + (photos.length > 1 ? 's' : '') + '</button>') +
      '<button type="button" class="pixup-ghost" data-act="leavego">' + (edit ? 'Close without saving' : 'Close anyway') + '</button></div></div>';
    leaveEl.hidden = false; leaveOn = true;
    var b = leaveEl.querySelector('[data-act="leavestay"]'); if (b) b.focus({ preventScroll: true });
    ga('designer_leave_warning', { saved: edit ? 'yes' : 'no' });
  }
  function closeLeave() { if (leaveEl) leaveEl.hidden = true; leaveOn = false; }
  function closeDesigner(done) {
    if (!modal || modal.hidden) return;
    if (!done) {
      if (snap) {                    /* a saved design: undo unsaved edits */
        design.tall = snap.tall; design.layout = snap.layout; design.lines = snap.lines; design.slots = snap.slots; design.texts = snap.texts;
        snap.photos.forEach(function (o) { o.P.rot = o.rot; o.P.enhance = o.enhance; });
        snap.photos.forEach(function (o) { if (photos.indexOf(o.P) < 0) photos.push(o.P); });
        if (snap.tin) tin = snap.tin;
      }
      ga('upload_abandoned', { stage: 'designer' });
    }
    if (pickOn) { pickOn = false; thumbTok++; pickEl.hidden = true; }
    if (sizesOn) { sizesOn = false; sizesEl.hidden = true; }
    closeLay(); closeLeave(); tool = null;
    backView(false);
    if (step === 2) goStep(1);
    snap = null; modal.hidden = true; document.documentElement.classList.remove('pixup-open'); histClose();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  /* the designer's button adds straight to the cart; it just says "Add to cart" (no price), or "Update cart" for a design opened from the cart */
  function addHtml() { return (EDIT ? 'Update cart' : 'Add to cart') + '<span class="pixup-addprice"></span>'; }
  function addLabel() {
    var el = modal && modal.querySelector('.pixup-addprice');
    if (el) el.textContent = '';
  }
  /* submit the product form like the page's Add to cart button, once the designer has finished closing */
  var afterHist = null;
  function submitCart() {
    var done = false;
    function go() {
      if (done) return; done = true; afterHist = null;
      setCartPreview();      /* the page may have put the plain puzzle picture back in the meantime */
      var btn = form.querySelector('[data-atc]') || form.querySelector('[type="submit"]');
      try { if (form.requestSubmit) { if (btn) form.requestSubmit(btn); else form.requestSubmit(); } else form.submit(); } catch (e) { form.submit(); }
    }
    afterHist = go; setTimeout(go, 600);
  }
  function setBusy(on, frac, label) {
    busy = on; busyEl.hidden = !on; barEl.style.width = Math.round((frac || 0) * 100) + '%';
    var t = busyEl.querySelector('span'); if (t) t.textContent = label || (EDIT ? 'Updating your cart…' : 'Adding to cart…');
  }
  function say(msg, error) { msgEl.className = 'pixup-warn' + (error ? ' is-error' : ''); msgEl.textContent = msg; msgEl.hidden = false; }

  /* ---------- save the design ---------- */
  function commit() {
    if (busy) return;
    design.texts = design.texts.filter(function (t) { return t.text.trim(); });
    if (sel.type === 'text' && !design.texts[sel.i]) sel = { type: 'slot', i: 0 };
    if (design.slots.some(function (s) { return !s.photo; })) {
      refresh();
      say(design.slots.length > 1 ? 'Add a photo to every space, or choose a layout with fewer photos.' : 'Upload a photo to add your puzzle to the cart.');
      return;
    }
    msgEl.hidden = true; setBusy(true, 0.03);
    if (TIN) stop3D();      /* free the processor for the print files */
    var out, printUrl, prevUrl, lidUrl = '', cartUrl = '', tinUrl = '', puzUrl = '', puzPic = null, origs = [], origList = [], photoUrls = [], list = [];
    design.slots.forEach(function (s) { if (list.indexOf(s.photo) < 0) list.push(s.photo); });
    waitFonts().then(function () { return artReady(design, true); }).then(function (artOk) {
      if (!artOk) throw new Error('artwork');
      return new Promise(function (r) { setTimeout(r, 40); });
    }).then(function () {
      out = exportDesign();
      var doneN = 0;
      return Promise.all(list.map(function (P) { return P.originalP.then(function (u) { setBusy(true, 0.03 + 0.27 * (++doneN / list.length)); return u; }); }));
    }).then(function (urls) {
      photoUrls = urls;
      origs = urls.filter(Boolean);
      origList = list.map(function (P, i) { return { url: urls[i], name: P.upName || P.file && P.file.name || P.name || '' }; }).filter(function (o) { return o.url; });
      return toBlob(out, 0.92);
    }).then(function (blob) {
      return send(blob, 'image/jpeg', 'cropped', group, function (f) { setBusy(true, 0.3 + f * (TIN ? 0.4 : 0.55)); });
    }).then(function (d) {
      printUrl = d.url; if (!group) group = d.group;
      return previewCanvas(out)
        .then(function (pv) {      /* a picture whose lines could not be read back is sent without them */
          puzPic = pv.c;
          return toBlob(pv.c, 0.85).catch(function () { puzPic = shrink(out, 1400); return toBlob(puzPic, 0.85); });
        })
        .then(function (b) { return send(b, 'image/jpeg', 'preview', group, function (f) { setBusy(true, TIN ? 0.7 + f * 0.08 : 0.85 + f * 0.15); }); })
        .then(function (p) { prevUrl = p.url; })
        .catch(function () { prevUrl = printUrl; });
    }).then(function () {
      if (!TIN) return;      /* the tin lid's print file */
      return Promise.all([tinFonts(), (tinLogo(tinDark(tin.color)) || {}).p]).then(function () { tinLayoutOk(); fitTinTitle(); return toBlob(exportLid(out), 0.92); })
        .then(function (b) { return sendLid(b, function (f) { setBusy(true, 0.78 + f * 0.1); }); })
        .then(function (d) { lidUrl = d.url; })
        .catch(function (e) { log('tin lid not saved:', e && e.message); lidUrl = ''; });
    }).then(function () {
      if (!TIN || !puzPic) return;      /* the cart's photo: the finished puzzle standing, with its tin in front */
      return comboCanvas(puzPic)
        .then(function (c) { return c ? toBlob(c, 0.86) : null; })
        .then(function (b) { return b ? send(b, 'image/jpeg', 'preview', group, function (f) { setBusy(true, 0.86 + f * 0.06); }) : null; })
        .then(function (d) { if (d) cartUrl = d.url; })
        .catch(function (e) { log('cart photo not made:', e && e.message); cartUrl = ''; });
    }).then(function () {
      if (!TIN) return;      /* the cart's tin view: the whole tin in 3D, not just its lid */
      return tinCanvas()
        .then(function (c) { return c ? toBlob(c, 0.88) : null; })
        .then(function (b) { return b ? send(b, 'image/jpeg', 'preview', group, function (f) { setBusy(true, 0.92 + f * 0.04); }) : null; })
        .then(function (d) { if (d) tinUrl = d.url; })
        .catch(function (e) { log('tin photo not made:', e && e.message); tinUrl = ''; });
    }).then(function () {
      if (!TIN || !puzPic) return;      /* the cart's puzzle view: the puzzle by itself in 3D */
      return puzzleCanvas(puzPic)
        .then(function (c) { return c ? toBlob(c, 0.88) : null; })
        .then(function (b) { return b ? send(b, 'image/jpeg', 'preview', group, function (f) { setBusy(true, 0.96 + f * 0.04); }) : null; })
        .then(function (d) { if (d) puzUrl = d.url; })
        .catch(function (e) { log('puzzle photo not made:', e && e.message); puzUrl = ''; });
    }).then(function () {
      /* move the page to the orientation chosen in the designer (quick mode: the hidden form's variant) */
      if (QUICK) syncVariant();
      else if (ORIENT === 'variants' && hasBoth && design.tall !== variantTall(activeVid())) {
        var ob = document.querySelector('.pix-orient[data-tall="' + (design.tall ? 'true' : 'false') + '"]');
        if (ob) ob.click();
      }
      var vid = activeVid(), notes = [design.tall ? 'Portrait' : 'Landscape',
        list.length + (list.length > 1 ? ' photos' : ' photo') + (design.layout.tpl ? ', design "' + design.layout.name + '" (' + design.layout.key + ')' : list.length > 1 ? ', layout ' + design.layout.id : ''),
        out.width + 'x' + out.height + ' px'];
      if (list.some(function (P) { return P.enhance; })) notes.push('auto-enhanced');
      design.texts.forEach(function (t) { notes.push('text: "' + t.text.replace(/\s+/g, ' ').trim() + '"'); });
      if (TIN) notes.push(tinNotes(lidUrl));
      saved = { vid: vid, tall: design.tall, print: printUrl, preview: prevUrl, cart: cartUrl || prevUrl, lid: lidUrl, tinView: tinUrl, puzView: puzUrl, originals: origs, notes: notes.join(' | '), edit: editId() };
      saved.download = downloadLink(printUrl, prevUrl, origList, saved.notes, lidUrl);
      editSave(saved.edit, editState(list, photoUrls));      /* so the customer can reopen this design from the cart */
      host.querySelectorAll('.uploadkit-thumbnails').forEach(function (n) { n.textContent = ''; });
      var box = uploaderFor(vid);
      if (box) { var im = document.createElement('img'); im.alt = ''; im.src = prevUrl; box.querySelector('.uploadkit-thumbnails').appendChild(im); }
      syncInputs();
      setCartPreview();      /* the cart's photo, set now rather than waiting for the page to notice */
      ga('upload_completed', { photos: list.length, has_text: design.texts.length ? 'yes' : 'no' });
      var gp = TIN ? { photos: list.length, tin_layout: tin.layout, tin_color: tin.color, tin_title: tin.title.trim() ? 'yes' : 'no' } : { photos: list.length };
      if (backOk()) gp.numbered_back = backOn ? 'yes' : 'no';
      ga(EDIT ? 'designer_cart_edit_saved' : 'designer_add_to_cart', gp);
      log('saved', saved);
      if (EDIT) { replaceCartLine(); return; }      /* opened from the cart: swap the old line for this one */
      /* the numbered back goes in first, as its own cart line tied to this design; the puzzle follows */
      (backOn && backOk() ? addBackLine(formQty(), saved.edit).catch(function (e) { log('numbered back not added:', e && e.message); }) : Promise.resolve()).then(function () {
        setBusy(false);
        closeDesigner(true);
        toast('Adding your puzzle to the cart…');
        submitCart();
      });
    }).catch(function (e) {
      log('save failed:', e && e.message);
      setBusy(false);
      say(e && e.message === 'artwork' ? 'The artwork for this design did not finish loading. Please try again in a moment.' : 'We could not save your design. Please check your connection and try again.', true);
    });
  }

  /* one link for the order: a page on the upload service listing exactly this design's files */
  function filePart(u) {
    var m = String(u || '').match(/\/file\/(\d{4}-\d{2}\/[0-9a-f-]{36})\/([^\/?#]+)$/);
    return m ? { folder: m[1], name: m[2] } : null;
  }
  function downloadLink(printUrl, prevUrl, origList, notes, lidUrl) {
    var pf = filePart(printUrl); if (!pf) return '';
    var qs = ['p=' + encodeURIComponent(pf.name)], pv = filePart(prevUrl), lf = filePart(lidUrl);
    if (pv && pv.folder === pf.folder && pv.name !== pf.name) qs.push('v=' + encodeURIComponent(pv.name));
    if (lf && lf.folder === pf.folder) qs.push('t=' + encodeURIComponent(lf.name));      /* the tin lid (shown once the upload service knows it) */
    origList.forEach(function (o) {
      var f = filePart(o.url);
      if (f && f.folder === pf.folder) qs.push('o=' + encodeURIComponent(f.name + '|' + String(o.name).slice(0, 80)));
    });
    if (notes) qs.push('n=' + encodeURIComponent(notes.slice(0, 200)));
    return ENDPOINT + '/order/' + pf.folder + '?' + qs.join('&');
  }

  /* ---------- page markup the hero section reads ---------- */
  function uploaderFor(vid) {
    var ups = host.querySelectorAll('.uploadkit-uploader');
    for (var i = 0; i < ups.length; i++) if (ups[i].getAttribute('data-matching-variant-ids') === String(vid)) return ups[i];
    return ups[0] || null;
  }
  function addInput(name, value) {
    if (!value) return;
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.value = value; i.setAttribute('data-pixup-prop', '');
    form.appendChild(i);
  }
  function syncInputs() {
    form.querySelectorAll('[data-pixup-prop]').forEach(function (n) { n.remove(); });
    if (!saved || saved.vid !== activeVid()) return;
    addInput('_Download files', saved.download);      /* one link: print file, preview and every original */
    if (ORIENT !== 'variants') addInput('Orientation', saved.tall ? 'Portrait' : 'Landscape');      /* shows on packing slips and emails */
    addInput('_Print file', saved.print);
    addInput('_Pix Puzzle', saved.preview);      /* the puzzle with its lines, for the cart's zoom view */
    addInput('_Tin lid file', saved.lid);
    addInput('_Tin view', saved.tinView);      /* the whole tin in 3D, for the cart's zoom view */
    addInput('_Puzzle view', saved.puzView);      /* the puzzle by itself in 3D, for the cart's zoom view */
    saved.originals.forEach(function (u, i) { addInput('_Original photo' + (saved.originals.length > 1 ? ' ' + (i + 1) : ''), u); });
    addInput('_Design notes', saved.notes);
    addInput('_Pix Edit', saved.edit);      /* lets the cart's "Edit design" button reopen this design */
  }
  if (vidInput) vidInput.addEventListener('change', syncInputs);
  /* the cart shows the puzzle with its tin; the page itself keeps showing the plain puzzle picture */
  function setCartPreview() {
    var cp = form.querySelector('[data-pix-cart-preview]');
    if (cp && saved && saved.vid === activeVid()) cp.value = saved.cart || saved.preview;
  }
  form.addEventListener('submit', setCartPreview, true);

  /* ---------- choosing files ---------- */
  var fileInput = document.createElement('input');
  fileInput.type = 'file'; fileInput.accept = 'image/*,.heic,.heif,.hif,.tif,.tiff,.avif,.bmp,.gif'; fileInput.multiple = false; fileInput.className = 'pixup-file';      /* one photo at a time */
  fileInput.setAttribute('aria-hidden', 'true'); fileInput.tabIndex = -1;
  document.body.appendChild(fileInput);
  function pickFile() { fileInput.value = ''; fileInput.click(); }
  fileInput.addEventListener('change', function () {
    var files = [].slice.call(fileInput.files || []).slice(0, 1), first = !photos.length, target = pendingSlot;      /* one photo at a time */
    pendingSlot = -1;
    if (!files.length) return;
    if (photos.length + files.length > MAX_PHOTOS) photos = photos.filter(used);      /* make room: forget photos not on the puzzle */
    if (photos.length + files.length > MAX_PHOTOS) { toast('You can add up to ' + MAX_PHOTOS + ' photos.'); files = files.slice(0, Math.max(0, MAX_PHOTOS - photos.length)); }
    function tooBig(f) { return f.size > (BIG_TYPES.indexOf(typeOf(f)) > -1 ? MAX_BIG : MAX_FILE); }
    var big = files.filter(tooBig);
    files = files.filter(function (f) { return !tooBig(f); });
    Promise.all(files.map(function (f) { return addPhoto(f).catch(function () { return null; }); })).then(function (list) {
      var ok = list.filter(Boolean);
      if (big.length) toast('Photos over 40 MB were skipped. Please choose smaller ones.');
      else if (ok.length < list.length) toast('We could not open ' + (list.length - ok.length > 1 ? 'some of those photos' : 'that photo') + ' in this browser. Please try a JPG, PNG or iPhone photo, or email it to us at ' + helpEmail() + '.');
      if (!ok.length) return;
      if (target < 0 && !design.layout.tpl) {      /* a photo added to a full collage grows it (a chosen design keeps its spaces) */
        var multi = design.layout.c.length > 1, total = design.slots.filter(function (x) { return x.photo; }).length + ok.length;
        if (multi ? total > design.slots.length : ok.length > 1) setLayout(firstLayout(total), ok);
      }
      if (first) {
        ga('upload_started', { entry_point: entry || '(not set)' });
        if (hasBoth && !orientTouched && !saved && !design.layout.tpl && design.layout.c.length === 1) { var r = ok[0].sw / ok[0].sh; if (r > 1.05) design.tall = false; else if (r < 0.95) design.tall = true; }
      }
      ok.forEach(function (P, n) {
        var i = -1;
        if (n === 0 && target > -1 && design.slots[target]) i = target;
        else { for (var k = 0; k < design.slots.length; k++) if (!design.slots[k].photo) { i = k; break; } }
        if (i < 0 && n === 0 && design.slots.length === 1) i = 0;      /* single photo: the new one replaces it */
        if (i > -1) { var was = design.slots[i].photo; design.slots[i] = { photo: P, z: 1, ox: 0, oy: 0 }; dropUnused(was); if (n === 0) sel = { type: 'slot', i: i }; }
      });
      openDesigner();
      trimNote();
    });
  });

  /* which hero button was pressed: runs before the hero's own click handler */
  var intent = '', entry = '';
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-change],[data-recrop],[data-upload],[data-upzone]');
    if (!t) return;
    intent = t.hasAttribute('data-change') ? 'change' : t.hasAttribute('data-recrop') ? 'edit' : 'new';
    entry = t.hasAttribute('data-change') ? 'change_photo_button' : t.hasAttribute('data-recrop') ? 'recrop_button' : t.hasAttribute('data-upload') ? 'upload_box_button' : 'upload_box_area';
  }, true);
  host.addEventListener('click', function (e) {
    if (!e.target.closest('.upk-open-button')) return;
    var it = intent; intent = '';
    openDesigner();
    if (it === 'change' && photos.length) { pendingSlot = sel.type === 'slot' ? sel.i : 0; pickFile(); }
    else if (it !== 'edit' && !saved && !EDIT && noPhotoYet() && !photos.length && !pickOn && !sizesOn) openStartPicker('product_page');
  });

  /* ---------- no design, no add to cart ---------- */
  if (CFG.requirePhoto) {
    form.addEventListener('submit', function (e) {
      if (saved && saved.vid === activeVid()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var zone = document.querySelector('[data-upzone]');
      if (zone) { zone.scrollIntoView({ behavior: 'smooth', block: 'center' }); zone.classList.add('pixup-need'); setTimeout(function () { zone.classList.remove('pixup-need'); }, 2200); }
      toast('Please upload your photo before adding the puzzle to your cart.');
    }, true);
  }

  /* ---------- the phone's back button closes the designer instead of leaving the page ---------- */
  var histOn = false, skipPop = false, keepUrl = '';
  function histOpen() { if (histOn) return; try { history.pushState({ pixup: 1 }, '', location.href); histOn = true; } catch (e) {} }
  function histClose() {
    if (!histOn) return;
    histOn = false; skipPop = true; keepUrl = location.href;
    try { history.back(); } catch (e) { skipPop = false; }
  }
  window.addEventListener('popstate', function () {
    if (skipPop) {      /* our own step back after closing: keep any address change made meanwhile (e.g. the chosen size) */
      skipPop = false;
      if (keepUrl && keepUrl !== location.href) { try { history.replaceState(history.state, '', keepUrl); } catch (e) {} }
      if (afterHist) setTimeout(afterHist, 0);      /* the designer has closed: now go to the cart */
      return;
    }
    if (!histOn || !modal || modal.hidden) { histOn = false; return; }
    histOn = false;
    if (leaveOn && !busy) { closeLeave(); histOpen(); return; }      /* back while "Leave without saving?" shows: stay */
    if (step === 2 && !busy) { if (is3D()) close3D(); else goStep(1); histOpen(); return; }      /* back from the tin returns to the puzzle (or closes its 3D view) */
    if (layOn && !busy) { closeLay(); histOpen(); return; }      /* back closes "Change layout" */
    if (sizesOn && sizesMust && tplFirst && !busy) { closeSizes(); askSize = true; tplFirst = false; openStartPicker('back_from_size'); histOpen(); return; }      /* back from the size goes back to the templates */
    if (sizesOn && sizesMust && !busy) { closeDesigner(false); return; }      /* back from the first "Choose your size" closes the designer */
    if (pickOn && pickStart && !busy) { closeDesigner(false); return; }      /* back from the first "Choose your template" closes the designer */
    if (busy || cropMode || pickOn || sizesOn) { if (!busy) { if (sizesOn) sizesBack(); else if (pickOn) closePicker(); else cancelCrop(); } histOpen(); return; }      /* back closes the design window or crop first */
    if (needsLeaveCheck()) { histOpen(); openLeave(); return; }      /* unsaved work: ask first */
    if (wantHelp()) { histOpen(); openHelp(true); return; }      /* nothing uploaded: offer email instead, once */
    closeDesigner(false);
  });

  /* ---------- links like /products/500-piece?design=1 open the designer on arrival ---------- */
  (function () {
    if (!urlQ.has('design')) return;
    var o = urlQ.get('orient');
    if (o && ORIENT === 'variants') {
      var ob = document.querySelector('.pix-orient[data-tall="' + (/^p/i.test(o) ? 'true' : 'false') + '"]');
      if (ob && !ob.classList.contains('active')) ob.click();
    }
    var q = new URLSearchParams(location.search); q.delete('design'); q.delete('orient');
    try { history.replaceState(history.state, '', location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash); } catch (e) {}
    entry = 'start_designing_link';
    var want = layoutById('d:' + slug(urlQ.get('design')));      /* ?design=snowy-christmas starts with that design */
    if (want) autoPick = false;
    setTimeout(function () {
      openDesigner();
      if (want && (geoFor(want, design.tall) || hasBoth)) {
        if (!geoFor(want, design.tall)) { design.tall = !design.tall; orientTouched = true; }
        setLayout(want); refresh(); entry = 'design_link';
      }
      ga('designer_opened', { entry_point: entry });
    }, 0);
  })();

  /* ---------- size variants (like the wooden puzzle's 30 / 60 piece): the hero's option buttons show sizes ---------- */
  if (CFG.sizeMode) (function () {
    var info = {};
    String(CFG.sizeLines || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|').map(function (x) { return x.trim(); });
      if (p[0]) info[p[0].toLowerCase()] = { sub: p[1] || '', dims: p[2] || '' };
    });
    function setDimsLine(text) {      /* same layout as the hero: the part after " - " is hidden on phones */
      var el = document.querySelector('[data-dims]');
      if (!el || !text) return;
      var cut = text.indexOf(' - ');
      el.textContent = '';
      var main = document.createElement('span'); main.className = 'pix-dims-main';
      main.textContent = cut > -1 ? text.slice(0, cut) : text; el.appendChild(main);
      if (cut > -1) { var more = document.createElement('span'); more.className = 'pix-dims-more'; more.textContent = text.slice(cut); el.appendChild(more); }
    }
    document.querySelectorAll('.pix-orient').forEach(function (b) {
      var v = b.getAttribute('data-value') || '', d = info[v.toLowerCase()] || {};
      var name = b.querySelector('b'), sub = b.querySelector('.pix-osub');
      if (name) name.textContent = v;
      if (sub) sub.textContent = d.sub || '';
      b.classList.add('pix-size');
      b.addEventListener('click', function () { setDimsLine(d.dims); if (modal && !modal.hidden) draw(); });
      if (b.classList.contains('active')) setDimsLine(d.dims);
    });
    document.documentElement.classList.add('pixup-sizes');
  })();

  /* ---------- step 2: the keepsake tin's lid ----------
     Settings come from <script id="pixup-tin"> in snippets/pix-designer-styles.liquid (sizes in inches).
     The lid shows the whole puzzle picture, so it doubles as the picture to build from. Layouts:
       classic  lid colour, piece count and logo across the top, the puzzle picture below
       photo    the puzzle picture over the whole lid
     The print file is the lid at TINCFG.dpi with TINCFG.bleed inches extra on every side. */
  var TINCFG = null;
  try { var tinCfgEl = document.getElementById('pixup-tin'); if (tinCfgEl) TINCFG = JSON.parse(tinCfgEl.textContent); } catch (e) { TINCFG = null; }
  var TIN = !!(TINCFG && TINCFG.enabled !== false && +TINCFG.w > 0 && +TINCFG.h > 0);
  var TIN_COLORS = [['#FFFFFF', 'White'], ['#F4EEE2', 'Cream'], ['#22314A', 'Navy'], ['#1F1F1F', 'Black'], ['#8E2B2B', 'Cranberry'], ['#2E5A43', 'Evergreen'], ['#2D5DA8', 'Blue']];
  var tin = { layout: 'classic', color: '#FFFFFF', title: '', badge: { x: 0, y: 0 } };      /* badge: where the piece count sits on a Full photo lid (0-1 across and down) */
  var step = 1, tinPanel = null, tinCtl = null, lidCv = null, tinPuzzle = null, tinDirty = true, T3 = null, threeP = null, tinFontsP = null, tinGuide = false;
  /* nothing is printed closer than this to the lid's edge (inches; snippets/pix-designer-styles.liquid "safe") */
  function tinSafe() { var v = parseFloat(tinSpec().safe); return isNaN(v) || v < 0 ? 0.5 : v; }
  /* which tin this puzzle comes in: the large one (the main settings), or the "small" one for puzzles of up to
     small.upTo pieces. The small settings replace the main ones they name. "pieces" can then change settings
     for one piece count (like the 1000 piece puzzle's lid designs): { "1000": { "layouts": ["classic"] } } */
  function tinSpec() {
    var sm = TINCFG.small, n = parseInt(tinPieces(), 10), out = {}, k;
    for (k in TINCFG) out[k] = TINCFG[k];
    out.name = 'large';
    if (sm && n > 0 && n <= (+sm.upTo || 0)) { for (k in sm) out[k] = sm[k]; out.name = 'small'; }
    var one = TINCFG.pieces && n > 0 ? TINCFG.pieces[String(n)] : null;
    if (one && typeof one === 'object') for (k in one) if (k !== 'name') out[k] = one[k];
    if (!Array.isArray(out.layouts) || !out.layouts.length) out.layouts = ['classic', 'photo'];
    return out;
  }
  function tinLayoutOk() { var L = tinSpec().layouts; if (L.indexOf(tin.layout) < 0) tin.layout = L[0]; }      /* a lid design this tin offers */
  /* 8.625 -> "8⅝" */
  function inchText(v) {
    var n = Math.round(+v * 8), w = Math.floor(n / 8), f = n % 8, fr = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'][f];
    return (w || !f ? w : '') + fr;
  }
  var NEXT_HTML = '<span>Next: Design Your Tin</span><svg class="pixup-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function tinDark(c) { var n = parseInt(String(c).slice(1), 16) || 0; return ((n >> 16 & 255) * 299 + (n >> 8 & 255) * 587 + (n & 255) * 114) / 1000 < 150; }
  function tinColorName(c) { for (var i = 0; i < TIN_COLORS.length; i++) if (TIN_COLORS[i][0] === c) return TIN_COLORS[i][1].toLowerCase(); return c; }
  /* the lid turns with the puzzle: landscape puzzles get a landscape lid, portrait puzzles a portrait one */
  function tinDims() { var S = tinSpec(), a = +S.w, b = +S.h; return design.tall ? { w: Math.min(a, b), h: Math.max(a, b) } : { w: Math.max(a, b), h: Math.min(a, b) }; }
  function tinPieces() {      /* "500" from "500 Piece Custom Puzzle", or from a size variant like "60 Piece" */
    var src = [variantTitle(activeVid()), QUICK && curProd ? curProd.title : (TINCFG.productTitle || '')];
    for (var i = 0; i < src.length; i++) { var m = String(src[i] || '').match(/(\d[\d,]*)\s*-?\s*(?:piece|pc)/i); if (m) return m[1].replace(/,/g, ''); }
    return '';
  }
  function tinFonts() {
    if (!tinFontsP) tinFontsP = !document.fonts || !document.fonts.load ? Promise.resolve() :
      Promise.all(['800 40px "Bricolage Grotesque"', '700 40px "Figtree"', '800 40px "Figtree"'].map(function (f) { return document.fonts.load(f).catch(function () {}); }));
    return tinFontsP;
  }
  var tinLogos = {};
  function tinLogo(dark) {      /* the light logo on dark lids, the dark one on light lids */
    var u = dark ? TINCFG.logoLight : TINCFG.logoDark; if (!u) return null;
    var e = tinLogos[u];
    if (!e) {
      e = tinLogos[u] = { img: new Image(), ok: false };
      e.p = new Promise(function (res) {
        e.img.crossOrigin = 'anonymous';
        e.img.onload = function () { e.ok = true; res(e); tinChanged(); };
        e.img.onerror = function () { log('tin logo did not load:', u); res(e); };
        e.img.src = u;
      });
    }
    return e;
  }
  /* the puzzle picture without puzzle lines; longest side px */
  function tinPuzzleImg(px, hi) {
    var A = aspect(), c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(A >= 1 ? px : px * A)); c.height = Math.max(1, Math.round(A >= 1 ? px / A : px));
    paint(c.getContext('2d'), c.width, c.height, !!hi, design, !hi);
    return c;
  }
  function tinImage() { if (!tinPuzzle || tinDirty) { tinPuzzle = tinPuzzleImg(1400, false); tinDirty = false; } return tinPuzzle; }
  /* classic layout, in inches from the lid's top-left corner */
  var HEAD_H = 0.46, HEAD_GAP = 0.26;      /* header row height (the logo's height) and the space under it, inches */
  function lidLayout(d) {
    var m = tinSafe(), hh = m + HEAD_H + HEAD_GAP, A = aspect(), aw = d.w - 2 * m, ah = d.h - hh - m;
    var pw = Math.min(aw, ah * A), ph = pw / A;
    return { m: m, hh: hh, photo: { x: m + (aw - pw) / 2, y: hh + (ah - ph) / 2, w: pw, h: ph } };
  }
  /* paint the lid: ppi = canvas pixels per inch, bleed = inches added on every side */
  function drawLid(g, ppi, img, bleed, screen) {
    var d = tinDims(), b = bleed || 0, k = function (v) { return v * ppi; }, dark = tinDark(tin.color);
    var W = k(d.w + 2 * b), H = k(d.h + 2 * b), ox = k(b), oy = k(b);
    g.save(); g.imageSmoothingQuality = 'high';
    if (tin.layout === 'photo') {
      var s = Math.max(W / img.width, H / img.height);
      g.drawImage(img, (W - img.width * s) / 2, (H - img.height * s) / 2, img.width * s, img.height * s);
      var bx = badgeBox(d);
      if (bx) {      /* the piece count on a soft white tag, so it reads on dark photos too */
        g.fillStyle = 'rgba(255,255,255,.8)'; g.beginPath(); roundRectPath(g, ox + k(bx.x), oy + k(bx.y), k(bx.w), k(bx.h), k(0.12)); g.fill();
        var bl = oy + k(bx.y + bx.h / 2 + bx.asc / 2);
        g.fillStyle = '#22314A'; g.textAlign = 'left'; g.textBaseline = 'alphabetic';
        g.font = '800 ' + k(BADGE_NUM) + 'px "Bricolage Grotesque", "Figtree", sans-serif'; g.fillText(bx.pcs, ox + k(bx.x + BADGE_PAD), bl);
        g.font = '800 ' + k(BADGE_LBL) + 'px "Figtree", system-ui, sans-serif';
        if ('letterSpacing' in g) g.letterSpacing = k(0.02) + 'px';
        g.fillText('PIECES', ox + k(bx.x + BADGE_PAD + bx.nw + 0.07), bl);
        if ('letterSpacing' in g) g.letterSpacing = '0px';
      }
      if (screen && tinGuide) safeGuide(g, k, ox, oy, d);
      g.restore(); return;
    }
    var L = lidLayout(d), P = L.photo, ink = dark ? '#FFFFFF' : '#22314A';
    g.fillStyle = tin.color; g.fillRect(0, 0, W, H);
    g.fillStyle = '#FFFFFF'; g.fillRect(ox + k(P.x), oy + k(P.y), k(P.w), k(P.h));      /* no drop shadow: nothing may spill into the safe border */
    g.drawImage(img, ox + k(P.x), oy + k(P.y), k(P.w), k(P.h));
    /* across the top, inside the safe area: piece count, title (centred on the lid, always full size), logo,
       all centred on one line */
    var hd = lidHead(d), left = ox + k(L.m), right = ox + k(d.w - L.m), mid = L.m + HEAD_H / 2, base = oy + k(mid + hd.asc / 2);
    g.fillStyle = ink; g.textAlign = 'left'; g.textBaseline = 'alphabetic';
    if (hd.pcs) {
      g.font = '800 ' + k(0.5) + 'px "Bricolage Grotesque", "Figtree", sans-serif';
      var nw = g.measureText(hd.pcs).width; g.fillText(hd.pcs, left, base);
      g.font = '800 ' + k(0.13) + 'px "Figtree", system-ui, sans-serif';
      if ('letterSpacing' in g) g.letterSpacing = k(0.025) + 'px';
      g.fillText('PIECES', left + nw + k(0.09), base);
      if ('letterSpacing' in g) g.letterSpacing = '0px';
    }
    if (hd.logo) {
      g.drawImage(hd.logo.img, right - k(hd.lw), oy + k(mid - hd.lh / 2), k(hd.lw), k(hd.lh));
    } else {
      g.font = '800 ' + k(0.26) + 'px "Bricolage Grotesque", "Figtree", sans-serif'; g.textAlign = 'right';
      g.fillText('Pix on Puzzles', right, oy + k(mid + 0.09)); g.textAlign = 'left';
    }
    var t = tinTitle();
    if (t) {      /* the title box only ever holds what fits (fitTinTitle), so it is drawn as is */
      g.font = titleFont(k(TITLE_IN)); g.textAlign = 'center';
      g.fillText(t, ox + k(d.w / 2), oy + k(mid + hd.tasc / 2)); g.textAlign = 'left';
    }
    if (screen && tinGuide) safeGuide(g, k, ox, oy, d);
    g.restore();
  }
  /* the safe area, shown while the piece count is dragged */
  function safeGuide(g, k, ox, oy, d) {
    var m = tinSafe();
    g.save(); g.setLineDash([k(0.08), k(0.06)]); g.lineWidth = Math.max(1, k(0.015));
    g.strokeStyle = 'rgba(255,255,255,.9)'; g.strokeRect(ox + k(m), oy + k(m), k(d.w - 2 * m), k(d.h - 2 * m));
    g.lineDashOffset = k(0.07); g.strokeStyle = '#E0287D'; g.strokeRect(ox + k(m), oy + k(m), k(d.w - 2 * m), k(d.h - 2 * m));
    g.restore();
  }
  /* ---------- Full photo lid: the piece count tag, dragged anywhere inside the safe area ---------- */
  var BADGE_NUM = 0.42, BADGE_LBL = 0.12, BADGE_PAD = 0.16;
  function badgeBox(d) {      /* inches from the lid's top-left corner */
    var pcs = tinPieces(); if (!pcs) return null;
    var g = mg(), m = tinSafe();
    g.font = '800 ' + BADGE_NUM * 100 + 'px "Bricolage Grotesque", "Figtree", sans-serif';
    var tm = g.measureText(pcs), nw = tm.width / 100, asc = (tm.actualBoundingBoxAscent || BADGE_NUM * 72) / 100;
    g.font = '800 ' + BADGE_LBL * 100 + 'px "Figtree", system-ui, sans-serif';
    if ('letterSpacing' in g) g.letterSpacing = '2px';
    var lw = g.measureText('PIECES').width / 100;
    if ('letterSpacing' in g) g.letterSpacing = '0px';
    var w = nw + 0.07 + lw + 2 * BADGE_PAD, h = asc + 0.26, b = tin.badge || { x: 0, y: 0 };
    var cx = clamp(b.x * d.w, m + w / 2, d.w - m - w / 2), cy = clamp(b.y * d.h, m + h / 2, d.h - m - h / 2);
    return { pcs: pcs, nw: nw, asc: asc, w: w, h: h, x: cx - w / 2, y: cy - h / 2 };
  }
  function bindBadgeDrag() {
    var drag = null;
    function at(e) { var r = lidCv.getBoundingClientRect(), d = tinDims(); return { x: (e.clientX - r.left) / r.width * d.w, y: (e.clientY - r.top) / r.height * d.h }; }
    function hit(p) {
      var b = tin.layout === 'photo' && step === 2 ? badgeBox(tinDims()) : null, s = 0.12;
      return b && p.x >= b.x - s && p.x <= b.x + b.w + s && p.y >= b.y - s && p.y <= b.y + b.h + s ? b : null;
    }
    lidCv.addEventListener('pointerdown', function (e) {
      if (busy) return;
      var p = at(e), b = hit(p); if (!b) return;
      e.preventDefault(); try { lidCv.setPointerCapture(e.pointerId); } catch (err) {}
      drag = { dx: p.x - (b.x + b.w / 2), dy: p.y - (b.y + b.h / 2), id: e.pointerId };
      tinGuide = true; lidCv.style.cursor = 'grabbing'; drawTinFlat();
    });
    lidCv.addEventListener('pointermove', function (e) {
      var p = at(e);
      if (!drag) { lidCv.style.cursor = hit(p) ? 'grab' : ''; return; }
      if (e.pointerId !== drag.id) return;
      var d = tinDims(); tin.badge = { x: (p.x - drag.dx) / d.w, y: (p.y - drag.dy) / d.h };
      drawTinFlat();
    });
    function end() {
      if (!drag) return;
      drag = null; tinGuide = false; lidCv.style.cursor = '';
      var d = tinDims(), b = badgeBox(d);      /* keep where it actually landed (inside the safe area) */
      if (b) tin.badge = { x: (b.x + b.w / 2) / d.w, y: (b.y + b.h / 2) / d.h };
      tinChanged(); ga('tin_piece_count_moved');
    }
    lidCv.addEventListener('pointerup', end); lidCv.addEventListener('pointercancel', end);
  }
  /* ---------- the lid's title: one size, centred on the lid, between the piece count and the logo ---------- */
  var TITLE_IN = 0.26, TITLE_GAP = 0.25, measureG = null;
  function titleFont(px) { return '700 ' + px + 'px "Figtree", system-ui, sans-serif'; }
  function tinTitle(t) { return String(t == null ? tin.title : t || '').replace(/\s+/g, ' ').trim(); }
  function mg() { if (!measureG) measureG = document.createElement('canvas').getContext('2d'); return measureG; }
  /* the header in inches: where the piece count ends and where the logo starts (measured at 100 px per inch) */
  function lidHead(d) {
    var g = mg(), m = lidLayout(d).m, pcs = tinPieces(), end = m, lg = tinLogo(tinDark(tin.color)), lw, lh = HEAD_H, logo = null, asc = 0.36, tasc = 0.19;
    g.font = titleFont(TITLE_IN * 100); tasc = (g.measureText('H').actualBoundingBoxAscent || TITLE_IN * 72) / 100;
    if (pcs) {
      g.font = '800 50px "Bricolage Grotesque", "Figtree", sans-serif';
      var pm = g.measureText(pcs); end += pm.width / 100 + 0.09; asc = Math.min(HEAD_H, (pm.actualBoundingBoxAscent || 36) / 100);
      g.font = '800 13px "Figtree", system-ui, sans-serif';
      if ('letterSpacing' in g) g.letterSpacing = '2.5px';
      end += g.measureText('PIECES').width / 100;
      if ('letterSpacing' in g) g.letterSpacing = '0px';
    }
    if (lg && lg.ok && lg.img.naturalWidth) {
      logo = lg; lw = lh * lg.img.naturalWidth / lg.img.naturalHeight;
      if (lw > 2.1) { lw = 2.1; lh = lw * lg.img.naturalHeight / lg.img.naturalWidth; }
    } else { g.font = '800 26px "Bricolage Grotesque", "Figtree", sans-serif'; lw = g.measureText('Pix on Puzzles').width / 100; }
    return { pcs: pcs, end: end, start: d.w - m - lw, lw: lw, lh: lh, logo: logo, asc: asc, tasc: tasc };
  }
  /* the widest title, in inches, that stays centred without touching the piece count or the logo */
  function titleRoom() {
    var d = tinDims(), h = lidHead(d), c = d.w / 2;
    return Math.max(0, 2 * Math.min(c - h.end - TITLE_GAP, h.start - TITLE_GAP - c));
  }
  function titleFits(t, room) {      /* a space typed at the end counts, so the next word has room too */
    t = String(t || '').replace(/\s+/g, ' ').replace(/^ /, ''); if (!t) return true;
    var g = mg(); g.font = titleFont(TITLE_IN * 100);
    return g.measureText(t).width / 100 <= (room == null ? titleRoom() : room);
  }
  /* keep the saved title within what fits (the lid, piece count or logo can change after it was typed) */
  function fitTinTitle() {
    var room = titleRoom(), t = tin.title, cut = false;
    while (t && !titleFits(t, room)) { t = t.slice(0, -1); cut = true; }
    if (cut) { tin.title = t.replace(/\s+$/, ''); syncTitleBox(true); }
    return cut;
  }
  function syncTitleBox(full) {
    var box = tinCtl && tinCtl.querySelector('.pixup-tintitle'), tip = tinCtl && tinCtl.querySelector('.pixup-tintip');
    if (box && box.value !== tin.title) box.value = tin.title;
    if (tip) tip.innerHTML = full ? '<span class="pixup-tinmax">That\'s as long as the title can be on this lid.</span>' : TITLE_TIP;
  }
  var TITLE_TIP = 'Printed in the middle of the top of the lid. It stops when the lid is full.';
  /* typing or pasting: keep only as much of the new text as fits */
  function typeTitle(el) {
    var old = tin.title, now = el.value.replace(/\s{2,}/g, ' ').replace(/^\s+/, ''), room = titleRoom();
    if (titleFits(now, room)) { tin.title = now; syncTitleBox(false); return; }
    var p = 0, s = 0;
    while (p < old.length && p < now.length && old[p] === now[p]) p++;
    while (s < old.length - p && s < now.length - p && old[old.length - 1 - s] === now[now.length - 1 - s]) s++;
    var head = now.slice(0, p), add = now.slice(p, now.length - s), tail = now.slice(now.length - s);
    while (add && !titleFits(head + add + tail, room)) add = add.slice(0, -1);
    tin.title = titleFits(head + add + tail, room) ? head + add + tail : old;
    if (!titleFits(tin.title, room)) fitTinTitle();
    el.value = tin.title;
    try { el.setSelectionRange(p + add.length, p + add.length); } catch (e) {}
    syncTitleBox(true);
  }
  /* the lid print file: the lid plus the bleed, at TINCFG.dpi */
  function exportLid(src) {
    var d = tinDims(), dpi = +TINCFG.dpi || 300, b = +TINCFG.bleed || 0, A = aspect();
    var c = document.createElement('canvas'); c.width = Math.round((d.w + 2 * b) * dpi); c.height = Math.round((d.h + 2 * b) * dpi);
    var need = tin.layout === 'photo' ? (A >= 1 ? Math.max(c.width, c.height * A) : Math.max(c.height, c.width / A)) : Math.max(lidLayout(d).photo.w, lidLayout(d).photo.h) * dpi;
    var g = c.getContext('2d'); g.fillStyle = '#FFFFFF'; g.fillRect(0, 0, c.width, c.height);
    drawLid(g, dpi, shrink(src, Math.ceil(need)), b);
    return c;
  }
  function sendLid(blob, onProg) {      /* an upload service without the "lid" type yet stores it like a print file */
    return send(blob, 'image/jpeg', 'lid', group, onProg).catch(function (e) {
      if (!/unknown kind/i.test(e && e.message || '')) throw e;
      return send(blob, 'image/jpeg', 'cropped', group, onProg);
    });
  }
  function tinNotes(lidUrl) {
    var S = tinSpec(), n = S.name + ' tin (' + inchText(S.w) + ' x ' + inchText(S.h) + ' in) lid: ' + (tin.layout === 'photo' ? 'full photo' : 'classic, ' + tinColorName(tin.color) + ' lid');
    var t = String(tin.title || '').replace(/\s+/g, ' ').trim();
    if (tin.layout !== 'photo' && t) n += ', title "' + t + '"';
    if (!lidUrl) n += ' (LID FILE NOT SAVED: make the lid from the print file)';
    return n;
  }

  /* ---------- the tin step's window ---------- */
  function tinMarkup() {
    return '<div class="pixup-tin" hidden><div class="pixup-tinstage"><canvas class="pixup-lidcv" role="img" aria-label="Your tin lid"></canvas><p class="pixup-tinnote"></p></div>' +
      '<div class="pixup-tinside"><div class="pixup-tinctl"></div>' +
      '<div class="pixup-sec pixup-sec3d" role="group" aria-label="3D preview"><div class="pixup-pickhead pixup-3dhead"><b>3D preview</b><button type="button" class="pixup-x" data-act="tin3dclose" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<h3>3D preview</h3><div class="pixup-tin3d" data-state="idle"><div class="pixup-tin3dmsg">Loading the 3D preview…</div></div>' +
      '<p class="pixup-tip">Drag to turn the tin around.</p></div></div></div>';
  }
  var TIN_CSS = '.pixup-ttl{display:flex;align-items:center;gap:10px;min-width:0}.pixup-3dhead{display:none}' +
    /* the button's text and arrow stay on one line, whatever the theme does to icons */
    '.pixup-modal .pixup-add{display:inline-flex;align-items:center;justify-content:center;gap:8px;white-space:nowrap}' +
    '.pixup-modal .pixup-add .pixup-arrow{display:inline-block;flex:none;width:18px;height:18px;max-width:none;margin:0}' +
    '.pixup-tinmax{color:#9B5B00;font-weight:700}' +
    '.pixup-btns.pixup-corners{display:grid;grid-template-columns:1fr 1fr}' +
    '.pixup-stepnum{flex:none;padding:3px 9px;border-radius:999px;background:#F3EDE0;color:#52607A;font-size:.72rem;font-weight:800;letter-spacing:.05em;text-transform:uppercase}' +
    '.pixup-tin{flex:1 1 auto;min-height:0;display:grid;grid-template-columns:minmax(0,1fr) 348px}' +
    '.pixup-tin[hidden],.pixup-body[hidden]{display:none}' +
    '.pixup-tinstage{min-width:0;min-height:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:18px;background:#FBF8F1}' +
    '.pixup-lidcv{display:block;max-width:100%;touch-action:none;filter:drop-shadow(0 1px 2px rgba(34,49,74,.2)) drop-shadow(0 10px 22px rgba(34,49,74,.2))}' +
    '.pixup-tinnote{flex:none;margin:0;font-size:.84rem;font-weight:600;color:#52607A;text-align:center}' +
    '.pixup-tinside{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px 18px 18px;border-left:1px solid #E4DCCB;display:flex;flex-direction:column;gap:16px}' +
    '.pixup-tinside>*,.pixup-tinctl>*{flex-shrink:0}.pixup-tinctl{display:flex;flex-direction:column;gap:16px}' +
    '.pixup-tiles rect.t{fill:#8C97A8;stroke:none}.pixup-tiles button[aria-pressed="true"] rect.t{fill:#2D5DA8}' +
    '.pixup-tintitle{display:block;width:100%;min-height:46px;padding:0 12px;border:1.5px solid #C9D6EA;border-radius:10px;background:#fff;color:#22314A;font:inherit;font-size:1rem}' +
    '.pixup-colors button[data-tincolor]{box-shadow:inset 0 0 0 1px rgba(34,49,74,.18)}' +
    '.pixup-tin3d{position:relative;height:250px;border-radius:14px;overflow:hidden;background:radial-gradient(120% 90% at 50% 35%,#FFFFFF 0,#F3EDE0 100%);touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none}' +
    '.pixup-tin3d:active{cursor:grabbing}.pixup-tin3d canvas{display:block;width:100%;height:100%}' +
    '.pixup-tin3dmsg{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:16px;text-align:center;font-size:.86rem;font-weight:600;color:#52607A}' +
    '.pixup-tin3d[data-state="ready"] .pixup-tin3dmsg{display:none}' +
    '@media (max-width:820px){.pixup-ttl b{font-size:1.05rem}.pixup-tin{display:flex;flex-direction:column}' +
      '.pixup-tinstage{flex:0 0 auto;height:34vh;height:34dvh;padding:10px 12px;gap:8px}.pixup-tinnote{font-size:.78rem}' +
      '.pixup-tinside{flex:1 1 auto;min-height:0;border-left:0;border-top:1px solid #E4DCCB;padding:12px 16px 16px;gap:14px}.pixup-tin3d{height:220px}}' +
    /* small phones: "Next: Design Your Tin" still fits on one line */
    '@media (max-width:360px){.pixup-modal .pixup-add{font-size:.95rem;padding:0 10px;gap:6px}.pixup-modal .pixup-foot .pixup-ghost{padding:0 2px}}';

  /* ---------- numbered back (an add-on: each piece's row and column printed on its back) ----------
     Settings come from <script id="pixup-back"> in snippets/pix-designer-styles.liquid (the add-on product,
     its price, the example pictures). The customer says yes or no on the last step, just above Add to cart.
     A yes adds the add-on product as its own cart line, tied to this design by "_Pix For" (= the design's
     "_Pix Edit" id); assets/pix-cart-addons.js keeps it in step with the puzzle in the cart. */
  var BACK = null;
  try { var backCfgEl = document.getElementById('pixup-back'); if (backCfgEl) BACK = JSON.parse(backCfgEl.textContent); } catch (e) { BACK = null; }
  if (BACK && (BACK.enabled === false || !(+BACK.variant > 0))) BACK = null;
  var backOn = false, backEl = null, backCb = null, backViewEl = null;
  var ZOOM_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>';
  function backPieces() {      /* 500 from "500 Piece Custom Puzzle" (or a size variant like "60 Piece") */
    if (!BACK) return 0;
    var src = [variantTitle(activeVid()), QUICK && curProd ? curProd.title : (BACK.productTitle || '')];
    for (var i = 0; i < src.length; i++) { var m = String(src[i] || '').match(/(\d[\d,]*)\s*-?\s*(?:piece|pc)/i); if (m) return parseInt(m[1].replace(/,/g, ''), 10) || 0; }
    return 0;
  }
  function backOk() { return !!BACK && backPieces() >= (+BACK.minPieces || 100); }
  function backPrice() { return String(BACK && BACK.price || '').trim(); }
  function backMarkup() {
    var pr = backPrice();
    return '<div class="pixup-back" hidden>' +
      '<button type="button" class="pixup-backimg" data-backsee aria-label="See an example of the numbered back"><img src="' + esc(BACK.thumb || '') + '" alt="" width="54" height="54"><i>' + ZOOM_SVG + '</i></button>' +
      '<div class="pixup-backtxt"><label for="pixup-backcb"><b>Add a numbered back</b>' + (pr ? ' <em>+' + esc(pr) + '</em>' : '') + '</label>' +
        '<small>Each piece gets its spot (like C3) printed on the back. <button type="button" class="pixup-backlink" data-backsee>See example</button></small></div>' +
      '<label class="pixup-backsw"><input type="checkbox" id="pixup-backcb" role="switch" aria-label="Add a numbered back' + (pr ? ' for ' + esc(pr) : '') + '"><span aria-hidden="true"></span></label>' +
    '</div>' +
    '<div class="pixup-backview" hidden role="dialog" aria-modal="true" aria-label="Numbered back example"><div class="pixup-bvcard">' +
      '<div class="pixup-bvhead"><b>Numbered back</b><button type="button" class="pixup-x" data-backclose aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="pixup-bvbody"><div class="pixup-bvpics">' +
        '<figure><img data-bv="size" alt="The back of the whole puzzle, with every piece numbered"><figcaption data-bv="sizecap">The whole back, piece by piece</figcaption></figure>' +
        '<figure><img data-bv="close" alt="A piece turned over, showing C3 on its back"><figcaption>Flip a piece to see where it goes</figcaption></figure></div>' +
        '<p>Every piece is printed on the back with its column letter and row number. Stuck on a piece? Turn it over and you know exactly where it goes. Great for kids, gifts and big puzzles.</p></div>' +
      '<div class="pixup-bvfoot"><button type="button" class="pixup-ghost" data-backno>No thanks</button><button type="button" class="pixup-add" data-backyes></button></div>' +
    '</div></div>';
  }
  var BACK_CSS = '.pixup-back{display:grid;grid-template-columns:auto minmax(0,1fr) auto;align-items:center;gap:12px;margin:0;padding:10px 20px;border-top:1px solid #E4DCCB;background:#F7F3EA;transition:background-color .15s ease}' +
    '.pixup-back.is-on{background:#E2F3EA}' +
    '.pixup-backimg{position:relative;flex:none;width:54px;height:54px;padding:0;border:1.5px solid #E4DCCB;border-radius:10px;overflow:hidden;background:#fff;cursor:zoom-in}' +
    '.pixup-backimg img{display:block;width:100%;height:100%;object-fit:cover;max-width:none}' +
    '.pixup-backimg i{position:absolute;right:2px;bottom:2px;display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:rgba(255,255,255,.94);color:#22314A;box-shadow:0 1px 4px rgba(34,49,74,.25)}' +
    '.pixup-backtxt{min-width:0;line-height:1.3}.pixup-backtxt label{display:block;cursor:pointer;font-size:.98rem}' +
    '.pixup-backtxt em{font-style:normal;font-weight:800;color:#1F7A4D;white-space:nowrap}' +
    '.pixup-backtxt small{display:block;margin-top:2px;font-size:.8rem;color:#52607A}' +
    '.pixup-backlink{padding:0;border:0;background:none;color:#2D5DA8;font:inherit;font-weight:700;text-decoration:underline;text-underline-offset:2px;cursor:pointer;white-space:nowrap}' +
    '.pixup-backsw{position:relative;display:block;flex:none;width:52px;height:30px;cursor:pointer}' +
    '.pixup-backsw input{position:absolute;inset:0;width:100%;height:100%;margin:0;opacity:0;cursor:pointer}' +
    '.pixup-backsw span{position:absolute;inset:0;border-radius:15px;background:#C9CFD9;transition:background-color .15s ease;pointer-events:none}' +
    '.pixup-backsw span::after{content:"";position:absolute;left:3px;top:3px;width:24px;height:24px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(18,26,40,.3);transition:transform .15s ease}' +
    '.pixup-backsw input:checked+span{background:#1F7A4D}.pixup-backsw input:checked+span::after{transform:translateX(22px)}' +
    '.pixup-backsw input:focus-visible+span{outline:2px solid #2D5DA8;outline-offset:2px}' +
    '.pixup-backview{position:absolute;inset:0;z-index:6;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(18,26,40,.6)}' +
    '.pixup-bvcard{display:flex;flex-direction:column;width:100%;max-width:760px;max-height:100%;border-radius:18px;background:#fff;overflow:hidden;box-shadow:0 16px 50px rgba(18,26,40,.4)}' +
    '.pixup-bvhead{display:flex;align-items:center;justify-content:space-between;padding:10px 12px 10px 18px;border-bottom:1px solid #E4DCCB}' +
    '.pixup-bvhead b{font-family:"Bricolage Grotesque","Figtree",sans-serif;font-size:1.15rem;font-weight:800}' +
    '.pixup-bvbody{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px 18px}' +
    '.pixup-bvpics{display:grid;grid-template-columns:1fr 1fr;gap:12px}' +
    '.pixup-bvpics figure{margin:0}.pixup-bvpics img{display:block;width:100%;height:auto;aspect-ratio:1/1;object-fit:cover;border-radius:12px;background:#EEEAE1}' +
    '.pixup-bvpics figcaption{margin-top:6px;font-size:.82rem;font-weight:700;color:#52607A;text-align:center}' +
    '.pixup-bvbody p{margin:14px 0 0;font-size:.92rem;color:#22314A}' +
    '.pixup-bvfoot{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 18px;border-top:1px solid #E4DCCB}' +
    '.pixup-bvfoot .pixup-add{padding:0 26px}' +
    '@media (max-width:820px){.pixup-back{padding:9px 16px;gap:10px}.pixup-backimg{width:48px;height:48px}.pixup-backtxt label{font-size:.94rem}.pixup-backtxt small{font-size:.76rem}' +
      '.pixup-backview{padding:0;align-items:flex-end}.pixup-bvcard{max-width:none;max-height:92%;border-radius:18px 18px 0 0}' +
      '.pixup-bvbody{padding:12px 16px}.pixup-bvpics{gap:8px}.pixup-bvfoot{padding:10px 16px calc(12px + env(safe-area-inset-bottom))}.pixup-bvfoot .pixup-add{flex:1;padding:0 14px}}';
  function initBack() {
    backEl = modal.querySelector('.pixup-back'); backViewEl = modal.querySelector('.pixup-backview');
    if (!backEl) return;
    backCb = backEl.querySelector('input');
    backCb.addEventListener('change', function () { setBack(backCb.checked, 'designer'); });
    modal.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-backsee],[data-backclose],[data-backyes],[data-backno]') : null;
      if (!t) { if (backViewEl && !backViewEl.hidden && e.target === backViewEl) backView(false); return; }
      e.preventDefault();
      if (t.hasAttribute('data-backsee')) { backView(true); ga('numbered_back_example', {}); }
      else if (t.hasAttribute('data-backclose')) backView(false);
      else if (t.hasAttribute('data-backyes')) { if (!backOn) setBack(true, 'example'); backView(false); }
      else if (t.hasAttribute('data-backno')) { if (backOn) setBack(false, 'example'); backView(false); }
    });
    document.addEventListener('keydown', function (e) {      /* Escape closes the example first */
      if (e.key === 'Escape' && backViewEl && !backViewEl.hidden && !modal.hidden) { e.stopImmediatePropagation(); backView(false); }
    }, true);
  }
  function setBack(on, where) {
    backOn = !!on; backShow();
    ga('numbered_back_toggled', { on: backOn ? 'yes' : 'no', where: where || 'designer', pieces: backPieces() });
  }
  function backShow() {
    if (!backEl) return;
    var ok = backOk();
    backEl.hidden = !ok || (TIN && step !== 2);
    if (backCb) backCb.checked = backOn && ok;
    backEl.classList.toggle('is-on', backOn && ok);
  }
  function backView(open) {
    if (!backViewEl) return;
    if (!open) { backViewEl.hidden = true; return; }
    var n = backPieces(), sizes = BACK.sizes || {}, big = sizes[String(n)] || sizes['500'] || '';
    var im = backViewEl.querySelector('[data-bv="size"]'), cl = backViewEl.querySelector('[data-bv="close"]'), cap = backViewEl.querySelector('[data-bv="sizecap"]');
    if (im && big && im.getAttribute('src') !== big) im.src = big;
    if (cl && BACK.closeup && cl.getAttribute('src') !== BACK.closeup) cl.src = BACK.closeup;
    if (cap) cap.textContent = n ? 'The back of a ' + n + ' piece puzzle' : 'The whole back, piece by piece';
    var yes = backViewEl.querySelector('[data-backyes]'), no = backViewEl.querySelector('[data-backno]'), pr = backPrice();
    if (yes) yes.textContent = backOn ? 'Keep it' : 'Add it' + (pr ? ' · +' + pr : '');
    if (no) no.textContent = backOn ? 'Remove it' : 'No thanks';
    backViewEl.hidden = false;
    var f = backViewEl.querySelector('[data-backclose]'); if (f) f.focus({ preventScroll: true });
  }
  function formQty() { var q = form && form.querySelector('[name="quantity"]'); return Math.max(1, parseInt(q && q.value, 10) || 1); }
  function backFor() {      /* shown with the add-on in checkout, emails and the order */
    var t = QUICK && curProd ? curProd.title : (BACK.productTitle || 'Puzzle');
    return t + ', ' + (design.tall ? 'Portrait' : 'Landscape');
  }
  function addBackLine(qty, forId) {
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +BACK.variant, quantity: qty || 1, properties: { 'For': backFor(), '_Pix For': forId } }] })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); });
  }
  function initTinDom() {
    tinPanel = modal.querySelector('.pixup-tin'); if (!tinPanel) return;
    tinCtl = tinPanel.querySelector('.pixup-tinctl'); lidCv = tinPanel.querySelector('.pixup-lidcv');
    bind3DPointer(tinPanel.querySelector('.pixup-tin3d'));
    bindBadgeDrag();
  }
  function renderTinSide() {
    if (!tinCtl) return;
    var S = tinSpec(), note = tinPanel.querySelector('.pixup-tinnote');
    if (note) note.textContent = 'Printed on the lid of your ' + inchText(S.w) + ' × ' + inchText(S.h) + ' in. keepsake tin';
    if (isPhone() && tinTool !== 'lid') {      /* phones: two buttons, like the puzzle's tools */
      tinCtl.innerHTML = '<div class="pixup-tools"><button type="button" data-act="tlid">' + ICON_LID + '<span>Lid design</span><small>' +
        (tin.layout === 'photo' ? 'Full photo' : 'Classic, ' + tinColorName(tin.color)) + '</small></button>' +
        '<button type="button" data-act="tin3d">' + ICON_3D + '<span>3D preview</span><small>Turn the tin around</small></button></div>';
      return;
    }
    var lays =[['classic', 'Classic', '<rect x="1" y="1" width="62" height="50" rx="6"/><rect class="t" x="7" y="7" width="13" height="5" rx="1"/><rect class="t" x="44" y="7" width="13" height="5" rx="1"/><rect class="f" x="8" y="16" width="48" height="30" rx="1"/>'],
                ['photo', 'Full photo', '<rect class="f" x="1" y="1" width="62" height="50" rx="6"/>']];
    var offered = tinSpec().layouts;
    lays = lays.filter(function (l) { return offered.indexOf(l[0]) > -1; });
    var h = lays.length < 2 ? '' : '<div class="pixup-sec"><h3>Lid design</h3><div class="pixup-tiles">' + lays.map(function (l) {
      return '<button type="button" data-tinlay="' + l[0] + '" aria-pressed="' + (tin.layout === l[0]) + '"><svg viewBox="0 0 64 52" aria-hidden="true">' + l[2] + '</svg><span>' + l[1] + '</span></button>';
    }).join('') + '</div></div>';
    if (tin.layout !== 'photo') {
      h += '<div class="pixup-sec"><h3>Lid color</h3><div class="pixup-colors">' + TIN_COLORS.map(function (c) {
        return '<button type="button" data-tincolor="' + c[0] + '" aria-pressed="' + (tin.color === c[0]) + '" aria-label="' + c[1] + '" title="' + c[1] + '" style="background:' + c[0] + '"></button>';
      }).join('') + '</div></div>' +
      '<div class="pixup-sec"><h3>Title <small>(optional)</small></h3><input type="text" class="pixup-tintitle" data-f="tintitle" maxlength="40" value="' + esc(tin.title) + '" placeholder="Like: The Millers 2026" aria-label="Title on the lid">' +
      '<p class="pixup-tip pixup-tintip">' + TITLE_TIP + '</p></div>';
    } else if (tinPieces()) {
      h += '<div class="pixup-sec"><h3>Piece count</h3><p class="pixup-tip" style="margin:0 0 9px">Drag it on the lid to place it, or pick a corner.</p>' +
        '<div class="pixup-btns pixup-corners">' + [['tl', 'Top left'], ['tr', 'Top right'], ['bl', 'Bottom left'], ['br', 'Bottom right']].map(function (c) {
          return '<button type="button" data-tinpos="' + c[0] + '">' + c[1] + '</button>';
        }).join('') + '</div></div>';
    } else {
      h += '<p class="pixup-tip" style="margin:0">Your puzzle picture covers the whole lid, edge to edge.</p>';
    }
    if (isPhone()) h = '<div class="pixup-tpanel pixup-lidpanel" role="group" aria-label="Lid design">' + toolHead('Lid design', '').replace('data-act="tdone"', 'data-act="tliddone"') + h + '</div>';
    tinCtl.innerHTML = h;
  }
  /* phones: the tin's 3D preview opens as a popup */
  function is3D() { return !!(tinPanel && tinPanel.classList.contains('is-3d')); }
  function open3D() {
    if (!tinPanel) return;
    tinPanel.classList.add('is-3d');
    requestAnimationFrame(function () { if (T3 && T3.ready) T3.sized = false; start3D(); });
    ga('tin_3d_opened', {});
  }
  function close3D() { if (!is3D()) return; tinPanel.classList.remove('is-3d'); stop3D(); }
  function drawTinFlat() {
    if (!lidCv || step !== 2) return;
    var d = tinDims(), box = lidCv.parentNode, note = box.querySelector('.pixup-tinnote');
    var bw = box.clientWidth - 36, bh = box.clientHeight - 36 - (note ? note.offsetHeight + 14 : 0);
    var ppi = Math.max(8, Math.min(bw / d.w, bh / d.h)), dpr = Math.min(2, window.devicePixelRatio || 1);
    var w = Math.round(d.w * ppi), h = Math.round(d.h * ppi);
    lidCv.style.width = w + 'px'; lidCv.style.height = h + 'px';
    if (lidCv.width !== Math.round(w * dpr) || lidCv.height !== Math.round(h * dpr)) { lidCv.width = Math.round(w * dpr); lidCv.height = Math.round(h * dpr); }
    var g = lidCv.getContext('2d'), P = ppi * dpr;
    g.clearRect(0, 0, lidCv.width, lidCv.height);
    g.save(); g.beginPath(); roundRectPath(g, 0, 0, lidCv.width, lidCv.height, (+tinSpec().radius || 0.45) * P); g.clip();
    drawLid(g, P, tinImage(), 0, true); g.restore();
    lidCv.style.borderRadius = Math.round((+tinSpec().radius || 0.45) * ppi) + 'px';      /* rounds the replay copy's corners like the lid's */
    mirrorSoon(lidCv, 'lid');
  }
  function tinChanged() {
    if (step !== 2) return;
    fitTinTitle();
    drawTinFlat();
    if (T3 && T3.ready) T3.dirty = true;
  }
  function goStep(n) {
    if (!TIN || !tinPanel) return;
    step = n === 2 ? 2 : 1;
    var body = modal.querySelector('.pixup-body'), ttl = modal.querySelector('.pixup-ttl b'), num = modal.querySelector('.pixup-stepnum');
    var ghost = modal.querySelector('.pixup-foot .pixup-ghost'), add = modal.querySelector('.pixup-foot .pixup-add');
    body.hidden = step === 2; tinPanel.hidden = step !== 2; msgEl.hidden = true;
    if (ttl) ttl.textContent = step === 2 ? 'Design your tin' : 'Design your puzzle';
    if (num) num.textContent = 'Step ' + step + ' of 2';
    ghost.setAttribute('data-act', step === 2 ? 'back' : 'cancel'); ghost.textContent = step === 2 ? 'Back' : 'Cancel';
    add.setAttribute('data-act', step === 2 ? 'add' : 'next');
    add.innerHTML = step === 2 ? addHtml() : NEXT_HTML;
    if (step === 2) {
      tinDirty = true; tinTool = null; tinLayoutOk(); renderTinSide(); fitTinTitle();
      tinFonts().then(function () { tinChanged(); });
      requestAnimationFrame(function () { drawTinFlat(); if (!isPhone()) start3D(); });      /* phones: the 3D view starts when its popup opens */
      ga('tin_step_opened', { layout: tin.layout });
    } else {
      close3D(); stop3D(); refresh(); requestAnimationFrame(draw);
    }
    backShow();
  }
  function nextStep() {
    if (design.slots.some(function (s) { return !s.photo; })) {
      refresh();
      say(design.slots.length > 1 ? 'Add a photo to every space, or choose a layout with fewer photos.' : 'Upload a photo to design your puzzle first.');
      return;
    }
    cropMode = false; popOn = false;
    goStep(2);
  }

  /* ---------- 3D preview of the tin (three.js, loaded only when the tin step opens) ---------- */
  function loadThree() {
    if (window.THREE && window.THREE.WebGLRenderer) return Promise.resolve(window.THREE);
    if (!threeP) threeP = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.async = true;
      s.src = TINCFG.three || 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
      s.onload = function () { if (window.THREE && window.THREE.WebGLRenderer) res(window.THREE); else rej(new Error('three')); };
      s.onerror = function () { threeP = null; rej(new Error('three')); };
      document.head.appendChild(s);
    });
    return threeP;
  }
  function tin3DFail(box, why) {
    T3 = { failed: true };
    if (box) { box.setAttribute('data-state', 'failed'); var m = box.querySelector('.pixup-tin3dmsg'); if (m) m.textContent = 'The 3D preview is not available on this device. The lid above shows exactly what will print.'; }
    log('3D preview off:', why);
  }
  function start3D() {
    var box = tinPanel && tinPanel.querySelector('.pixup-tin3d'); if (!box || (T3 && T3.failed)) return;
    if (T3 && T3.ready) { T3.dirty = true; T3.sized = false; run3D(); return; }
    if (T3 && T3.loading) return;
    T3 = { loading: true };
    loadThree().then(function (THREE) { init3D(THREE, box); if (step === 2 && T3.ready) run3D(); })
      .catch(function (e) { tin3DFail(box, e && e.message); });
  }
  function stop3D() { if (T3) T3.running = false; }
  function rrShape(THREE, w, d, r) {
    var s = new THREE.Shape(), x0 = -w / 2, y0 = -d / 2, x1 = w / 2, y1 = d / 2;
    r = Math.max(0.001, Math.min(r, w / 2, d / 2));
    s.moveTo(x0 + r, y0); s.lineTo(x1 - r, y0); s.absarc(x1 - r, y0 + r, r, -Math.PI / 2, 0, false);
    s.lineTo(x1, y1 - r); s.absarc(x1 - r, y1 - r, r, 0, Math.PI / 2, false);
    s.lineTo(x0 + r, y1); s.absarc(x0 + r, y1 - r, r, Math.PI / 2, Math.PI, false);
    s.lineTo(x0, y0 + r); s.absarc(x0 + r, y0 + r, r, Math.PI, Math.PI * 1.5, false);
    return s;
  }
  function slab(THREE, w, d, r, h, y, mat, bevel) {      /* a rounded block from y up to y + h */
    var bv = bevel || 0;
    var geo = new THREE.ExtrudeGeometry(rrShape(THREE, w - 2 * bv, d - 2 * bv, r - bv), { depth: Math.max(0.001, h - 2 * bv), bevelEnabled: bv > 0, bevelThickness: bv, bevelSize: bv, bevelSegments: 5, curveSegments: 18 });
    geo.rotateX(-Math.PI / 2); geo.translate(0, y + bv, 0);
    return new THREE.Mesh(geo, mat);
  }
  function roomEnv(THREE) {      /* a soft studio room, only used for reflections on the metal and the printed lid */
    var s = new THREE.Scene(), box = new THREE.BoxGeometry(1, 1, 1);
    var room = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: 0x7a7672, side: THREE.BackSide }));
    room.scale.set(40, 24, 40); room.position.y = 10; s.add(room);
    [[0, 21.5, 0, 16, 0.2, 16, 5], [-19.5, 9, 2, 0.2, 10, 14, 3.2], [19.5, 9, -4, 0.2, 8, 10, 1.6], [0, 7, 19.5, 18, 8, 0.2, 2.2]].forEach(function (p) {
      var m = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: new THREE.Color(p[6], p[6], p[6]) }));
      m.position.set(p[0], p[1], p[2]); m.scale.set(p[3], p[4], p[5]); s.add(m);
    });
    return s;
  }
  function init3D(THREE, box) {
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }); } catch (e) { tin3DFail(box, 'webgl'); return; }
    if (!renderer.getContext()) { tin3DFail(box, 'webgl'); return; }
    renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1)); renderer.setClearColor(0x000000, 0);
    box.insertBefore(renderer.domElement, box.firstChild);
    var scene = new THREE.Scene(), camera = new THREE.PerspectiveCamera(26, 1, 0.1, 200);
    var pm = new THREE.PMREMGenerator(renderer); scene.environment = pm.fromScene(roomEnv(THREE), 0.03).texture; pm.dispose();
    scene.add(new THREE.HemisphereLight(0xffffff, 0xcfc8bd, 0.35));
    var key = new THREE.DirectionalLight(0xffffff, 0.75); key.position.set(-5, 12, 8); scene.add(key);
    var rim = new THREE.DirectionalLight(0xffffff, 0.25); rim.position.set(7, 4, -6); scene.add(rim);
    var tc = document.createElement('canvas'), tex = new THREE.CanvasTexture(tc);
    tex.encoding = THREE.sRGBEncoding; tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    /* soft contact shadow under the tin */
    var sc = document.createElement('canvas'); sc.width = sc.height = 128;
    var sg = sc.getContext('2d'), gr = sg.createRadialGradient(64, 64, 10, 64, 64, 64);
    gr.addColorStop(0, 'rgba(34,40,52,.55)'); gr.addColorStop(0.55, 'rgba(34,40,52,.22)'); gr.addColorStop(1, 'rgba(34,40,52,0)');
    sg.fillStyle = gr; sg.fillRect(0, 0, 128, 128);
    var shadow = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false, toneMapped: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.y = -0.01;
    var pivot = new THREE.Group(); scene.add(pivot);
    var mats = {
      white: new THREE.MeshStandardMaterial({ color: new THREE.Color(0x9b9a95).convertSRGBToLinear(), roughness: 0.42, metalness: 0.6, envMapIntensity: 1 }),      /* satin grey tin (body and lid band) */
      silver: new THREE.MeshStandardMaterial({ color: new THREE.Color(0xb8b7b2).convertSRGBToLinear(), roughness: 0.32, metalness: 0.85, envMapIntensity: 1.15 }),      /* rolled rims, a touch brighter */
      edge: new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.55, metalness: 0, envMapIntensity: 0.45 }),
      face: new THREE.MeshBasicMaterial({ map: tex, toneMapped: false })      /* the print shows its true colours, with no glare */
    };
    T3 = { THREE: THREE, ready: true, renderer: renderer, scene: scene, camera: camera, pivot: pivot, shadow: shadow, tc: tc, tex: tex, mats: mats, box: box,
           yaw: -0.5, pitch: 0.5, auto: true, t0: (window.performance || Date).now(), running: false, dirty: true, sized: false, key: '' };
    scene.add(shadow);
    box.setAttribute('data-state', 'ready');
  }
  /* the tin's colour in the 3D preview: "grey" (large tin) or "white" (small tin) */
  var TIN_FINISH = {
    grey: { body: 0x9b9a95, br: 0.42, bm: 0.6, rim: 0xb8b7b2, rr: 0.32, rm: 0.85 },
    white: { body: 0xf3f3f0, br: 0.18, bm: 0, rim: 0xecebe8, rr: 0.22, rm: 0.15 }
  };
  function build3D() {      /* the tin, sized from the settings: lid face w x h, height "depth" */
    var THREE = T3.THREE, S = tinSpec(), d = tinDims(), W = d.w, D = d.h, H = +S.depth || 2.5, r = +S.radius || 0.45, lidH = Math.min(0.55, H * 0.3);
    var fin = TIN_FINISH[S.finish] || TIN_FINISH.grey;
    var key = W + 'x' + D + 'x' + H + 'x' + r + S.finish; if (T3.key === key) return; T3.key = key;
    while (T3.pivot.children.length) { var c = T3.pivot.children.pop(); if (c.geometry) c.geometry.dispose(); }
    var M = T3.mats, p = T3.pivot;
    M.white.color.set(fin.body).convertSRGBToLinear(); M.white.roughness = fin.br; M.white.metalness = fin.bm;
    M.silver.color.set(fin.rim).convertSRGBToLinear(); M.silver.roughness = fin.rr; M.silver.metalness = fin.rm;
    p.add(slab(THREE, W - 0.06, D - 0.06, r - 0.03, 0.07, 0, M.silver));                         /* rolled bottom edge */
    p.add(slab(THREE, W - 0.1, D - 0.1, r - 0.05, H - lidH - 0.03, 0.06, M.white));                /* body */
    p.add(slab(THREE, W + 0.03, D + 0.03, r + 0.015, 0.06, H - lidH - 0.02, M.silver));          /* rolled lid edge */
    p.add(slab(THREE, W, D, r, lidH - 0.1, H - lidH + 0.03, M.white));                            /* lid band */
    p.add(slab(THREE, W, D, r, 0.12, H - 0.12, M.edge, 0.045));                                    /* lid top, rounded edge */
    var fw = W - 0.09, fd = D - 0.09, face = new THREE.ShapeGeometry(rrShape(THREE, fw, fd, r - 0.045), 18), pos = face.attributes.position, uv = face.attributes.uv;
    for (var i = 0; i < pos.count; i++) uv.setXY(i, (pos.getX(i) + fw / 2) / fw, (pos.getY(i) + fd / 2) / fd);
    face.rotateX(-Math.PI / 2); face.translate(0, H + 0.002, 0);
    p.add(new THREE.Mesh(face, M.face));
    T3.shadow.scale.set(W * 1.55, D * 1.55, 1);
    T3.H = H; T3.R = Math.sqrt(W * W / 4 + D * D / 4 + H * H / 4); T3.sized = false;
  }
  function update3DTexture() {
    var d = tinDims(), tc = T3.tc, w = 1024, h = Math.round(w * d.h / d.w);
    if (tc.width !== w || tc.height !== h) { tc.width = w; tc.height = h; T3.tex.dispose(); }
    var g = tc.getContext('2d'); g.clearRect(0, 0, w, h); drawLid(g, w / d.w, tinImage(), 0);
    T3.tex.needsUpdate = true;
    /* the rounded edge of the lid takes the lid's edge colour */
    var col = tin.layout === 'photo' ? edgeColor(g, w, h) : tin.color;
    T3.mats.edge.color.set(col); T3.mats.edge.color.convertSRGBToLinear();
  }
  /* ---------- the cart's photo: the finished puzzle standing up, with its tin on the table in front ----------
     Drawn once when the design is saved, with the same tin model as the 3D preview, true to size. */
  var COMBO_BG = '#F3EEE6', COMBO_PX = 1600, COMBO_OUT = 1400;      /* big enough to zoom into from the cart */
  function comboTin(THREE, tex) {
    var S = tinSpec(), d = tinDims(), W = d.w, D = d.h, H = +S.depth || 2.5, r = +S.radius || 0.45, lidH = Math.min(0.55, H * 0.3);
    var fin = TIN_FINISH[S.finish] || TIN_FINISH.grey, grp = new THREE.Group();
    var lc = document.createElement('canvas'); lc.width = 1600; lc.height = Math.round(1600 * D / W);
    var lg = lc.getContext('2d'); drawLid(lg, lc.width / W, tinImage(), 0);
    var col = tin.layout === 'photo' ? edgeColor(lg, lc.width, lc.height) : tin.color;
    /* the cart pictures keep the metal soft and matte: no bright reflections */
    var body = new THREE.MeshStandardMaterial({ color: new THREE.Color(fin.body).convertSRGBToLinear(), roughness: Math.max(fin.br, 0.62), metalness: Math.min(fin.bm, 0.45), envMapIntensity: 0.6 });
    var rim = new THREE.MeshStandardMaterial({ color: new THREE.Color(fin.rim).convertSRGBToLinear(), roughness: Math.max(fin.rr, 0.55), metalness: Math.min(fin.rm, 0.55), envMapIntensity: 0.6 });
    var edge = new THREE.MeshStandardMaterial({ color: new THREE.Color(col).convertSRGBToLinear(), roughness: 0.8, metalness: 0, envMapIntensity: 0.3 });
    var face = new THREE.MeshBasicMaterial({ map: tex(lc), toneMapped: false });      /* the lid print as it really looks: no glare from the lights */
    [slab(THREE, W - 0.06, D - 0.06, r - 0.03, 0.07, 0, rim), slab(THREE, W - 0.1, D - 0.1, r - 0.05, H - lidH - 0.03, 0.06, body),
     slab(THREE, W + 0.03, D + 0.03, r + 0.015, 0.06, H - lidH - 0.02, rim), slab(THREE, W, D, r, lidH - 0.1, H - lidH + 0.03, body),
     slab(THREE, W, D, r, 0.12, H - 0.12, edge, 0.045)].forEach(function (m) { m.castShadow = true; m.receiveShadow = true; grp.add(m); });
    var fw = W - 0.09, fd = D - 0.09, fg = new THREE.ShapeGeometry(rrShape(THREE, fw, fd, r - 0.045), 18), pos = fg.attributes.position, uv = fg.attributes.uv;
    for (var i = 0; i < pos.count; i++) uv.setXY(i, (pos.getX(i) + fw / 2) / fw, (pos.getY(i) + fd / 2) / fd);
    fg.rotateX(-Math.PI / 2); fg.translate(0, H + 0.002, 0);
    var fm = new THREE.Mesh(fg, face); fm.receiveShadow = true; grp.add(fm);
    return grp;
  }
  function comboCanvas(pic) {      /* pic: the puzzle picture with its lines; resolves to a square canvas, or null when it can't be drawn */
    return loadThree().then(function (THREE) {
      var renderer;
      try { renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true }); } catch (e) { return null; }
      if (!renderer.getContext()) return null;
      var scene = new THREE.Scene();
      try {
        var d = dims(), A = aspect(), PL = d.inches ? d.long : 20, PS = d.inches ? d.short : 20 / Math.max(A, 1 / A);
        var PW = design.tall ? PS : PL, PH = design.tall ? PL : PS, T = 0.085, big = Math.max(PW, PH), k = big / 21.25;
        renderer.setPixelRatio(1); renderer.setSize(COMBO_PX, COMBO_PX, false);
        renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
        renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.VSMShadowMap;
        scene.background = new THREE.Color(COMBO_BG);
        var pm = new THREE.PMREMGenerator(renderer); scene.environment = pm.fromScene(roomEnv(THREE), 0.03).texture; pm.dispose();
        scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d0c4, 0.38));
        var key = new THREE.DirectionalLight(0xffffff, 0.75), sc = key.shadow.camera, ext = big * 0.95;
        key.position.set(-2.5 * k, 26 * k, 30 * k); key.castShadow = true;      /* from nearly straight ahead: shadows fall behind, not off to one side */
        key.shadow.mapSize.set(1024, 1024); key.shadow.radius = 8; key.shadow.blurSamples = 12; key.shadow.bias = -0.0004; key.shadow.normalBias = 0.02;
        sc.left = -ext; sc.right = ext; sc.top = ext; sc.bottom = -ext; sc.near = 1; sc.far = 120 * k;
        scene.add(key); scene.add(key.target);
        var fill = new THREE.DirectionalLight(0xffffff, 0.22); fill.position.set(14 * k, 6 * k, -10 * k); scene.add(fill);
        var floor = new THREE.Mesh(new THREE.PlaneGeometry(big * 20, big * 20), new THREE.ShadowMaterial({ opacity: 0.3, color: 0x2a2620 }));
        floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true; scene.add(floor);
        var tex = function (cv) { var t = new THREE.CanvasTexture(cv); t.encoding = THREE.sRGBEncoding; t.anisotropy = renderer.capabilities.getMaxAnisotropy(); return t; };
        /* the puzzle: a thin board with the picture on top, shown exactly as printed (unlit: no glare, no shading) */
        var side = new THREE.MeshStandardMaterial({ color: 0xd9d2c4, roughness: 0.95 });
        var top = new THREE.MeshBasicMaterial({ map: tex(pic), toneMapped: false });
        var board = new THREE.Mesh(new THREE.BoxGeometry(PW, T, PH), [side, side, top, new THREE.MeshStandardMaterial({ color: 0x8a8378, roughness: 1 }), side, side]);
        board.castShadow = true; board.receiveShadow = true;
        /* stand it on its bottom edge, leaning back a little, with the picture facing the camera */
        var stand = new THREE.Group(); board.position.set(0, T / 2, -PH / 2); stand.add(board);
        stand.rotation.x = Math.PI / 2 - 0.2; stand.position.set(design.tall ? 0 : -PW * 0.06, 0, -0.1 * big); scene.add(stand);
        var box3 = tiltedTin(THREE, tex);      /* a portrait puzzle is narrow: its tin sits straight in front, in the middle */
        box3.position.set(design.tall ? 0 : PW * 0.2, 0, tinDims().h * 1.25); box3.rotation.y = design.tall ? -0.14 : -0.26; scene.add(box3);
        /* the camera looks at them from the front, a little above; it backs off until the puzzle and tin both fit */
        scene.updateMatrixWorld(true);
        var bb = new THREE.Box3().setFromObject(stand).union(new THREE.Box3().setFromObject(box3)), ctr = bb.getCenter(new THREE.Vector3());
        var cam = new THREE.PerspectiveCamera(24, 1, 0.5, 600 * k), dir = new THREE.Vector3(0.08, 0.36, 1).normalize(), pts = [], v, lo = big * 0.5, hi = big * 12;
        for (var i = 0; i < 8; i++) pts.push(new THREE.Vector3(i & 1 ? bb.max.x : bb.min.x, i & 2 ? bb.max.y : bb.min.y, i & 4 ? bb.max.z : bb.min.z));
        for (var n = 0; n < 30; n++) {
          var mid = (lo + hi) / 2, fits = true;
          cam.position.copy(ctr).addScaledVector(dir, mid); cam.lookAt(ctr); cam.updateMatrixWorld(true);
          for (var j = 0; j < 8 && fits; j++) { v = pts[j].clone().project(cam); if (Math.abs(v.x) > 0.9 || Math.abs(v.y) > 0.9) fits = false; }
          if (fits) hi = mid; else lo = mid;
        }
        cam.position.copy(ctr).addScaledVector(dir, hi); cam.lookAt(ctr);
        key.target.position.copy(ctr);
        renderer.render(scene, cam);
        /* where the puzzle and tin are on the picture (their shadow does not count), for centring the crop */
        var box = { x0: COMBO_PX, y0: COMBO_PX, x1: 0, y1: 0 };
        [stand, box3].forEach(function (o) {
          o.traverse(function (m) {
            if (!m.isMesh) return;
            var gp = m.geometry.attributes.position, w = new THREE.Vector3();
            for (var q = 0; q < gp.count; q += Math.max(1, Math.floor(gp.count / 400))) {
              w.fromBufferAttribute(gp, q).applyMatrix4(m.matrixWorld).project(cam);
              var sx = (w.x + 1) / 2 * COMBO_PX, sy = (1 - w.y) / 2 * COMBO_PX;
              box.x0 = Math.min(box.x0, sx); box.x1 = Math.max(box.x1, sx); box.y0 = Math.min(box.y0, sy); box.y1 = Math.max(box.y1, sy);
            }
          });
        });
        return comboCrop(renderer.domElement, box.x1 > box.x0 ? box : null);
      } finally {
        scene.traverse(function (o) {
          if (o.geometry) o.geometry.dispose();
          [].concat(o.material || []).forEach(function (m) { if (m.map) m.map.dispose(); m.dispose(); });
        });
        if (scene.environment) scene.environment.dispose();
        renderer.dispose(); if (renderer.forceContextLoss) renderer.forceContextLoss();
      }
    });
  }
  /* the tin leaning forward on its front edge, so the lid faces the camera */
  var TIN_TILT = 0.34;
  function tiltedTin(THREE, tex) {
    var tin3 = comboTin(THREE, tex), lean = new THREE.Group(), outer = new THREE.Group();
    tin3.position.z = -tinDims().h / 2; lean.add(tin3); lean.rotation.x = TIN_TILT; outer.add(lean);
    return outer;
  }
  /* one object by itself on the table, lit softly, framed square (for the cart's "Puzzle" and "Tin" views) */
  function studioShot(build, dir) {
    return loadThree().then(function (THREE) {
      var renderer;
      try { renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true }); } catch (e) { return null; }
      if (!renderer.getContext()) return null;
      var scene = new THREE.Scene();
      try {
        renderer.setPixelRatio(1); renderer.setSize(COMBO_PX, COMBO_PX, false);
        renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
        renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.VSMShadowMap;
        scene.background = new THREE.Color(COMBO_BG);
        var pm = new THREE.PMREMGenerator(renderer); scene.environment = pm.fromScene(roomEnv(THREE), 0.03).texture; pm.dispose();
        var tex = function (cv) { var t = new THREE.CanvasTexture(cv); t.encoding = THREE.sRGBEncoding; t.anisotropy = renderer.capabilities.getMaxAnisotropy(); return t; };
        var obj = build(THREE, tex); scene.add(obj); scene.updateMatrixWorld(true);
        var bb = new THREE.Box3().setFromObject(obj), ctr = bb.getCenter(new THREE.Vector3()), sz = bb.getSize(new THREE.Vector3()), big = Math.max(sz.x, sz.y, sz.z, 2);
        scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d0c4, 0.45));
        var key = new THREE.DirectionalLight(0xffffff, 0.7), sc = key.shadow.camera, ext = big * 1.4;
        key.position.set(ctr.x - 0.3 * big, 2.6 * big, ctr.z + 2.4 * big); key.castShadow = true;
        key.shadow.mapSize.set(1024, 1024); key.shadow.radius = 8; key.shadow.blurSamples = 12; key.shadow.bias = -0.0004; key.shadow.normalBias = 0.02;
        sc.left = -ext; sc.right = ext; sc.top = ext; sc.bottom = -ext; sc.near = 0.1; sc.far = big * 10;
        scene.add(key); key.target.position.copy(ctr); scene.add(key.target);
        var fill = new THREE.DirectionalLight(0xffffff, 0.3); fill.position.set(ctr.x + 2 * big, 1.2 * big, ctr.z + 1.5 * big); scene.add(fill);
        var floor = new THREE.Mesh(new THREE.PlaneGeometry(big * 20, big * 20), new THREE.ShadowMaterial({ opacity: 0.22, color: 0x2a2620 }));
        floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true; scene.add(floor);
        var cam = new THREE.PerspectiveCamera(24, 1, 0.05, big * 60), pts = [], v, lo = big * 0.3, hi = big * 20;
        dir = new THREE.Vector3(dir[0], dir[1], dir[2]).normalize();
        for (var i = 0; i < 8; i++) pts.push(new THREE.Vector3(i & 1 ? bb.max.x : bb.min.x, i & 2 ? bb.max.y : bb.min.y, i & 4 ? bb.max.z : bb.min.z));
        for (var n = 0; n < 30; n++) {
          var mid = (lo + hi) / 2, fits = true;
          cam.position.copy(ctr).addScaledVector(dir, mid); cam.lookAt(ctr); cam.updateMatrixWorld(true);
          for (var j = 0; j < 8 && fits; j++) { v = pts[j].clone().project(cam); if (Math.abs(v.x) > 0.9 || Math.abs(v.y) > 0.9) fits = false; }
          if (fits) hi = mid; else lo = mid;
        }
        cam.position.copy(ctr).addScaledVector(dir, hi); cam.lookAt(ctr);
        renderer.render(scene, cam);
        var box = { x0: COMBO_PX, y0: COMBO_PX, x1: 0, y1: 0 };
        obj.traverse(function (m) {
          if (!m.isMesh) return;
          var gp = m.geometry.attributes.position, w = new THREE.Vector3();
          for (var q = 0; q < gp.count; q += Math.max(1, Math.floor(gp.count / 400))) {
            w.fromBufferAttribute(gp, q).applyMatrix4(m.matrixWorld).project(cam);
            var sx = (w.x + 1) / 2 * COMBO_PX, sy = (1 - w.y) / 2 * COMBO_PX;
            box.x0 = Math.min(box.x0, sx); box.x1 = Math.max(box.x1, sx); box.y0 = Math.min(box.y0, sy); box.y1 = Math.max(box.y1, sy);
          }
        });
        return comboCrop(renderer.domElement, box.x1 > box.x0 ? box : null);
      } finally {
        scene.traverse(function (o) {
          if (o.geometry) o.geometry.dispose();
          [].concat(o.material || []).forEach(function (m) { if (m.map) m.map.dispose(); m.dispose(); });
        });
        if (scene.environment) scene.environment.dispose();
        renderer.dispose(); if (renderer.forceContextLoss) renderer.forceContextLoss();
      }
    });
  }
  function tinCanvas() {      /* the whole tin, leaning toward the camera, so the lid and its sides both show */
    return studioShot(function (THREE, tex) { var t = tiltedTin(THREE, tex); t.rotation.y = -0.4; return t; }, [0.05, 0.7, 1]);
  }
  function puzzleCanvas(pic) {      /* the finished puzzle by itself, standing and leaning back a little, picture unlit (no glare) */
    return studioShot(function (THREE, tex) {
      var d = dims(), A = aspect(), PL = d.inches ? d.long : 20, PS = d.inches ? d.short : 20 / Math.max(A, 1 / A);
      var PW = design.tall ? PS : PL, PH = design.tall ? PL : PS, T = 0.085;
      var side = new THREE.MeshStandardMaterial({ color: 0xd9d2c4, roughness: 0.95 });
      var top = new THREE.MeshBasicMaterial({ map: tex(pic), toneMapped: false });
      var board = new THREE.Mesh(new THREE.BoxGeometry(PW, T, PH), [side, side, top, new THREE.MeshStandardMaterial({ color: 0x8a8378, roughness: 1 }), side, side]);
      board.castShadow = true; board.receiveShadow = true;
      var stand = new THREE.Group(); board.position.set(0, T / 2, -PH / 2); stand.add(board);
      stand.rotation.x = Math.PI / 2 - 0.2;
      var outer = new THREE.Group(); outer.add(stand); outer.rotation.y = -0.16;
      return outer;
    }, [0.1, 0.3, 1]);
  }
  function comboCrop(src, box) {      /* square it up around the puzzle and tin (box: where they are), trimming the empty table */
    var N = src.width, c = document.createElement('canvas'); c.width = c.height = N;
    var g = c.getContext('2d'); g.drawImage(src, 0, 0);
    var px = box ? null : g.getImageData(0, 0, N, N).data, bg = [0xF3, 0xEE, 0xE6], x0 = N, y0 = N, x1 = -1, y1 = -1;
    if (box) { x0 = box.x0; y0 = box.y0; x1 = box.x1; y1 = box.y1; }
    else for (var y = 0; y < N; y += 2) for (var x = 0; x < N; x += 2) {
      var i = (y * N + x) * 4;
      if (Math.abs(px[i] - bg[0]) + Math.abs(px[i + 1] - bg[1]) + Math.abs(px[i + 2] - bg[2]) > 10) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    var side = Math.max(x1 - x0, y1 - y0) * 1.14, cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
    var o = document.createElement('canvas'); o.width = o.height = COMBO_OUT;
    var og = o.getContext('2d'); og.fillStyle = COMBO_BG; og.fillRect(0, 0, COMBO_OUT, COMBO_OUT); og.imageSmoothingQuality = 'high';
    /* only the part of the square that lies on the render is copied (some browsers draw nothing for a source outside the image) */
    var f = COMBO_OUT / side, sx = cx - side / 2, sy = cy - side / 2, ax = Math.max(0, sx), ay = Math.max(0, sy), bx = Math.min(N, sx + side), by = Math.min(N, sy + side);
    og.drawImage(c, ax, ay, bx - ax, by - ay, (ax - sx) * f, (ay - sy) * f, (bx - ax) * f, (by - ay) * f);
    return o;
  }
  function edgeColor(g, w, h) {
    var px = g.getImageData(0, 0, w, h).data, r = 0, gg = 0, b = 0, n = 0, add = function (x, y) { var i = (y * w + x) * 4; r += px[i]; gg += px[i + 1]; b += px[i + 2]; n++; };
    for (var x = 0; x < w; x += 8) { add(x, 2); add(x, h - 3); }
    for (var y = 0; y < h; y += 8) { add(2, y); add(w - 3, y); }
    var hex = function (v) { return ('0' + Math.round(v / n).toString(16)).slice(-2); };
    return '#' + hex(r) + hex(gg) + hex(b);
  }
  function size3D() {
    var bw = T3.box.clientWidth, bh = T3.box.clientHeight; if (!bw || !bh) return false;
    T3.renderer.setSize(bw, bh, false);
    var cam = T3.camera, vf = cam.fov * Math.PI / 180, hf = 2 * Math.atan(Math.tan(vf / 2) * bw / bh);
    cam.aspect = bw / bh; cam.updateProjectionMatrix();
    T3.dist = (T3.R || 5.5) / Math.sin(Math.min(vf, hf) / 2) * 0.94;
    T3.sized = true; return true;
  }
  function run3D() {
    if (!T3 || !T3.ready || T3.running) return;
    T3.running = true;
    (function frame() {
      if (!T3.running || step !== 2 || !modal || modal.hidden || (isPhone() && !is3D())) { T3.running = false; return; }
      if (T3.dirty) { build3D(); update3DTexture(); T3.dirty = false; }
      if (!T3.sized && !size3D()) { requestAnimationFrame(frame); return; }
      var now = (window.performance || Date).now();
      if (T3.auto) T3.yaw = -0.5 + Math.sin((now - T3.t0) / 2600) * 0.45;
      T3.pivot.rotation.y = T3.yaw;
      var cam = T3.camera, H = T3.H || 2.5;
      cam.position.set(0, H * 0.45 + T3.dist * Math.sin(T3.pitch), T3.dist * Math.cos(T3.pitch));
      cam.lookAt(0, H * 0.42, 0);
      T3.renderer.render(T3.scene, cam);
      requestAnimationFrame(frame);
    })();
  }
  function bind3DPointer(el) {
    if (!el) return;
    var drag = null;
    el.addEventListener('pointerdown', function (e) {
      if (!T3 || !T3.ready) return;
      drag = { x: e.clientX, y: e.clientY, yaw: T3.yaw, pitch: T3.pitch, id: e.pointerId };
      T3.auto = false; try { el.setPointerCapture(e.pointerId); } catch (err) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      T3.yaw = drag.yaw + (e.clientX - drag.x) * 0.012;
      T3.pitch = clamp(drag.pitch + (e.clientY - drag.y) * 0.008, 0.3, 1.25);      /* never so low that the lid disappears */
    });
    /* on phones a drag on the 3D tin turns it instead of scrolling the page (touch-action:none does this too; this covers older browsers) */
    el.addEventListener('touchmove', function (e) { if (drag && e.cancelable) e.preventDefault(); }, { passive: false });
    function end() { if (drag && !T3.turned) { T3.turned = true; ga('tin_3d_turned'); } drag = null; }
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
  }

  /* ---------- quick mode: "Choose your size" window and the page's way in (window.PixDesigner.open) ---------- */
  /* "Choose your size" shows the puzzle as it will look at each size when there is something to show:
     a theme design (opened from a design card on a theme page) or the customer's own photos.
     Otherwise each size shows its product picture. */
  function sizePreview() { return !!(tplFirst || (design.layout && design.layout.tpl) || design.slots.some(function (s) { return s.photo; })); }
  function sizeAspect(p) { var a = +p.long || 4, b = +p.short || 3; return design.tall ? b / a : a / b; }
  function sizeThumbs() {
    if (!sizesEl || !sizesOn) return;
    [].slice.call(sizesEl.querySelectorAll('canvas[data-sz]')).forEach(function (cv) {
      var p = prodBy(cv.getAttribute('data-sz')); if (p) thumbPaint(cv, design.layout, design.tall, sizeAspect(p), 180, 132, 0.86, true);
    });
  }
  var SIZE_PRICES = false;      /* "Choose your size" shows no prices (true brings them back) */
  function renderSizes() {
    var prev = sizePreview();
    var h = '<div class="pixup-pickbox"><div class="pixup-pickhead">' +
      (sizesMust && tplFirst ? '<button type="button" class="pixup-pickback" data-act="sizeback" aria-label="Back to Choose your template"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>Templates</button>' : '') +
      '<b>Choose your size</b><button type="button" class="pixup-x" data-act="sizeclose" aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' + '</button></div>' +
      '<p class="pixup-sizelead">Every size works with all of our designs, and you can change it later.</p><div class="pixup-grid pixup-sizegrid">';
    PRODUCTS.forEach(function (p) {
      var on = p === curProd && !sizesMust;
      h += '<button type="button" class="pixup-dcard pixup-scard" data-size="' + esc(p.handle) + '" aria-pressed="' + on + '">' +
        (p.badge ? '<span class="pixup-sbadge">' + esc(p.badge) + '</span>' : '') +
        '<span class="pixup-simg">' + (prev ? '<canvas data-sz="' + esc(p.handle) + '" role="img" aria-label="Your design on the ' + esc(p.title) + '"></canvas>' : p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<b>' + esc(p.title) + '</b>' +
        (p.sizeText ? '<small>Finished size ' + esc(p.sizeText) + '</small>' : '') +
        (SIZE_PRICES && p.price ? '<span class="pixup-sprice"><strong>' + esc(p.price) + '</strong>' + (p.compare ? ' <s>' + esc(p.compare) + '</s>' : '') + '</span>' : '') +
        '<span class="pixup-scta">' + (on ? 'Selected' : 'Choose') + '</span></button>';
    });
    sizesEl.innerHTML = h + '</div></div>';
  }
  function openSizes(must) {
    if (!sizesEl) return;
    sizesMust = !!must; sizesOn = true; popOn = false; cropMode = false;
    if (pickOn) closePicker();
    renderSizes(); sizesEl.hidden = false; draw();
    if (sizePreview()) { loadPlaceholders(); sizeThumbs(); }
    var b = sizesEl.querySelector('[data-act="sizeclose"]'); if (b) b.focus({ preventScroll: true });
    ga('size_window_opened', { source: must ? 'start' : 'change_size' });
  }
  function closeSizes() { if (!sizesOn) return; sizesOn = false; sizesEl.hidden = true; renderSide(); }
  function sizesBack() { if (sizesMust) askClose(); else closeSizes(); }      /* nothing chosen yet: leave the designer */
  function chooseSize(handle) {
    var p = prodBy(handle); if (!p) return;
    var first = sizesMust; tplFirst = false;
    if (p !== curProd) {
      useProduct(p);
      if (!hasBoth) design.tall = !!(CFG.variants[0] && CFG.variants[0].tall);
      fitOrient(); resetSlots(); syncVariant();
    }
    sizesMust = false; closeSizes(); refresh();
    ga('size_chosen', { size: p.handle });
    /* opened from "Start your puzzle": the design comes next, then the designer with the photo upload */
    if (first && askDesign && (DESIGNS.length || LAYOUTS.length > 1)) {
      askDesign = false; pickStart = true;
      openPicker(slotCount(design.layout) > 1 ? 'multi' : 'one', 'start_flow');
    }
  }
  function quickOpen(o) {
    o = o || {};
    if (busy) return;
    var p = o.handle ? prodBy(o.handle) : null;
    if (p && p !== curProd) { useProduct(p); fitOrient(); }
    if (o.entry) entry = o.entry;
    var want = o.design ? layoutById('d:' + slug(o.design)) : null;      /* a design card on a theme page */
    askDesign = false; pickStart = false; askSize = false; tplFirst = false;      /* "Start your puzzle": template, then size (when none chosen yet), then photos */
    openDesigner();
    if (want && (geoFor(want, design.tall) || hasBoth)) {
      if (!geoFor(want, design.tall)) { design.tall = !design.tall; orientTouched = true; }
      setLayout(want); syncVariant(); refresh();
    }
    if (!want) { if (sizesOn) closeSizes(); askSize = !p; openStartPicker('start_flow'); }
    else if (!p) openSizes(true);
    else if (sizesOn) closeSizes();
    ga('designer_opened', { entry_point: entry || 'quick', size: curProd ? curProd.handle : '', design: want ? want.key : '' });
    if (want) ga('design_chosen', { design: want.key, source: entry || 'quick' });
  }
  if (QUICK) {
    var queued = (window.PixDesigner && window.PixDesigner.q) || [];
    window.PixDesigner = { ready: true, open: quickOpen };
    queued.forEach(function (o) { quickOpen(o); });
  }

  /* ---------- "Edit design" from the cart ----------
     Each saved design is remembered in this browser (localStorage) under the id in its _Pix Edit property.
     The cart's "Edit design" link opens the product page with ?pix_edit=<id>: the designer reopens with the
     same photos (loaded back from the upload service), crops, text and tin, and "Update cart" swaps the
     cart line for the new design. On another device only the photos can come back (from the cart line). */
  var EDIT_STORE = 'pixup-designs', EDIT_KEEP = 25;
  function editId() { return 'e' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function editAll() { try { var o = JSON.parse(localStorage.getItem(EDIT_STORE) || '{}'); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; } }
  function editPut(all) { try { localStorage.setItem(EDIT_STORE, JSON.stringify(all)); return true; } catch (e) { return false; } }
  function editSave(id, st) {
    if (!id || !st) return;
    var all = editAll(); all[id] = st;
    Object.keys(all).sort(function (a, b) { return (all[b].ts || 0) - (all[a].ts || 0); }).slice(EDIT_KEEP).forEach(function (k) { delete all[k]; });
    if (!editPut(all)) { var one = {}; one[id] = st; editPut(one); }      /* storage full: keep just this one */
  }
  function editLoad(id) { var st = editAll()[id]; return st && st.v === 1 && Array.isArray(st.photos) && Array.isArray(st.slots) ? st : null; }
  function editDrop(id) { var all = editAll(); if (all[id]) { delete all[id]; editPut(all); } }
  function editState(list, urls) {
    return {
      v: 1, ts: Date.now(), group: group, tall: !!design.tall, layout: design.layout.id, lines: design.lines !== false,
      photos: list.map(function (P, i) { return { url: urls[i] || '', name: P.name || '', rot: P.rot || 0, enhance: !!P.enhance }; }),
      slots: design.slots.map(function (s) { var P = s.photo; return { p: list.indexOf(P), z: s.z, ox: P ? s.ox / P.work.width : 0, oy: P ? s.oy / P.work.height : 0, bg: s.bg || '' }; }),
      texts: design.texts.map(function (t) { var o = {}; for (var k in t) o[k] = t[k]; return o; }),
      tin: TIN ? { layout: tin.layout, color: tin.color, title: tin.title, badge: { x: tin.badge.x, y: tin.badge.y } } : null
    };
  }
  function photoFromUrl(p) {      /* a saved photo, loaded back from the upload service (it allows any site to read its files) */
    return new Promise(function (res, rej) {
      if (!p || !p.url) return rej(new Error('missing'));
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        var P = photoOf(img);
        if (!P) return rej(new Error('empty'));
        P.name = p.name || ''; P.rot = +p.rot || 0; P.enhance = !!p.enhance; P.originalP = Promise.resolve(p.url);
        photos.push(P); res(P);
      };
      img.onerror = function () { rej(new Error('load')); };
      img.src = p.url;
    });
  }
  function restoreDesign(st, urls) {
    var list = st ? st.photos : urls.map(function (u) { return { url: u }; }), done = 0, label = 'Opening your design…';
    setBusy(true, 0.05, label);
    return Promise.all(list.map(function (p) {
      return photoFromUrl(p).catch(function (e) { log('photo not reopened:', p && p.url, e.message); return null; })
        .then(function (P) { setBusy(true, 0.05 + 0.9 * (++done / Math.max(1, list.length)), label); return P; });
    })).then(function (Ps) {
      var ok = Ps.filter(Boolean), L = st ? layoutById(st.layout) : null;
      if (st && L && slotCount(L) === st.slots.length) {
        design.tall = !!st.tall; design.layout = L; design.lines = st.lines !== false; orientTouched = true;
        design.slots = st.slots.map(function (s) {
          var P = Ps[s.p] || null;
          return { photo: P, z: P ? +s.z || 1 : 1, ox: P ? (+s.ox || 0) * P.work.width : 0, oy: P ? (+s.oy || 0) * P.work.height : 0, bg: s.bg || undefined };
        });
        design.texts = (st.texts || []).map(function (t) { var o = {}; for (var k in t) o[k] = t[k]; return o; });
      } else {      /* only the photos are known (or that design is no longer offered): start them in a plain layout */
        if (st) { design.tall = !!st.tall; orientTouched = true; }
        design.slots = [{ photo: null, z: 1, ox: 0, oy: 0 }]; design.layout = LAYOUTS[0]; design.texts = [];
        setLayout(ok.length > 1 ? firstLayout(Math.min(ok.length, MAX_PHOTOS)) : LAYOUTS[0], ok);
      }
      if (st && st.group) group = st.group;      /* the new files go in the same folder as the photos */
      ok.forEach(function (P) { if (P.enhance) ensureEnhanced(P); });
      if (TIN && st && st.tin) {
        var b = st.tin.badge || {};
        tin = { layout: st.tin.layout || tin.layout, color: st.tin.color || tin.color, title: String(st.tin.title || ''), badge: { x: +b.x || 0, y: +b.y || 0 } };
      }
      tinDirty = true; sel = { type: 'slot', i: 0 }; cropMode = false; popOn = false;
      setBusy(false); refresh(); requestAnimationFrame(draw);
      openSig = designSig();      /* reopened from the cart: changes count from here */
      if (ok.length < list.length) say(ok.length ? 'One or more of your photos could not be reopened. Please add them again.' : 'Your photos could not be reopened. Please upload them again.', true);
      return ok.length;
    });
  }
  function cartRoot() { var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root; return typeof r === 'string' && r ? r : '/'; }
  function replaceCartLine() {      /* add the new design (same quantity), take the old line out, then show the cart */
    var E = EDIT;
    setBusy(true, 1, 'Updating your cart…');
    setCartPreview();
    var fd = new FormData(form);
    fd.set('quantity', String(E.qty || 1));
    fetch(cartRoot() + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); })
      .then(function () {      /* the numbered back follows the new design */
        if (backOn && backOk()) return addBackLine(E.qty || 1, saved.edit).catch(function (e) { log('numbered back not added:', e && e.message); });
      })
      .then(function () {
        return dropLine(E.key, 'old cart line');
      })
      .then(function () {
        if (E.backKey) return dropLine(E.backKey, 'old numbered back');
      })
      .then(function () {
        editDrop(E.id); EDIT = null;
        location.href = cartRoot() + 'cart';
      })
      .catch(function (e) {
        log('cart not updated:', e && e.message);
        setBusy(false);
        say('We could not update your cart. Please check your connection and try again.', true);
      });
  }
  function dropLine(key, what) {
    return fetch(cartRoot() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function (r) { if (!r.ok) log(what + ' not removed: HTTP', r.status); }, function (e) { log(what + ' not removed:', e && e.message); });
  }
  (function () {
    var id = urlQ.get('pix_edit');
    if (!id || !/^[a-z0-9]{4,40}$/i.test(id)) return;
    var q = new URLSearchParams(location.search); q.delete('pix_edit');
    try { history.replaceState(history.state, '', location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash); } catch (e) {}
    var st = editLoad(id);
    var shown = false;
    autoPick = false; entry = 'cart_edit';
    setTimeout(function () { if (!shown) { shown = true; openDesigner(); setBusy(true, 0.03, 'Opening your design…'); } }, 0);
    fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (cart) {
        if (!shown) { shown = true; openDesigner(); }
        var line = null, urls = [];
        ((cart && cart.items) || []).forEach(function (it) { if (!line && it.properties && it.properties['_Pix Edit'] === id) line = it; });
        if (line) {
          EDIT = { id: id, key: line.key, qty: line.quantity || 1 };
          if (BACK) ((cart && cart.items) || []).forEach(function (it) {
            if (!EDIT.backKey && String(it.variant_id) === String(BACK.variant) && it.properties && it.properties['_Pix For'] === id) { EDIT.backKey = it.key; backOn = true; }
          });
          backShow();
          var add = modal && modal.querySelector('.pixup-foot .pixup-add');
          if (add && (!TIN || step === 2)) add.innerHTML = addHtml();
          if (!st) Object.keys(line.properties).filter(function (k) { return /^_Original photo/.test(k) && line.properties[k]; })
            .sort(function (a, b) { return (parseInt(a.replace(/\D+/g, ''), 10) || 0) - (parseInt(b.replace(/\D+/g, ''), 10) || 0); })
            .forEach(function (k) { urls.push(line.properties[k]); });
        }
        ga('designer_cart_edit_opened', { restored: st ? 'full' : urls.length ? 'photos' : 'none', in_cart: line ? 'yes' : 'no' });
        if (!st && !urls.length) {
          setBusy(false);
          say('We could not reopen that design here. Please upload your photo to design it again.', true);
          return;
        }
        return restoreDesign(st, urls).then(function (n) {
          if (!st && n) toast('Your photos are back. The rest of the design could not be reopened on this device, so please check it before updating your cart.');
        });
      });
  })();

  log('ready');
})();